<template>
    <div>
        <!-- 编辑、添加界面 -->
        <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="1100px" :destroy-on-close="true"
            :before-close="cancel">
            <div class="el-dialog-div">
                <el-form class="formDiv" label-width="125px" ref="formContract" :model="formContract"
                    :rules="rulesContract">
                    <el-form-item label="合同编号" prop="contractNumber">
                        <div style="display:flex;align-items: center">
                            <el-input style="width: 87%;" v-model="formContract.contractNumber" auto-complete="off"
                                disabled :readonly=true placeholder="请获取合同编号">
                            </el-input>
                            <el-tooltip content="复制">
                                <a-icon type="copy" style="color: #3f9dfe"
                                    @click="copyData(formContract.contractNumber)" />
                            </el-tooltip>
                        </div>
                    </el-form-item>
                    <el-form-item label="有效期限" prop="expirationDate">
                        <el-select style="width: 87%;" disabled v-model="formContract.expirationDate"
                            placeholder="请选择有效期限" filterable>
                            <el-option v-for="item in DateOptions" :key="item.label" :label="item.name"
                                :value="item.label"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="合同名称" prop="contractName" style="width: 48%!important;">
                        <template #label>
                            <div style="position: relative; display: inline-block;margin-right: 10px;">
                                <span>合同名称</span>
                                <el-popover placement="top" width="200" trigger="click"
                                    content="不支持使用<  >  :  &quot;  /  \  |  ?  *  +；仅支持数字/汉字/英文/( - _ )等">
                                    <sup slot="reference"
                                        style="position: absolute; top: 10px; right: -15px; cursor: pointer;">
                                        <i class="el-icon-info" style="color: #409EFF; font-size: 14px;"></i>
                                    </sup>
                                </el-popover>
                            </div>
                        </template>
                        <div style="display:flex;align-items: center">
                            <el-input style="width: 87%;margin-right: 10px;" v-model="formContract.contractName" auto-complete="off"
                                placeholder="请输入合同名称"></el-input>
                            <el-button type="primary" size="mini"
                                @click="createName">生成</el-button>
                        </div>
                    </el-form-item>
                    <el-form-item label="合同金额" prop="contractAmount" style="width: 50%!important;">
                        <div style="display:flex;align-items: center">
                            <el-input style="width: 87%;margin-right: 10px;" v-model="formContract.contractAmount" auto-complete="off"
                                :disabled="formContract.contractType === 'DEVELOPMENT' || ['salesManagerEdits'].includes(operation)"
                                placeholder="请输入合同金额"></el-input>
                            <el-button type="success" size="mini"
                                :disabled="formContract.contractType === 'DEVELOPMENT' || ['salesManagerEdits'].includes(operation)"
                                @click="addAllAmount">累加</el-button>
                        </div>
                    </el-form-item>
                    <div style="width: 100%;margin-left: 45px;font-size: 14px;color: red;margin-bottom: 10px;">
                        {{'注：合同名称不支持使用<> : " / \\ | ? * + 字符，仅支持数字/汉字/英文/( - _ )等' }}
                    </div>
                    <el-form-item label="合同拟定时间" prop="contractDraftingDate">
                        <el-input style="width: 87%;" v-model="formContract.contractDraftingDate"
                            :disabled="['salesManagerEdits', 'adminEdits'].includes(operation)" auto-complete="off"
                            placeholder="请输入日期，格式yyyy-MM-dd"></el-input>
                    </el-form-item>
                    <el-form-item label="销售" prop="salesId">
                        <el-select style="width: 87%;" v-model="formContract.salesId" placeholder="请选择" filterable>
                            <el-option v-for="item in DrafterOptions" :key="item.uuid" :label="item.name"
                                :value="item.uuid"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="甲方项目联系人" prop="customerContactsId"
                        v-if="formContract.contractType !== 'DEVELOPMENT'">
                        <el-select style="width: 87%;" v-model="formContract.customerContactsId"
                            @change="getRemainingAmount(formContract.customerContactsId, applyContractId, successContractId)"
                            placeholder="请先选择甲方项目联系人" filterable :disabled="['salesManagerEdits'].includes(operation)">
                            <el-option v-for="item in UserOptions" :key="item.id"
                                :label="item.contactName + '-' + item.companyName" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="乙方(受托方)" prop="trusteeCompanyId">
                        <el-select style="width: 87%;" v-model="formContract.trusteeCompanyId" placeholder="请选择"
                            filterable :disabled="['salesManagerEdits','adminEdits'].includes(operation)"
                            @change="changeTrusteeCompany">
                            <el-option v-for="item in businessOption" :key="item.id" :label="item.companyName"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="乙方项目联系人" prop="trusteeContactsId"
                        v-if="formContract.contractType !== 'DEVELOPMENT'">
                        <el-select style="width: 87%;" v-model="formContract.trusteeContactsId" placeholder="请选择"
                            filterable :disabled="['salesManagerEdits'].includes(operation)">
                            <el-option v-for="item in DrafterOptions" :key="item.uuid" :label="item.name"
                                :value="item.uuid"></el-option>
                        </el-select>
                    </el-form-item>


                    <el-form-item label="合同分类" prop="contractType">
                        <el-select style="width: 87%;" v-model="formContract.contractType"
                            :disabled="['salesManagerEdits'].includes(operation) || (['edit', 'change', 'adminEdits', 'submit'].includes(operation) && selectDetail?.contractType === 'TEAM')" placeholder="请选择合同分类" filterable
                            @change="changeContractType(formContract.contractType)">
                            <el-option v-for="item in TypeOptions" :key="item.label" :label="item.name" v-if="(!['IMPORT_PREPAYMENTS'].includes(item.label) || selectDetail?.contractType === 'IMPORT_PREPAYMENTS') && (!['TEAM'].includes(item.label) || !['edit', 'change', 'adminEdits', 'submit'].includes(operation) || selectDetail?.contractType === 'TEAM')"
                                :value="item.label"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="合同类型" prop="projectType">
                        <el-select style="width: 87%;" v-model="formContract.projectType" placeholder="请选择合同类型"
                            filterable @change="changeProjectType"
                            :disabled="['salesManagerEdits'].includes(operation)">
                            <el-option
                                v-for="item in DirectionOptions.filter(item => (operation === 'adminEdits' && !targetList.includes(item.label)) || operation !== 'adminEdits' && item.label !== '微生态保护液')"
                                :key="item.label" :label="item.label" :value="item.label"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="签订地点" prop="signingPlace">
                        <el-input placeholder="请输入签订地点" style="width: 87%;"
                            :disabled="['salesManagerEdits', 'adminEdits'].includes(operation)"
                            v-model="formContract.signingPlace">
                        </el-input>
                    </el-form-item>
                   <div style="width: 100%;margin-left: 45px;font-size: 14px;color: red;margin-bottom: 10px;">
                        {{ '注：重新释放数据的录纯分析' }}
                    </div>
                    <div v-if="projectTypeData.includes(formContract.projectType) && formContract.contractType !== 'DEVELOPMENT'"
                        style="width: 100%">
                        <div style="display:flex;width: 100%">
                            <el-form-item label="是否返样" prop="returnFlag">
                                <el-select style="width: 87%;" v-model="formContract.returnFlag" placeholder="请选择是否返样"
                                    filterable :disabled="['salesManagerEdits'].includes(operation)">
                                    <el-option v-for="item in flagOption" :key="item.value" :label="item.label"
                                        :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="服务费(返样)" prop="sampleAmount" v-if="formContract.returnFlag === true">
                                <el-input style="width: 87%;" v-model="formContract.sampleAmount"
                                    :disabled="['salesManagerEdits'].includes(operation)"
                                    auto-complete="off"></el-input>
                            </el-form-item>
                        </div>
                        <el-form-item label="金额为0原因" prop="reason" v-if="Number(formContract.sampleAmount) === 0 && formContract.returnFlag === true
                            && formContract.sampleAmount !== ''" style="width: 92%!important;">
                            <el-input :autosize="{ minRows: 3 }" type="textarea" placeholder="请填写服务费(返样)为0的原因"
                                v-model="formContract.reason" :disabled="['salesManagerEdits'].includes(operation)"
                                maxlength="300" show-word-limit>
                            </el-input>
                        </el-form-item>
                    </div>
                    <el-form-item v-if="formContract.contractType === 'CHARGEBACKS'" label="甲方可扣款金额"
                        prop="remainingAmount">
                        <el-input style="width: 87%;" disabled v-model="formContract.remainingAmount"></el-input>
                    </el-form-item>

                    <div style="width: 100%;display: flex;flex-wrap: wrap;"
                        v-if="formContract.contractType === 'PREPAYMENTS'">
                        <el-form-item label="是否增值" prop="addedType">
                            <el-cascader :disabled="['salesManagerEdits'].includes(operation)" placeholder="请选择是否增值"
                                style="width: 87%;" v-model="formContract.addedType" :options="addedTypeOptions"
                                :props="{ expandTrigger: 'hover', emitPath: false }"></el-cascader>
                        </el-form-item>
                        <el-form-item v-if="formContract.addedType === 'number'" label="增值金额" prop="addedAmount"
                            key="addedAmount-number">
                            <el-input style="width: 87%;" v-model="formContract.addedAmount"
                                :disabled="['salesManagerEdits'].includes(operation)" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item v-if="formContract.addedType === 'proportion'" label="增值比例" prop="addedProportion"
                            key="addedAmount-proportion">
                            <template #label>
                                <div style="position: relative; display: inline-block;margin-right: 10px;">
                                    <span>增值比例</span>
                                    <el-popover placement="top" width="200" trigger="click" content="增值金额=合同金额*增值比例后取整">
                                        <sup slot="reference"
                                            style="position: absolute; top: 10px; right: -15px; cursor: pointer;">
                                            <i class="el-icon-info" style="color: #808080; font-size: 14px;"></i>
                                        </sup>
                                    </el-popover>
                                </div>
                            </template>
                            <el-select style="width: 87%;" v-model="formContract.addedProportion"
                                @change="onProportionChange" :disabled="['salesManagerEdits'].includes(operation)"
                                placeholder="请选择增值比例" filterable>
                                <el-option v-for="item in proportionOptions" :key="item.value"
                                    :label="getProportionLabel(item)" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>

                    <div v-if="['返样/暂存样品', '预付款扣款（返样/暂存样品）'].includes(formContract.projectType)" style="width: 100%">
                        <el-form-item label="样品处理方式" prop="sampleManagement" style="width: 100%!important;">
                            <template #label>
                                <span style="background-color: #ffff00;color: #ff1c00;font-weight: bold;">样品处理方式</span>
                            </template>
                            <div style="display: flex;align-items: center">
                                <el-radio-group v-model="formContract.sampleManagement">
                                    <el-radio label="RETURN_SAMPLE">返样</el-radio>
                                    <el-radio label="SAMPLE_HOLD">暂存样品</el-radio>
                                </el-radio-group>
                               <div style="margin-left: 25px;font-size: 14px;color: red;">
                                    <span v-if="formContract.sampleManagement === 'SAMPLE_HOLD'">
                                        注：暂存样品<= 三个月可以不收费,但暂存的样品必须小于50ml或50g,超过该体积或重量无法暂存 </span>
                                            <span v-else-if="formContract.sampleManagement === 'RETURN_SAMPLE'">
                                                注：除【冰袋寄出，顺丰快递到付】可不收费外，其余情况均需收费
                                            </span>
                                            <span v-else>&nbsp;</span>
                                </div>
                            </div>
                        </el-form-item>
                    </div>
                    
                    <div v-if="formContract.contractType === 'TEAM'" style="width: 100%;margin-bottom: 5px">
                        <div
                            :style="{ width: '93%!important', display: 'flex', flexDirection: 'column', padding: '12px 20px', border: '1px dashed #d9d9d9', background: '#fafafa' }">
                            <span style="font-size: 14px; font-weight: 600; margin-bottom: 6px;">团队费用合同说明</span>
                            <span style="font-size: 12px; color: red; line-height: 1.8;">
                                <span style="display: block;">1. 试做项目（金额&lt;=800，价格按照报价表的价格）</span>
                                <span style="display: block;">2. 项目售后</span>
                                <span style="display: block;">3. 原始数据重释放</span>
                                <span style="display: block;">4. 销售/客户对数据有疑问；后台核查没问题；还要重做；</span>
                                <span style="display: block;">5. 纯分析（金额&lt;1500，走团队费用的纯分析不允许打折）</span>
                                <span style="display: block;">6. 外送的项目不允许；测序分析项目不允许部分费用走：团队费用。</span>
                            </span>
                        </div>
                    </div>
                    <div style="width: 100%;margin-bottom: 20px">
                        <div style="margin-top: 5px;" v-if="projectTypeData.includes(formContract.projectType)">
                           <div
                                :style="{ width: '93%!important', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 20px', border: '1px dashed #d9d9d9', background: '#fafafa' }">
                                <span style="font-size: 14px; font-weight: 600;">项目信息</span>
                                <div style="display:flex; align-items:center; gap: 10px;">
                                    <el-button type="success" size="mini" icon="el-icon-plus" @click="handleAddProject"
                                        :disabled="['salesManagerEdits'].includes(operation)">添加</el-button>
                                </div>
                            </div>
                            <div style="width: 100%;display:flex;align-items: center;"
                                v-for="(project, index) in formContract.specificProjectType" :key="index">
                                <div :class="{ 'disabled-state': project.projectStatus === 'TERMINATION' && operation !== 'adminEdits' }"
                                    style="display: flex;flex-wrap: wrap;padding-top:20px;border: 1px dashed #d9d9d9;border-top: none;width: 93%!important;gap:10px;">
                                    <el-form-item label="项目模块" style="width: 32%!important;"
                                        :prop="'specificProjectType.' + index + '.projectClassification'"
                                        :rules="{ required: true, message: '请选择项目分类', trigger: 'change' }">
                                        <el-select v-model="project.projectClassification" placeholder="请选择项目模块"
                                            filterable @change="changeProject(project)"
                                            :disabled="['salesManagerEdits'].includes(operation)">
                                            <el-option
                                                v-for="item in TypeOption.filter(item => !item.disabled.includes(formContract.projectType) && !(formContract.contractType === 'TEAM' && item.label === 'METAPRO'))"
                                                :key="item.label" :label="item.name" :value="item.label"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item :label="project.projectClassification !== '硬盘购买' ? '项目类型' : '硬盘大小'"
                                        style="width: 32%!important;"
                                        :prop="'specificProjectType.' + index + '.projectType'"
                                        :rules="{ required: true, message: '请选择项目类型', trigger: 'change' }">
                                        <el-select v-model="project.projectType" placeholder="请选择项目类型" filterable
                                            @change="changeType(project)"
                                            :disabled="['salesManagerEdits'].includes(operation)">
                                            <el-option
                                                v-for="item in filterOptions(project.projectClassification, project.projectType)"
                                                :disabled="item.deprecated" :key="item.name" :label="item.name"
                                                :value="item.name"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="项目金额" :prop="'specificProjectType.' + index + '.projectAmount'"
                                        style="width: 32%!important;"
                                        v-if="!(project.experimental && project.experimental.length > 0)"
                                        :rules="formContract.contractType !== 'DEVELOPMENT' ? [{ required: project.projectStatus !== 'TERMINATION', message: '请输入项目金额', trigger: 'change' },
                                        (project.experimental && project.experimental.length > 0)
                                            ? { validator: (rule, value, callback) => checkSumAmount(rule, value, project.labList, project.experimental, callback, operation !== 'adminEdits'), trigger: 'change' }
                                            : { validator: checkNumber, trigger: 'change' }] : { required: false, message: '请输入项目金额', trigger: 'change' }">
                                        <div style="display: flex;align-items: center">
                                            <el-input v-model="project.projectAmount" auto-complete="off"
                                                :disabled="formContract.contractType === 'DEVELOPMENT' || ['salesManagerEdits'].includes(operation)"
                                                placeholder="请输入项目金额"></el-input>
                                        </div>
                                    </el-form-item>
                                    <div style="width: 100%!important;display: flex;justify-content: center;"
                                        v-if="project.experimental && project.experimental.length > 0">
                                        <div
                                            style="width: 98%;display: flex;flex-wrap:wrap;border:1px dashed #d9d9d9;padding-top: 20px">
                                            <el-form-item label="实验过程"
                                                :prop="'specificProjectType.' + index + '.labList'"
                                                style="width: 99%!important;margin-bottom: 0" label-width="135px"
                                                :rules="[{ required: true, message: '请选择实验过程', trigger: 'change' }, { validator: (rule, value, callback) => checkInclude(rule, value, callback, ['引物合成', '荧光定量'], project.experimental.map(item => item.experimentName)), trigger: 'change' }]">
                                                <el-checkbox-group v-model="project.labList" style="width:100%">
                                                    <el-checkbox v-for="(lab, labIndex) in project.experimental"
                                                        style="width:45%;margin-bottom:20px" :key="labIndex"
                                                        :label="lab.experimentName"
                                                        :disabled="(['引物合成', '荧光定量'].includes(lab.experimentName) && project.labList.includes(lab.experimentName)) || ['salesManagerEdits'].includes(operation)">
                                                        <div style="display:flex;align-items:center">
                                                            <span style="width:65px">{{ lab.experimentName }}</span>
                                                            <el-form-item label-width="12px"
                                                                :prop="'specificProjectType.' + index + '.experimental.' + labIndex + '.numberOfExperiment'"
                                                                :rules="[{ required: project.labList.includes(lab.experimentName), message: '请输入数量', trigger: 'change' },
                                                                { validator: checkNum, trigger: 'change' }]"
                                                                style="width:48%!important">
                                                                <el-input v-model="lab.numberOfExperiment"
                                                                    auto-complete="off" placeholder="数量"
                                                                    :disabled="!project.labList.includes(lab.experimentName) || ['salesManagerEdits'].includes(operation)"></el-input>
                                                            </el-form-item>
                                                            <el-form-item label-width="12px" style="width:48%!important"
                                                                :prop="'specificProjectType.' + index + '.experimental.' + labIndex + '.experimentAmount'"
                                                                :rules="[{ required: project.labList.includes(lab.experimentName) && project.projectStatus !== 'TERMINATION', message: '请输入金额', trigger: 'change' },
                                                                (formContract.contractType === 'DEVELOPMENT' || operation === 'adminEdits' || project.projectStatus === 'TERMINATION') ? { validator: checkNumber, trigger: 'change' } : { validator: checkNum, trigger: 'change' }]">
                                                                <el-input
                                                                    @input="(value) => addProjectAmount(value, index)"
                                                                    v-model="lab.experimentAmount" auto-complete="off"
                                                                    placeholder="金额"
                                                                    :disabled="!project.labList.includes(lab.experimentName) || ['salesManagerEdits'].includes(operation)"></el-input>
                                                            </el-form-item>
                                                        </div>
                                                    </el-checkbox>
                                                </el-checkbox-group>
                                            </el-form-item>
                                        </div>
                                    </div>

                                    <div style="width: 100%;"
                                        v-if="!(project.experimental && project.experimental.length > 0)">
                                        <div v-for="(dataItem, dataIndex) in project.projectSampleDataList"
                                            :class="['custom-style']">
                                            <div
                                                :style="{ display: 'flex', width: '95%', 'align-items': 'flex-start', 'flex-wrap': 'wrap', 'border': '1px dashed #d9d9d9', 'border-top-style': dataIndex !== 0 ? 'none' : 'dashed', 'margin-left': '10px', }">
                                                <el-form-item label="样品数量"
                                                    :prop="'specificProjectType.' + index + '.projectSampleDataList.' + dataIndex + '.numberOfSamples'"
                                                    style="width: 32%!important;margin-top: 10px;"
                                                    :rules="[{ required: true, message: '请输入样品数量', trigger: 'change' },
                                                    (project.experimental && project.experimental.length > 0) ? { validator: (rule, value, callback) => checkSum(rule, value, callback, project.minSampleCount, project.maxSampleCount, project.labList, project.experimental), trigger: 'change' } : { validator: (rule, value, callback) => checkMinMax(rule, value, callback, project.minSampleCount, project.maxSampleCount), trigger: 'change' }]">
                                                    <div style="display: flex;align-items: center">
                                                        <el-input v-model="dataItem.numberOfSamples" auto-complete="off"
                                                            :disabled="['salesManagerEdits'].includes(operation)"
                                                            placeholder="请输入样品数量"></el-input>
                                                    </div>
                                                </el-form-item>
                                                <!-- 二代/三代检测平台可选时，宽度为66% -->
                                                <div style="display: flex; flex-wrap: wrap; width: 68%;">
                                                    <div v-for="(info, sonIndex) in dataItem.projectList"
                                                        :key="sonIndex" v-if="info.value !== 'NOT'"
                                                        :style="{ display: 'flex', alignItems: 'center', width: ((info.name === '二代' && project.sequencingPlatformList && project.sequencingPlatformList.length > 0) || (info.name === '三代' && project.thirdSequencingPlatformList && project.thirdSequencingPlatformList.length > 0)) ? '98%' : '49%', marginTop: '15px' }">
                                                        <el-form-item style="width: 1%!important;" label-width="10px">
                                                            <el-checkbox v-model="info.boolean"
                                                                :disabled="(info.value !== 'CHOOSE' && !['TGG'].includes(project.projectClassification)) || dataIndex > 0 || ['salesManagerEdits'].includes(operation)"
                                                                @change="() => onPlatformCheckboxChange(index, dataIndex, info)"></el-checkbox>
                                                        </el-form-item>
                                                        <el-form-item :label="info.name + '数据量'"
                                                            :prop="'specificProjectType.' + index + '.projectSampleDataList.' + dataIndex + '.projectList.' + sonIndex + '.size'"
                                                            :rules="info.boolean ? [
                                                                { required: info.boolean, message: '请输入样品数据量', trigger: 'change' },
                                                                { validator: (rule, value, callback) => checkSize(rule, value, callback, project.projectClassification === 'AMPLICON' ? 10000 : ''), trigger: 'change' },
                                                                { validator: (rule, value, callback) => validatePlatformSelection(rule, value, callback, project, index, dataIndex), trigger: 'change' }
                                                            ] : [{ validator: (rule, value, callback) => validatePlatformSelection(rule, value, callback, project, index, dataIndex), trigger: 'change' }]"
                                                            :style="{ width: ((info.name === '二代' && project.sequencingPlatformList?.length > 0) || (info.name === '三代' && project.thirdSequencingPlatformList?.length > 0)) ? '48%!important' : '99%!important' }">
                                                            <el-input v-model="info.size" auto-complete="off"
                                                                :disabled="!info.boolean || ['salesManagerEdits'].includes(operation)"
                                                                placeholder="请输入">
                                                                <template #suffix>
                                                                    <span style="color: #606266;margin-right: 3px;">{{
                                                                        '(' + (info.name !== 'ONT' ?
                                                                        project.dataAmountUnit : 'Cell') + ')' }}</span>
                                                                </template>
                                                            </el-input>
                                                        </el-form-item>
                                                        <!-- 二代检测平台选择 -->
                                                        <el-form-item
                                                            v-if="info.name === '二代' && project.sequencingPlatformList && project.sequencingPlatformList.length > 0"
                                                            label="检测平台"
                                                            :prop="'specificProjectType.' + index + '.sequencingPlatform'"
                                                            style="width: 48%!important;"
                                                            :rules="{ required: info.boolean, message: '请选择二代检测平台', trigger: 'change' }">
                                                            <el-select v-model="project.sequencingPlatform"
                                                                placeholder="请选择二代检测平台"
                                                                :disabled="project.sequencingPlatformList.length === 1 || dataIndex !== 0 || !info.boolean || ['salesManagerEdits'].includes(operation)"
                                                                filterable>
                                                                <el-option
                                                                    v-for="item in project.sequencingPlatformList"
                                                                    :key="item" :label="item" :value="item"></el-option>
                                                            </el-select>
                                                        </el-form-item>
                                                        <!-- 三代检测平台选择 -->
                                                        <el-form-item
                                                            v-if="info.name === '三代' && project.thirdSequencingPlatformList && project.thirdSequencingPlatformList.length > 0"
                                                            label="检测平台"
                                                            :prop="'specificProjectType.' + index + '.thirdSequencingPlatform'"
                                                            style="width: 48%!important;"
                                                            :rules="{ required: info.boolean, message: '请选择三代检测平台', trigger: 'change' }">
                                                            <el-select v-model="project.thirdSequencingPlatform"
                                                                placeholder="请选择三代检测平台"
                                                                @change="(value) => changeThirdSequencingPlatform(value, project)"
                                                                :disabled="project.thirdSequencingPlatformList.length === 1 || dataIndex !== 0 || !info.boolean || ['salesManagerEdits'].includes(operation)"
                                                                filterable>
                                                                <el-option
                                                                    v-for="item in project.thirdSequencingPlatformList"
                                                                    :key="item" :label="item" :value="item"></el-option>
                                                            </el-select>
                                                        </el-form-item>
                                                    </div>
                                                </div>

                                            </div>
                                            <div
                                                style="justify-content: center;display: flex;flex-wrap: wrap;margin-left: 10px;width: 50px;margin-right: 10px;">
                                                <el-button type="danger" size="mini" icon="el-icon-delete"
                                                    :disabled="['METAPRO', '硬盘购买', 'PCR'].includes(project.projectClassification) || ['salesManagerEdits'].includes(operation)"
                                                    @click="handleDeleteData(index, dataIndex)"
                                                    style="margin-bottom: 2px;"></el-button>
                                                <el-button size="mini" icon="el-icon-plus" type="success"
                                                    style="margin: 1px 0 0;"
                                                    :disabled="['METAPRO', '硬盘购买', 'PCR'].includes(project.projectClassification) || ['salesManagerEdits'].includes(operation)"
                                                    v-if="dataIndex === project.projectSampleDataList.length - 1"
                                                    @click="handleAddData(index)"></el-button>
                                            </div>
                                        </div>
                                    </div>


                                    <div style="width: 100%!important;display: flex;flex-wrap: wrap;"
                                        v-if="!['预付款扣款（裸测）', '裸测'].includes(formContract.projectType)">
                                        <el-form-item label="分析要求" :prop="'specificProjectType.' + index + '.analysis'"
                                            v-if="project.projectClassification && project.projectClassification !== '硬盘购买'"
                                            :rules="[{ required: true, message: '请选择分析要求', trigger: 'change' }]">
                                            <el-radio-group v-model="project.analysis"
                                                :disabled="['salesManagerEdits'].includes(operation)">
                                                <el-radio label="标准分析">标准分析</el-radio>
                                                <el-radio label="非标准分析">非标准分析</el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                        <div style="width: 50%!important;" v-if="['理化性质'].includes(project.projectType) && project.projectMainTypeId">
                                            <div class="project-annex-wrapper" style="display:flex;flex-direction:column;width:100%;">
                                                <el-form-item label="需做的理化性质列表" prop="projectAnnexFiles" label-width="155px" style="width: 100%!important;margin-bottom:0;"
                                                    :rules="[{ required: true, validator: (rule, value, callback) => validateProjectAnnex(rule, value, callback, project), trigger: 'change' }]">
                                                    <div style="display:flex;width: 100%;align-items: center">
                                                        <el-input
                                                            :value="(formContract.projectAnnexFiles[project.projectMainTypeId] && formContract.projectAnnexFiles[project.projectMainTypeId].name) || ''"
                                                            readonly style="flex:1"></el-input>
                                                        <el-button size="small" style="margin-left:8px;flex-shrink:0"
                                                            :disabled="['salesManagerEdits'].includes(operation)"
                                                            type="success" icon="el-icon-upload2"
                                                            @click="$refs['projectAnnexInput_' + project.projectMainTypeId] && $refs['projectAnnexInput_' + project.projectMainTypeId][0] && $refs['projectAnnexInput_' + project.projectMainTypeId][0].click()"></el-button>
                                                        <input :ref="'projectAnnexInput_' + project.projectMainTypeId"
                                                            type="file" style="display:none"
                                                            @change="(e) => handleProjectAnnexFileSelect(e, project)" />
                                                    </div>
                                                </el-form-item>
                                                <div style="margin-left:155px;">
                                                    <span style="font-weight: bold;">eg.</span><a :href="`./file/理化检测示例表格.xlsx`"
                                                        :underLine="false" download>理化检测示例表格.xlsx</a>
                                                </div>
                                            </div>
                                        </div>
                                        <el-form-item label="解离样品投递方式" style="width: 49%!important;" label-width="135px"
                                            prop="protectiveFluidInfo.protectiveFluidMethod"
                                            v-if="['单细胞解离转录组-C4', '单细胞解离转录组-10X', '单细胞解离转录组'].includes(project.projectType)"
                                            :rules="[{ required: true, message: '请选择解离样品投递方式', trigger: 'change' }]">
                                            <el-radio-group
                                                v-model="formContract.protectiveFluidInfo.protectiveFluidMethod">
                                                <el-radio label="DOOR">上门</el-radio>
                                                <el-radio label="MAIL">邮寄</el-radio>
                                            </el-radio-group>
                                        </el-form-item> 
                                        <div v-if="['单细胞解离转录组-C4', '单细胞解离转录组-10X', '单细胞解离转录组'].includes(project.projectType)"
                                            style="margin-top: 5px;width: 100%;display: flex;flex-wrap: wrap;">
                                            <template
                                                v-if="formContract.protectiveFluidInfo.protectiveFluidMethod === 'DOOR'">
                                                <el-form-item label="上门时间" style="width: 48%!important;"
                                                    prop="protectiveFluidInfo.doorInfo.doorTime" :rules="[{ required: true, message: '请输入上门时间', trigger: 'change' },
                                                    { validator: checkDate, trigger: 'change' }]">
                                                    <el-input
                                                        v-model="formContract.protectiveFluidInfo.doorInfo.doorTime"
                                                        auto-complete="off" placeholder="请输入日期，格式yyyy-MM-dd"></el-input>
                                                </el-form-item>
                                                <el-form-item :label="'上门费用'" style="width: 48%!important;"
                                                    prop="protectiveFluidInfo.doorInfo.doorFee"
                                                    :rules="[{ required: true, message: '请输入上门费用', trigger: 'change' },
                                                    { validator: validateDoorFee, trigger: 'change' }]">
                                                    <el-input
                                                        v-model="formContract.protectiveFluidInfo.doorInfo.doorFee"
                                                        auto-complete="off" placeholder="请输入上门费用">
                                                    </el-input>
                                                    <template #label>
                                                        <span>上门费用</span>
                                                        <!-- 可以根据需求调整对齐方式：text-align: flex-end 为右对齐 -->
                                                        <span
                                                            style="font-size: 12px; color: #606266; margin-top: 2px;">&ge;3000</span>
                                                    </template>
                                                </el-form-item>
                                                <el-form-item label="联系方式" style="width: 48%!important;"
                                                    prop="protectiveFluidInfo.doorInfo.phone"
                                                    :rules="[{ required: true, message: '请输入联系方式', trigger: 'change' }]">
                                                    <el-input v-model="formContract.protectiveFluidInfo.doorInfo.phone"
                                                        auto-complete="off" placeholder="请输入联系方式"></el-input>
                                                </el-form-item>
                                                <el-form-item label="上门地址" style="width: 48%!important;"
                                                    prop="protectiveFluidInfo.doorInfo.address"
                                                    :rules="[{ required: true, message: '请输入上门地址', trigger: 'change' }]">
                                                    <el-input
                                                        v-model="formContract.protectiveFluidInfo.doorInfo.address"
                                                        auto-complete="off" placeholder="请输入上门地址"></el-input>
                                                </el-form-item>
                                            </template>
                                            <template
                                                v-else-if="formContract.protectiveFluidInfo.protectiveFluidMethod === 'MAIL'">
                                                <el-form-item label="邮寄时间" style="width: 48%!important;"
                                                    prop="protectiveFluidInfo.materialMailInfo.mailTime" :rules="[{ required: true, message: '请输入邮寄时间', trigger: 'change' },
                                                    { validator: checkDate, trigger: 'change' }]">
                                                    <el-input
                                                        v-model="formContract.protectiveFluidInfo.materialMailInfo.mailTime"
                                                        auto-complete="off" placeholder="请输入日期，格式yyyy-MM-dd"></el-input>
                                                </el-form-item>
                                                <el-form-item label="收件人" style="width: 48%!important;"
                                                    prop="protectiveFluidInfo.materialMailInfo.recipient"
                                                    :rules="{ required: true, message: '请输入收件人', trigger: 'change' }">
                                                    <el-input
                                                        v-model="formContract.protectiveFluidInfo.materialMailInfo.recipient"
                                                        auto-complete="off" placeholder="请输入收件人"></el-input>
                                                </el-form-item>
                                                <el-form-item label="收件人电话" style="width: 48%!important;"
                                                    prop="protectiveFluidInfo.materialMailInfo.phone"
                                                    :rules="{ required: true, message: '请输入收件人电话', trigger: 'change' }">
                                                    <el-input
                                                        v-model="formContract.protectiveFluidInfo.materialMailInfo.phone"
                                                        auto-complete="off" placeholder="请输入收件人电话"></el-input>
                                                </el-form-item>
                                                <el-form-item label="收件地址" style="width: 48%!important;"
                                                    prop="protectiveFluidInfo.materialMailInfo.address"
                                                    :rules="{ required: true, message: '请输入收件地址', trigger: 'change' }">
                                                    <el-input
                                                        v-model="formContract.protectiveFluidInfo.materialMailInfo.address"
                                                        auto-complete="off" placeholder="请输入收件地址"></el-input>
                                                </el-form-item>
                                            </template>
                                        </div>
                                        <el-form-item label="标准分析具体类型"
                                            :prop="'specificProjectType.' + index + '.analysisList'"
                                            style="width: 98%!important;" label-width="135px"
                                            v-if="project.analysis === '标准分析' && project.analysisChoiceList.length > 0 && !(project.analysisChoiceList.includes('标准分析') && project.analysisChoiceList.length === 1)"
                                            :rules="[{ required: true, message: '请选择标准分析具体类型', trigger: 'change' }]">
                                            <el-checkbox-group v-model="project.analysisList"
                                                v-if="project.multipleChoice"
                                                @change="(value) => changeAnalysisChoice(value, project)"
                                                :disabled="['salesManagerEdits'].includes(operation)">
                                                <el-checkbox
                                                    v-for="(choiceItem, choiceIndex) in project.analysisChoiceList"
                                                    :key="choiceIndex" :label="choiceItem"></el-checkbox>
                                            </el-checkbox-group>
                                            <el-radio-group v-model="project.analysisList[0]"
                                                v-if="!project.multipleChoice"
                                                :disabled="['salesManagerEdits'].includes(operation)">
                                                <el-radio
                                                    v-for="(choiceItem, choiceIndex) in project.analysisChoiceList"
                                                    :key="choiceIndex" :label="choiceItem"></el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div
                                    style="justify-content: center;display: flex;flex-wrap: wrap;margin-left: 10px;width: 50px;margin-right: 10px;">
                                    <el-button type="danger" size="mini" icon="el-icon-delete"
                                        :disabled="project.projectStatus === 'TERMINATION' || ['salesManagerEdits'].includes(operation)"
                                        @click="handleDeleteProject(project)" style="margin-bottom: 2px;"></el-button>
                                </div>
                            </div>
                        </div>
                        <div style="margin-top: 5px;"
                            v-if="protectiveFluidMail.some(item => item.trackingFlag !== 0)">
                            <div
                                :style="{ width: '93%!important', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 20px', border: '1px dashed #d9d9d9', background: '#fafafa' }">
                                <span style="font-size: 14px; font-weight: 600;">物料信息（已邮寄/已取消）</span>
                            </div>
                            <div v-for="(materialMail, index) in protectiveFluidMail" style="width: 100%;">
                                <div v-if="materialMail.trackingFlag !== 0" style="width: 100%;">
                                    <div v-for="(material, index) in materialMail.details" :key="index"
                                        style="width: 100%; display: flex; align-items: center; position: relative;">
                                        <div
                                            :style="{ width: '93%!important', display: 'flex', flexWrap: 'wrap', paddingTop: '20px', border: '1px dashed #d9d9d9', borderTop: 'none' }">
                                            <el-form-item label="物料名称" style="width: 33%!important;">
                                                <el-input v-model="material.materialName" readonly></el-input>
                                            </el-form-item>

                                            <el-form-item label="物料规格" style="width: 33%!important;">
                                                <el-input v-model="material.specs" readonly></el-input>
                                            </el-form-item>

                                            <el-form-item label-width="147px" style="width: 33%!important;"
                                                label="申领数量">
                                                <el-input v-model="material.number" readonly>
                                                    <template #suffix>
                                                        <span style="color: #606266;margin-right: 3px;">{{ '(支)'
                                                            }}</span>
                                                    </template>
                                                </el-input>
                                            </el-form-item>
                                        </div>
                                        <div class="mask-layer">
                                            <span class="mask-layer-text">{{ materialMail.trackingFlag === 1 ?
                                                '该物料已被邮寄，无法编辑' : '该物料已被取消，无法编辑' }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 全局解离投递方式表单，仅出现一次 -->
                        <div style="margin-top: 5px;" v-if="targetList.includes(formContract.projectType) || (['单细胞解离转录组-C4','单细胞解离转录组-10X','单细胞解离转录组'].some(item => formContract.specificProjectType.map(project => project.projectType).includes(item)) && formContract.protectiveFluidInfo.protectiveFluidMethod === 'MAIL')">
                            <div :style="{ width: '93%!important', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 20px', border: '1px dashed #d9d9d9', background: '#fafafa' }">
                                <span style="font-size: 14px; font-weight: 600;">物料申领</span>
                                <div style="display:flex; align-items:center; gap: 10px;">
                                    <el-button type="success" size="mini" icon="el-icon-plus" @click="handleAddMaterial" :disabled="['adminEdits', 'salesManagerEdits'].includes(operation)">{{operation === 'change' ? '再次申领' : '添加'}}</el-button>
                                </div>
                            </div>
                           <div v-for="(material, index) in formContract.materials" :key="index"
                                style="width: 100%;display:flex;align-items: center;">
                                <div
                                    :style="{ width: '93%!important', display: 'flex', flexWrap: 'wrap', paddingTop: '20px', border: '1px dashed #d9d9d9', borderTop: 'none' }">
                                    <el-form-item label="物料名称" :prop="'materials.' + index + '.materialId'"
                                        style="width: 33%!important;"
                                        :rules="{ required: true, message: '请选择物料', trigger: 'change' }">
                                        <el-select v-model="material.materialId" placeholder="请选择物料" filterable
                                            :disabled="['adminEdits', 'salesManagerEdits'].includes(operation)"
                                            @change="changeNumber(material.materialId, index)">
                                            <el-option v-for="item in filterOption(material.materialId)" :key="item.id"
                                                :label="'物料:' + item.materialName + '，剩余:' + item.number"
                                                :value="item.id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="物料规格" :prop="'materials.' + index + '.specs'"
                                        style="width: 33%!important;"
                                        :rules="{ required: true, message: '请选择物料规格', trigger: 'change' }">
                                        <el-select v-model="material.specs" placeholder="请选择物料规格" filterable
                                            :disabled="['adminEdits', 'salesManagerEdits'].includes(operation)">
                                            <el-option
                                                v-for="item in filterSpecsOption(material.materialId, material.specs)"
                                                :key="item" :label="item" :value="item"></el-option>
                                        </el-select>
                                    </el-form-item>
                                   <el-form-item label-width="147px" style="width: 33%!important;" label="申领数量"
                                        :prop="'materials.' + index + '.materialNumber'"
                                        :rules="[{ required: true, message: '请输入申领数量', trigger: 'change' },
                                        { validator: (rule, value, callback) => check(rule, value, material.remainingNumber, materialNumber[material.materialId], callback), trigger: 'change' }]">
                                        <el-input style="width: 100%" v-model="material.materialNumber"
                                            auto-complete="off" :disabled="['adminEdits', 'salesManagerEdits'].includes(operation)"
                                            placeholder="请输入">
                                            <template #suffix>
                                                <span style="color: #606266;margin-right: 3px;">{{ '(支)' }}</span>
                                            </template>
                                        </el-input>
                                    </el-form-item>
                                </div>
                                <div
                                    style="justify-content: center;display: flex;flex-wrap: wrap;margin-left: 10px;width: 50px;margin-right: 10px;">
                                    <el-button type="danger" size="mini" icon="el-icon-delete"
                                        :disabled="['adminEdits', 'salesManagerEdits'].includes(operation)"
                                        @click="handleDeleteMaterial(material)" style="margin-bottom: 2px;"></el-button>
                                </div>
                            </div>
                        </div>

                       <div style="margin-top: 5px;width: 100%;"
                            v-if="formContract.contractType === 'TEAM' && formContract.projectType === '纯分析'">
                            <div :style="{ width: '93%!important', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 20px', border: '1px dashed #d9d9d9', background: '#fafafa' }">
                                <span style="font-size: 14px; font-weight: 600; flex-shrink: 0;">纯分析项目选择</span>
                                <span style="display: flex; align-items: flex-start; font-size: 12px; color: red; margin: 0 20px; line-height: 1.5; max-width: 50%; text-align: left;">
                                    <span style="flex-shrink: 0;">注：</span>
                                    <span>售后分析选择的合同号必须是已完成分析的，状态从管理系统获取；<br />原始数据重释放选择的项目是已经释放过原始数据的项目，状态从管理系统获取。</span>
                                </span>
                                <el-button type="success" size="mini" icon="el-icon-plus" style="flex-shrink: 0;"
                                    v-if="['AFTER_SALES_ANALYSIS', 'RAW_DATA_RERELEASE'].includes(formContract.pureAnalysisInfo.pureAnalysisType)"
                                    :disabled="['salesManagerEdits'].includes(operation)"
                                    @click="addPureAnalysisContract">添加合同</el-button>
                            </div>
                            <div style="width: 100%;">
                                <div v-for="(item, index) in formContract.pureAnalysisInfo.contracts" :key="index"
                                    style="display: flex; align-items: center; width: 100%;">
                                    <!-- 边框内容区：纯分析类型 / 合同 / 项目 -->
                                    <div style="width: 93%; display: flex; align-items: flex-start; gap: 10px; border: 1px dashed #d9d9d9; border-top: none; padding: 20px 0;">
                                        <!-- 首列：第一行放「纯分析类型」，其余行放等宽占位以与第一项对齐 -->
                                        <el-form-item v-if="index === 0" label="纯分析类型" prop="pureAnalysisInfo.pureAnalysisType"
                                            style="flex: 1 1 32%; max-width: 32%; min-width: 0;"
                                            :rules="[{ required: true, message: '请选择纯分析类型', trigger: 'change' }]">
                                            <el-select v-model="formContract.pureAnalysisInfo.pureAnalysisType"
                                                placeholder="请选择纯分析类型" filterable
                                                :disabled="['salesManagerEdits'].includes(operation)"
                                                @change="changePureAnalysisType">
                                                <el-option v-for="type in pureAnalysisTypeOptions" :key="type.value"
                                                    :label="type.label" :value="type.value"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <div v-else style="flex: 1 1 32%; max-width: 32%; min-width: 0;"></div>
                                        <!-- 合同 / 项目：仅售后分析、原始数据重释放时显示 -->
                                        <template v-if="['AFTER_SALES_ANALYSIS', 'RAW_DATA_RERELEASE'].includes(formContract.pureAnalysisInfo.pureAnalysisType)">
                                            <el-form-item label="合同"
                                                :prop="'pureAnalysisInfo.contracts.' + index + '.contractId'"
                                                style="flex: 1 1 32%; max-width: 32%; min-width: 0;"
                                                :rules="[{ required: true, message: '请选择合同', trigger: 'change' }]">
                                                <el-select v-model="item.contractId" placeholder="请输入合同编号搜索"
                                                    filterable remote reserve-keyword clearable
                                                    :remote-method="(query) => getEnforceContractOption(query, index)"
                                                    :loading="enforceContractLoading"
                                                    :disabled="['salesManagerEdits'].includes(operation)"
                                                    @change="changePureAnalysisContract(index)">
                                                    <el-option v-for="opt in item.options" :key="opt.id"
                                                        :label="opt.contractNumber" :value="opt.id"
                                                        :disabled="isContractOptionDisabled(opt.id, index)"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="项目"
                                                :prop="'pureAnalysisInfo.contracts.' + index + '.projectIds'"
                                                style="flex: 1 1 32%; max-width: 32%; min-width: 0;"
                                                :rules="[{ required: true, message: '请选择项目', trigger: 'change' }]">
                                                <el-select v-model="item.projectIds"
                                                    placeholder="请先选择合同"
                                                    filterable multiple reserve-keyword clearable
                                                    :multiple-limit="formContract.pureAnalysisInfo.pureAnalysisType === 'AFTER_SALES_ANALYSIS' ? 1 : 0"
                                                    :disabled="['salesManagerEdits'].includes(operation) || !item.contractId">
                                                    <el-option v-for="opt in getProjectOptions(item)" :key="opt.id"
                                                        :label="opt.label" :value="opt.id"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </template>
                                    </div>
                                    <!-- 删除按钮：移到边框外右侧，与物料/硬盘选购保持一致 -->
                                    <div v-if="['AFTER_SALES_ANALYSIS', 'RAW_DATA_RERELEASE'].includes(formContract.pureAnalysisInfo.pureAnalysisType)"
                                        style="justify-content: center; display: flex; flex-wrap: wrap; margin-left: 10px; width: 50px; margin-right: 10px;">
                                        <el-button type="danger" size="mini" icon="el-icon-delete"
                                            :disabled="['salesManagerEdits'].includes(operation) || formContract.pureAnalysisInfo.contracts.length <= 1"
                                            @click="removePureAnalysisContract(index)" style="margin-bottom: 2px;"></el-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="margin-top: 5px;width: 100%;"
                            v-if="hardDiskList.includes(formContract.projectType) && formContract.contractType !== 'TEAM'">
                            <div :style="{ width: '93%!important', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 20px', border: '1px dashed #d9d9d9', background: '#fafafa' }">
                                <span style="font-size: 14px; font-weight: 600;">硬盘选购信息</span>
                                <div style="display:flex; align-items:center; gap: 10px;">
                                    <el-button type="text" size="mini" @click="showHardDiskPurchaseInfo = !showHardDiskPurchaseInfo">
                                        {{ showHardDiskPurchaseInfo ? '收起' : '展开' }}
                                    </el-button>
                                    <el-button type="success" size="mini" icon="el-icon-plus" @click="addHardDiskPurchaseItem" :disabled="filterOptions('硬盘购买').length <= 0">
                                        添加
                                    </el-button>
                                </div>
                            </div>
                            <div v-show="showHardDiskPurchaseInfo" style="width: 100%!important; display:flex; flex-wrap:wrap;">
                                <div v-if="formContract.hardDiskPurchaseInfo.length === 0" style="width:93%;padding:20px;text-align:center;color:#909399; border: 1px dashed #d9d9d9;border-top: none;">
                                    当前暂无硬盘选购信息，点击“添加”开始填写。
                                </div>
                               <div v-for="(purchase, index) in formContract.hardDiskPurchaseInfo" :key="index"
                                    style="width: 100%;display:flex;align-items: center;">
                                   <div
                                        style="width: 93%;display:flex; flex-wrap:wrap; align-items:flex-start; gap:10px; padding-top: 20px; border: 1px dashed #d9d9d9;border-top: none;">
                                        <el-form-item label="硬盘大小"
                                            :prop="'hardDiskPurchaseInfo.' + index + '.hardDiskSize'"
                                            style="width: 32%!important;" :rules="[{ required: true, message: '请选择硬盘大小', trigger: 'change' }]">
                                            <el-select v-model="purchase.hardDiskSize" placeholder="请选择硬盘大小" filterable>
                                                <el-option v-for="item in filterOptions('硬盘购买', purchase.hardDiskSize)"
                                                    :key="item.name" :label="item.name" :value="item.name"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="项目金额"
                                            :prop="'hardDiskPurchaseInfo.' + index + '.projectAmount'"
                                            style="width: 32%!important;"
                                            :rules="[{ required: true, message: '请输入项目金额', trigger: 'change' },
                                            { validator: validateHardDiskProjectAmount, trigger: 'change' }]">
                                            <el-input v-model="purchase.projectAmount" auto-complete="off"
                                                :disabled="formContract.contractType === 'DEVELOPMENT' || ['salesManagerEdits'].includes(operation)"
                                                placeholder="请输入项目金额"></el-input>
                                        </el-form-item>
                                        <el-form-item label="数量"
                                            :prop="'hardDiskPurchaseInfo.' + index + '.sampleCount'"
                                            style="width: 32%!important;"
                                            :rules="[{ required: true, message: '请输入选购数量', trigger: 'change' }, 
                                            { validator: validateHardDiskSampleCount, trigger: 'change' }]">
                                            <el-input style="width: 100%" v-model="purchase.sampleCount"
                                                auto-complete="off"
                                      
                                                placeholder="请输入选购数量"></el-input>
                                        </el-form-item>
                                    </div>
                                   <div
                                        style="justify-content: center;display: flex;flex-wrap: wrap;margin-left: 10px;width: 50px;margin-right: 10px;">
                                        <el-button type="danger" size="mini" icon="el-icon-delete"
                                 
                                            @click="removeHardDiskPurchaseItem(index)"
                                            style="margin-bottom: 2px;"></el-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="formContract.contractType !== 'DEVELOPMENT'" style="width: 100%;">
                        <div v-if="['预付款扣款（测序分析）', '测序分析'].includes(formContract.projectType)"
                            style="display: flex;width: 100%">
                            <el-form-item label="补充分析要求" prop="analysisRequest" style="width: 100%!important;">
                                <div style="display: flex;align-items: center">
                                    <el-checkbox-group :disabled="['salesManagerEdits'].includes(operation)"
                                        v-model="formContract.moreAnalysis" class="checkbox-group">
                                        <el-checkbox label="SENIOR_ANALYSIS">高级分析</el-checkbox>
                                        <el-checkbox label="CUSTOMIZED_ANALYSIS">个性化分析</el-checkbox>
                                    </el-checkbox-group>
                                    <div style="width: 49%;margin-left: 25px;font-size: 14px;color: red;">
                                        <span>{{ '注：如有高级分析/个性化分析这里一定要登记，不登记不分析' }}</span>
                                    </div>
                                </div>
                            </el-form-item>
                        </div>
                        <div v-if="['预付款扣款（测序分析）', '测序分析'].includes(formContract.projectType) && formContract?.moreAnalysis.includes('SENIOR_ANALYSIS')"
                            style="display: flex;width: 100%">
                            <el-form-item label="高级分析金额" prop="seniorAnalysisAmount" style="width: 35%!important;"
                                :disabled="[ 'salesManagerEdits'].includes(operation)">
                                <el-input :disabled="[ 'salesManagerEdits'].includes(operation)"
                                    v-model="formContract.seniorAnalysisAmount" auto-complete="off"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="高级分析附件" prop="seniorAnalysisFile">
                                <div style="display:flex;width: 100%;align-items: center">
                                    <el-input v-model="seniorFileName" readonly style="flex:1"></el-input>
                                    <el-button size="small" style="margin-left:8px;flex-shrink:0"
                                        :disabled="[ 'salesManagerEdits'].includes(operation)"
                                        type="success" icon="el-icon-upload2"
                                        @click="$refs.seniorFileInput.click()">上传文件</el-button>
                                    <input ref="seniorFileInput" type="file" style="display:none"
                                        @change="(e) => handleFileSelect(e, 'senior')" />
                                </div>
                            </el-form-item>
                        </div>
                        <div v-if="['预付款扣款（测序分析）', '测序分析'].includes(formContract.projectType) && formContract?.moreAnalysis.includes('CUSTOMIZED_ANALYSIS')"
                            style="display: flex;width: 100%">
                            <el-form-item label="个性化分析金额" prop="customizedAnalysisAmount" style="width: 35%!important;"
                                :disabled="[ 'salesManagerEdits'].includes(operation)">
                                <el-input v-model="formContract.customizedAnalysisAmount" auto-complete="off"
                                    :disabled="[ 'salesManagerEdits'].includes(operation)"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="个性化分析附件" prop="customizedAnalysisFile">
                                <div style="display:flex;width: 100%;align-items: center">
                                    <el-input v-model="customizedFileName" readonly style="flex:1"></el-input>
                                    <el-button size="small" style="margin-left:8px;flex-shrink:0"
                                        :disabled="[ 'salesManagerEdits'].includes(operation)"
                                        type="success" icon="el-icon-upload2"
                                        @click="$refs.customizedFileInput.click()">上传文件</el-button>
                                    <input ref="customizedFileInput" type="file" style="display:none"
                                        @change="(e) => handleFileSelect(e, 'customized')" />
                                </div>
                            </el-form-item>
                        </div>
                    </div>
                    <div style="display:flex;align-items: center;width: 100%" v-if="formContract.contractType !== 'DEVELOPMENT' && ![ 'salesManagerEdits'].includes(operation)
                        && ['ADMIN', 'MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES', 'SALES_MANAGER'].includes(role)
                        && ['预付款扣款（测序分析）', '预付款扣款（裸测）', '测序分析', '裸测', '预付款'].includes(formContract.projectType)">
                        <div
                            style="width: 92%;align-items: center;border: 1px dashed #d9d9d9;padding-top:20px;margin-bottom: 20px;display:flex;flex-wrap: wrap;">

                            <el-form-item label="核酸抽提" prop="extractionFlag" style="width: 48%!important;"
                                v-if="formContract.projectType !== '预付款'">
                                <el-select v-model="formContract.extractionFlag" placeholder="请选择是否进行核酸抽提" filterable>
                                    <el-option v-for="item in flagOption" :key="item.value" :label="item.label"
                                        :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="抽提次数" prop="extractionNumber" style="width: 48%!important;"
                                v-if="formContract.projectType !== '预付款' && formContract.extractionFlag === true">
                                 <el-input v-model="formContract.extractionNumber"
                                    placeholder="请输入抽提次数（正整数）"></el-input>
                            </el-form-item>
                            <el-form-item label="添加水印" prop="watermarkFlag" style="width: 48%!important;"
                                v-if="companyIds.includes(Number(formContract.trusteeCompanyId))">
                                <el-select v-model="formContract.watermarkFlag" placeholder="请选择是否添加水印" filterable
                                    :disabled="Number(formContract.trusteeCompanyId) !== 1">
                                    <el-option v-for="item in flagOption" :key="item.value" :label="item.label"
                                        :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="付款方式" prop="methods" v-if="formContract.projectType !== '预付款'"
                                :rules="{ required: true, message: '请选择付款方式', trigger: 'change' }"
                                style="width: 48%!important;">
                                <el-select v-model="formContract.methods" placeholder="请选择">
                                    <el-option v-for="item in option" :key="item.value" :label="item.label"
                                        :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                v-if="formContract.methods === 'TWO_PAYMENTS' && formContract.projectType !== '预付款'"
                                prop="theFirstRatio" style="width: 48%!important;"
                                :rules="[{ required: true, message: '请输入首付款比例', trigger: 'change' },
                                { validator: (rule, value, callback) => checkMinMax(rule, value, callback, 0, 100), trigger: 'change' }]" label="首付款比例">
                                <el-input placeholder="请输入首付款比例" v-model="formContract.theFirstRatio"><template
                                        #append>%</template></el-input>
                            </el-form-item>
                        </div>
                        <div style="display: flex;margin-bottom: 20px;flex-wrap: wrap;width: 85px;margin-right: 10px;">
                            <el-button type="success" size="small" style="margin: 6px 10px 0 10px;"
                                @click="openTemplate">生成合同</el-button>
                            <el-button type="primary" size="small" style="margin: 6px 10px 0 10px;"
                                @click="downloadFile(templateFile.raw)"
                                :disabled="!templateFile">下载合同</el-button>
                            <el-button type="warning" size="small" style="margin: 6px 10px 0 10px;"
                                @click="usedTemplate"
                                :disabled="!templateFile">使用合同</el-button>
                        </div>
                    </div>
                   <div style="width: 96%;display:flex;flex-wrap: wrap;align-items: center" v-if="['add', 'edit', 'submit','change','adminEdits'].includes(operation) && !['预付款'].includes(formContract.projectType) && formContract.contractType !== 'DEVELOPMENT'">
                        <el-form-item label="价格申请截图" prop="priceFile" style="width: 100%!important;">
                            <div style="display:flex;align-items: center">
                                <el-input v-model="priceFileName" readonly style="flex:1"></el-input>
                                <el-button size="small" style="margin-left:8px;flex-shrink:0" type="success" icon="el-icon-upload2" @click="$refs.priceFileInput.click()">上传文件</el-button>
                                <input ref="priceFileInput" type="file" style="display:none"
                                    @change="(e) => handleFileSelect(e, 'price')" />
                                <div style="width: 54%;margin-left: 25px;font-size: 14px;color: red;">
                                    <span v-if="['add', 'edit', 'submit'].includes(operation)">{{
                                        '注：如合同价格低于报价表，请提供销售经理/程燕同意的截图' }}</span>
                                    <span v-else>{{ '注：如合同变更价格低于报价表，请重新上传销售经理/程燕同意的截图' }}</span>
                                </div>    
                            </div>
                        </el-form-item>
                    </div>
                   
                    <div style="width: 96%;display:flex;flex-wrap: wrap;align-items: center"
                        v-if="formContract.contractType !== 'DEVELOPMENT' && ![ 'salesManagerEdits'].includes(operation)">
                        <el-form-item label="原合同" v-if="['change'].includes(operation)" style="width: 100%!important;">
                            <div style="display:flex;align-items: center">
                                <el-input v-model="oldContractFile.name" readonly style="flex:1"></el-input>
                                <el-button size="small" type="primary" @click="downloadFile(oldContractFile.file.raw)" icon="el-icon-download" style="margin-left: 8px;"
                                    :disabled="!oldContractFile.file">下载合同</el-button>
                                <div style="width: 54%;margin-left: 25px;font-size: 14px;color: red;">
                                    <span>{{ '注：若合同有变更，请上传新合同' }}</span>
                                </div>
                            </div>
                        </el-form-item>
                    
                        <el-form-item label="合同附件" prop="contractFilePath" style="width: 100%!important;">
                            <div style="display:flex;align-items: center">
                                <el-input v-model="contractFileName" readonly style="flex:1"></el-input>
                                <el-button size="small" style="margin-left:8px;flex-shrink:0" type="success"
                                    icon="el-icon-upload2" @click="$refs.contractFileInput.click()">{{ ['change'].includes(operation) ?'上传新文件' :'上传文件'}}</el-button>
                                <input ref="contractFileInput" type="file" style="display:none"
                                    @change="(e) => handleFileSelect(e, 'contract')" />
                            </div>
                        </el-form-item>
                    </div>
                    <el-form-item style="width: 96%!important;" label="合同备注" prop="remark">
                        <el-input :autosize="{ minRows: 3 }" type="textarea" placeholder="请输入内容"
                            :disabled="['adminEdits', 'salesManagerEdits'].includes(operation)"
                            v-model="formContract.remark" maxlength="300" show-word-limit>
                        </el-input>
                    </el-form-item>

                </el-form>
                <div v-if="['add', 'edit', 'submit'].includes(operation) && formContract.contractType !== 'DEVELOPMENT'"
                    style="width: 100%!important;">
                    <span class="bold-text">{{ remindText }}</span>
                </div>
                <div
                    v-if="['add', 'edit', 'submit'].includes(operation) && !['DEVELOPMENT','CHARGEBACKS','TEAM'].includes(formContract.contractType)">

                        <el-divider></el-divider>
                        <el-switch v-model="isRecord" active-text="添加发票信息"></el-switch>
                        <br><br>
                        <el-form class="formDiv" v-if="isRecord"
                            label-width="125px" ref="formRecord" :model="formRecord" :rules="rulesRecord">
                            <el-form-item label="销售" prop="applicantId">
                                <el-select style="width: 87%;" v-model="formRecord.applicantId" placeholder="请选择销售"
                                    filterable>
                                    <el-option v-for="item in DrafterOptions" :key="item.uuid" :label="item.name"
                                        :value="item.uuid"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="申请日期" prop="applicationDate">
                                <el-input style="width: 87%;" v-model="formRecord.applicationDate" auto-complete="off"
                                    placeholder="请输入日期，格式yyyy-MM-dd"></el-input>
                            </el-form-item>
                            <el-form-item label="试剂清单">
                                <div style="display: flex;align-items: center">
                                    <el-input v-model="recordFileName" readonly style="width: 87%;"></el-input>
                                    <el-button size="small" type="danger" icon="el-icon-delete"
                                             style="margin-left: 8px" @click="handleRemove([], 'record')"></el-button>
                                    <el-button size="small" style="margin-left:8px;flex-shrink:0" icon="el-icon-upload2"
                                        type="success" @click="$refs.recordFileInput.click()"></el-button>
                                    <input ref="recordFileInput" type="file" style="display:none"
                                        @change="(e) => handleFileSelect(e, 'record')" />
                                </div>
                            </el-form-item>
                            <el-form-item label="可开票金额">
                                <el-input style="width: 87%;" v-model="formContract.contractAmount"
                                    auto-complete="off" disabled></el-input>
                            </el-form-item>
                            <div style="margin-left: 20px;margin-top:-15px;width: 50%">
                                <span class="bold-text">备注:</span><br>
                                <span class="bold-text">1.此处仅用于上传试剂清单。</span><br>
                                <span class="bold-text">2.如果需要把单价数量单位规格开到发票里,请在发票备注里写清楚。</span>
                            </div>
                            <div style="width: 100%">
                                <div style="display: flex;align-items: center"
                                    v-for="(invoiceInfo, index) in formRecord.invoiceInfos">
                                    <div style="display: flex;flex-wrap:wrap;width:98%" class="invoice-box">
                                        <el-form-item label="发票金额" :prop="'invoiceInfos.' + index + '.invoiceAmount'"
                                            style="width: 33%!important;" label-width="90px"
                                            :rules="[{ required: true, message: '请输入发票金额', trigger: 'change' }, { validator: checkNum, trigger: 'change' }]">
                                            <el-input v-model="invoiceInfo.invoiceAmount" auto-complete="off"
                                                placeholder="请输入发票金额"></el-input>
                                        </el-form-item>
                                        <el-form-item label="发票类型" :prop="'invoiceInfos.' + index + '.invoiceType'"
                                            style="width: 33%!important;" label-width="90px"
                                            :rules="{ required: true, message: '请选择发票类型', trigger: 'change' }">
                                            <el-select v-model="invoiceInfo.invoiceType" placeholder="请选择发票类型"
                                                filterable>
                                                <el-option v-for="item in invoiceTypeOptions" :key="item.label"
                                                    :label="item.label" :value="item.label"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="纳税人识别号" style="width: 33%!important;" label-width="100px">
                                            <el-input v-model="invoiceInfo.taxRegistrationNumber" disabled></el-input>
                                        </el-form-item>
                                        <el-form-item label="开票公司" label-width="90px"
                                            :prop="'invoiceInfos.' + index + '.billingUnitId'"
                                            style="width: 50%!important;"
                                            :rules="{ required: true, message: '请选择开票公司', trigger: 'change' }">
                                            <el-select v-model="invoiceInfo.billingUnitId" placeholder="请选择开票公司"
                                                filterable>
                                                <el-option v-for="item in businessOption" :key="item.id"
                                                    :label="item.companyName" :value="item.id"
                                                    :disabled="!item['companyInvoiceStatus']"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="发票抬头" style="width: 49%!important;" label-width="90px"
                                            :prop="'invoiceInfos.' + index + '.invoiceTitleId'"
                                            :rules="{ required: true, message: '请选择发票抬头', trigger: 'change' }">
                                            <el-select v-model="invoiceInfo.invoiceTitleId" filterable
                                                placeholder="请选择发票抬头"
                                                @change="(value) => selectTitle(invoiceInfo, value)">
                                                <el-option v-for="item in companyOption" :key="item.id"
                                                    :label="item.companyName" :value="item.id"></el-option>
                                            </el-select>
                                        </el-form-item>

                                        <el-form-item label="发票内容" style="width: 100%!important;" label-width="90px"
                                            :prop="'invoiceInfos.' + index + '.invoiceContent'"
                                            :rules="{ required: true, message: '请输入发票内容', trigger: 'change' }">
                                            <el-input type="textarea" v-model="invoiceInfo.invoiceContent"
                                                :autosize="{ minRows: 3 }" show-word-limit maxlength="300"
                                                auto-complete="off" placeholder="请输入发票内容，例如:测序费 测试费 测序分析费"></el-input>
                                        </el-form-item>
                                        <el-form-item label="发票备注" :prop="'invoiceInfos.' + index + '.remark'"
                                            label-width="90px" style="width: 100%!important;">
                                            <el-input type="textarea" v-model="invoiceInfo.remark" auto-complete="off"
                                                :autosize="{ minRows: 3 }" show-word-limit maxlength="300"
                                                placeholder="注:如果需要把单价数量单位规格开到发票里,请在发票备注里写清楚。"></el-input>
                                        </el-form-item>
                                    </div>
                                    <div
                                        style="justify-content: center;display: flex;flex-wrap: wrap;margin-left: 10px;width: 50px;margin-right: 10px;">
                                        <el-button type="danger" size="mini" icon="el-icon-delete"
                                            @click="handleDelete(invoiceInfo)"
                                            style="margin-bottom: 2px;"></el-button>
                                        <el-button size="mini" icon="el-icon-plus" type="success"
                                            style="margin: 1px 0 0;"
                                            v-if="index === formRecord.invoiceInfos.length - 1"
                                            @click="handleAdd"></el-button>
                                    </div>
                                </div>
                            </div>
                            <div v-if="formRecord.invoiceInfos.length > 1" style="display: flex;flex-wrap: wrap;width: 100%;">
                               <el-form-item label="是否可连号"
                                    prop="connectedFlag">
                                    <el-select style="width: 87%;" v-model="formRecord.connectedFlag"
                                        placeholder="请选择是否可连号" filterable>
                                        <el-option v-for="item in SFOptions" :key="item.label" :label="item.name"
                                            :value="item.label"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="是否同一天"
                                    prop="sameDayFlag">
                                    <el-select style="width: 87%;" v-model="formRecord.sameDayFlag"
                                        placeholder="请选择是否同一天" filterable>
                                        <el-option v-for="item in SFOptions" :key="item.label" :label="item.name"
                                            :value="item.label"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item v-if="formRecord.sameDayFlag === 0" label="开票日期备注" prop="remark" style="width: 92%!important;">
                                    <el-input type="textarea" v-model="formRecord.remark" auto-complete="off"
                                        :autosize="{ minRows: 3 }" show-word-limit maxlength="300"></el-input>
                                </el-form-item>
                            </div>
                            
                            <div style="width: 100%!important;">
                                <span class="bold-text">注:如需邮寄/扫描，请点击下方开关"添加邮寄/扫描信息"。</span>
                            </div>
                        </el-form>
                </div>
                <div
                    v-if="['add', 'edit', 'submit'].includes(operation) && (formContract.contractType !== 'DEVELOPMENT' || targetList.includes(formContract.projectType))">
                    <el-divider></el-divider>
                    <el-switch v-model="isMail" active-text="添加邮寄/扫描信息"></el-switch>
                    <br><br>
                    <el-form class="formDiv" v-if="isMail" label-width="120px" ref="formMail" :model="formMail"
                        :rules="rulesMail">
                        <div style="width: 100%;margin-bottom: 20px;text-align: center"
                            v-if="!(formContract.contractType === 'DEVELOPMENT' && targetList.includes(formContract.projectType))">
                            <el-table :fit="false" style="width: 917px;display: inline-block" border
                                :data="!isRecord ? tableData : tableData.slice(0, -1)">
                                <el-table-column label="邮寄说明" width="90" prop="name"></el-table-column>
                                <el-table-column label="是否邮寄" width="88" align="center">
                                    <template slot-scope="scope">
                                        <el-form-item label-width="0" :prop="'mailingContent.' + scope.row.mailProp"
                                            v-if="scope.row.mailProp" style="width: 100%!important;margin-bottom: 0"
                                            :rules="{ required: true, message: scope.row.mailMessage, trigger: 'change' }">
                                            <el-select style="width: 100%;"
                                                v-model="formMail.mailingContent[scope.row.mailProp]"
                                                @change="(value) => changeMailNumber(value, scope.row.type)"
                                                class="no-border-select" :placeholder=scope.row.mailMessage>
                                                <el-option
                                                    v-for="item in numberOption.slice(scope.row.min, scope.row.max)"
                                                    :key="item.value" :label="item.label"
                                                    :value="item.value"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <span v-else>{{ 'NA' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="是否扫描" width="88" align="center">
                                    <template slot-scope="scope">
                                        <el-form-item label-width="0" :prop="'mailingContent.' + scope.row.scanningProp"
                                            v-if="scope.row.scanningProp" style="width: 100%!important;margin-bottom: 0"
                                            :rules="{ required: true, message: scope.row.scanningMessage, trigger: 'change' }">
                                            <el-select style="width: 100%;"
                                                v-model="formMail.mailingContent[scope.row.scanningProp]"
                                                @change="(value) => changeMailNumber(value, scope.row.type)"
                                                class="no-border-select" :placeholder=scope.row.scanningMessage>
                                                <el-option v-for="item in flagOption" :key="item.value"
                                                    :label="item.label" :value="item.value"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <span v-else>{{ 'NA' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="上传文件" width="350" align="center">
                                    <template slot-scope="scope">
                                        <el-form-item style="width: 100%!important;margin-bottom: 0" label-width="0"
                                            v-if="scope.row.file">
                                            <div style="display: flex; align-items: center; width: 100%;">
                                                <div style="width: 86%!important;">
                                                    <div style="width: 100%!important;margin-bottom: 2px;"
                                                        v-if="$data[scope.row.fileList].length > 0"
                                                        v-for="(fileItem, fileIndex) in $data[scope.row.fileList]">
                                                        <div style="display: flex;width: 100%!important;">
                                                            <el-input v-model="fileItem.name" readonly
                                                                style="margin-right: 5px;"></el-input>
                                                            <div>
                                                                <el-button type="danger" icon="el-icon-delete"
                                                                    size="small"
                                                                    @click="handleRemove([fileIndex], scope.row.type)"></el-button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="$data[scope.row.fileList].length <= 0"
                                                        style="display: flex;width: 100%!important;">
                                                        <el-input v-if="$data[scope.row.fileList].length <= 0"
                                                            v-model="$data[scope.row.fileName]"
                                                            style="margin-right: 5px;" readonly></el-input>
                                                        <div>
                                                            <el-button type="danger" icon="el-icon-delete"
                                                                size="small"></el-button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <el-button type="success" icon="el-icon-upload2"
                                                    size="small" style="margin-left:8px;flex-shrink:0"
                                                    @click="$refs['mailFileInput_' + scope.row.type].click()"></el-button>
                                                <input :ref="'mailFileInput_' + scope.row.type" type="file"
                                                    style="display:none" multiple :limit="5"
                                                    @change="(e) => handleFileSelect(e, scope.row.type, true)" />

                                            </div>
                                        </el-form-item>
                                        <span v-else>{{ 'NA' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="备注" width="300" align="center">
                                    <template slot-scope="scope">
                                        <el-form-item label-width="0" style="width: 100%!important;margin-bottom: 0"
                                            :prop="'mailingContent.' + scope.row.remark" v-if="scope.row.remark">
                                            <el-input v-model="formMail.mailingContent[scope.row.remark]"
                                                auto-complete="off" class="no-border-select" type="textarea"
                                                :autosize="{ minRows: 1 }" show-word-limit maxlength="300"
                                                :placeholder=scope.row.remarkMessage style="width: 100%;"></el-input>
                                        </el-form-item>
                                        <span v-else>{{ 'NA' }}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div style="text-align: left;margin-left: 6%"><span class="bold-text">{{
                                    '备注:1.客户需要报账合同等及其他报账资料需要单独在邮寄/扫描模块内选择"报账资料"上传附件' }}</span>
                                <el-tooltip content="折叠" v-if="showRemark">
                                    <i class="el-icon-caret-top iconMore" @click="showRemark = !showRemark"></i>
                                </el-tooltip>
                                <el-tooltip content="展开" v-if="!showRemark">
                                    <i class="el-icon-caret-bottom iconMore" @click="showRemark = !showRemark"></i>
                                </el-tooltip><br>
                                <span class="bold-text" v-if="showRemark">{{
                                    '2.需要注意的是报账合同尽量用实际项目的合同，如果不一致，合同要合法并符合公司规定(公司涉及到的正常项目及公司正常报价范围)' }}</span><br>
                                <span class="bold-text" v-if="showRemark">{{
                                    '3.尽量不要开试剂票，开了的，公司不提供任何图片和实物。没有按照以上操作的，后果销售自己承担。' }}</span><br>
                                <span class="bold-text" v-if="showRemark">{{ '4.上传文件可上传多个文件，最大上传数量不能超过5,上传文件总大小不能超过50M。'
                                    }}</span>
                            </div>
                        </div>
                        <el-form-item label="销售" prop="applicantId">
                            <el-select style="width: 87%;" v-model="formMail.applicantId" placeholder="请选择销售"
                                filterable>
                                <el-option v-for="item in DrafterOptions" :key="item.uuid" :label="item.name"
                                    :value="item.uuid"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="申请日期" prop="applicantDate" >
                            <el-input style="width: 87%;" v-model="formMail.applicantDate" auto-complete="off"
                                placeholder="请输入日期，格式yyyy-MM-dd"></el-input>
                        </el-form-item>
                        <el-form-item label="收件人" prop="recipientName"
                            :rules="{ required: flag, message: '请输入收件人名称', trigger: 'change' }">
                            <el-autocomplete class="inline-input" v-model="formMail.recipientName"
                                :fetch-suggestions="querySearch" placeholder="请输入收件人名称" @select="handleSelect"
                                style="width: 87%;">
                            </el-autocomplete>
                        </el-form-item>
                        <el-form-item label="收件人电话" prop="recipientPhone" 
                            :rules="{ required: flag, message: '请输入收件人电话', trigger: 'change' }">
                            <el-input style="width: 87%;" v-model="formMail.recipientPhone"
                                placeholder="请输入收件人电话"></el-input>
                        </el-form-item>
                        <el-form-item label="收件地址" prop="recipientAddress"
                            :rules="{ required: flag, message: '请输入收件地址', trigger: 'change' }">
                            <el-input style="width: 87%;" v-model="formMail.recipientAddress"
                                placeholder="请输入收件地址"></el-input>
                        </el-form-item>
                        <el-form-item label="邮寄备注" prop="remark" style="width: 92%!important;">
                            <el-input :autosize="{ minRows: 3 }" type="textarea" maxlength="300" show-word-limit
                                placeholder="请输入内容" v-model="formMail.remark"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" class="title" @click="cancel">取消</el-button>
                <el-button v-if="['add', 'edit'].includes(operation)" size="small" type="primary" class="title"
                    @click="handleDraft">保存到草稿箱</el-button>
                <el-button size="small" type="success" class="title" @click="handle">提交</el-button>
            </div>
        </el-dialog>
        <loading :loading="loading || dataLoading" :load-text="loading ? '提交中' : '数据加载中'"></loading>
    </div>
</template>

<script>
import { getEvaluators, getPersonById, getPersonByType } from "@/api/dilivery/customer/person";
import { getCompanyPage } from "@/api/dilivery/company";
import { addDraft, downloadAttachment, editDraft, downloadProjectDraft } from "@/api/dilivery/draft";
import { getDataInLocalStorage } from "@/utils/localStorage";
import { check, checkDate, checkInclude, checkMinMax, checkNum, checkNumber, checkSize, checkSum, checkSumAmount, checkCharacter, checkTeamContractAmount } from "@/utils/rules";
import { formatNumberWithUnit, padDate } from "@/store/date";
import { addContractRecordMail, adminEdit, attachmentContract, changeContract, editContractRecordMail, getContractNumber, downloadProjectAnnex, getAllContract } from "@/api/dilivery/sales/contract";
import { getAllCompanyName } from "@/api/dilivery/customer/company";
import { getUserAmountById, getUserById } from "@/api/dilivery/customer/user";
import { getMaterialType } from "@/api/dilivery/material/lexicon";
import { getProjectList } from "@/api/dilivery/project";
import { copyText } from "@/utils/windowsUtils";
import { downloadRecord } from "@/api/dilivery/record";
import { attachmentMail } from "@/api/dilivery/mail";
import { templateGeneration } from "@/api/dilivery/template";
import { fileDownload } from "@/utils/downFileUtils";
import JSZip from 'jszip';
import Loading from "@/components/loading/Loading.vue"
import Decimal from 'decimal.js';
import { getConfigPage } from "@/api/dilivery/sysconfig";

export default {
    name: "AddEditCRM",
    props: ['showDialog', 'selectDetail', 'operation', 'invoiceSelectDetail', 'mailSelectDetail'],
    components: {
        Loading
    },
    data() {
        return {
            oldContractFile:{
                name:'',
                file:null
            },
            gutSalesList: [],
            targetList: [
                "单细胞保护液",
                "微生态保护剂",
                "微生态保护液",
                "肠道菌群检测样本采集套装（16s全长）",
                "肠道菌群检测样本采集套装（宏基因组）",
                "RNA保护剂"
            ],
            detailLoading: {
                mailLoading: false,
                recordLoading: false,
                contractLoading: false
            },
            proportionOptions: [
                { label: '1%', value: 0.01 },
                { label: '2%', value: 0.02 },
                { label: '3%', value: 0.03 },
                { label: '4%', value: 0.04 },
                { label: '5%', value: 0.05 },
                { label: '6%', value: 0.06 },
                { label: '7%', value: 0.07 },
                { label: '8%', value: 0.08 },
                { label: '9%', value: 0.09 },
                { label: '10%', value: 0.10 }
            ],
            addedTypeOptions: [
                {
                    label: '是', value: true, children: [
                        { label: '金额', value: 'number' },
                        { label: '比例', value: 'proportion' }
                    ]
                },
                { label: '否', value: false },
            ],
            dataLoading: false,
            loading: false,
            specsOption: ['2ml', '5ml'],
            showRemark: true,
            option: [{ label: '全款', value: 'FULL_AMOUNT' }, { label: '2次付款（首付款，尾款）', value: 'TWO_PAYMENTS' }],
            tableData: [
                {
                    id: 1,
                    name: '合同',
                    mailProp: 'numberOfContract',
                    mailMessage: '请选择合同邮寄份数',
                    type: 'contract',
                    min: 0,
                    max: 11,
                    scanningProp: 'contractScanningFlag',
                    scanningMessage: '请选择是否扫描合同',
                    file: '',
                    fileName: '',
                    fileList: '',
                    remark: 'contractExplain',
                    remarkMessage: '请填写合同具体邮寄说明'
                },
                // {
                //   id: 2,
                //   name: '发票',
                //   mailProp: 'numberOfInvoice',
                //   mailMessage: '请选择发票邮寄份数',
                //   type: 'invoice',
                //   min: 0,
                //   max: 11,
                //   scanningProp: '',
                //   scanningMessage: '',
                //   file: '',
                //   fileName: '',
                //   fileList: '',
                //   remark: 'invoiceExplain',
                //   remarkMessage: '请填写发票具体邮寄说明'
                // },
                {
                    id: 3,
                    name: '营业执照',
                    mailProp: 'numberOfLicense',
                    mailMessage: '请选择营业执照邮寄份数',
                    type: 'license',
                    min: 0,
                    max: 4,
                    scanningProp: '',
                    scanningMessage: '',
                    file: '',
                    fileName: '',
                    fileList: '',
                    remark: 'licenseExplain',
                    remarkMessage: '请填写营业执照具体邮寄说明'
                },
                {
                    id: 4,
                    name: '结题报告',
                    mailProp: 'numberOfReport',
                    mailMessage: '请选择结题报告邮寄份数',
                    type: 'report',
                    min: 0,
                    max: 6,
                    scanningProp: 'reportScanningFlag',
                    scanningMessage: '请选择是否扫描结题报告',
                    file: 'reportFile',
                    fileName: 'reportFileName',
                    fileList: 'reportFileList',
                    remark: 'reportExplain',
                    remarkMessage: '请填写结题报告具体邮寄说明'
                },
                {
                    id: 5,
                    name: '报账资料',
                    mailProp: 'numberOfReimbursementFile',
                    mailMessage: '请选择邮寄报账资料份数',
                    type: 'reimbursement',
                    min: 0,
                    max: 6,
                    scanningProp: 'reimbursementScanningFlag',
                    scanningMessage: '请选择是否扫描报账资料',
                    file: 'reimbursementFile',
                    fileName: 'reimbursementFileName',
                    fileList: 'reimbursementFileList',
                    remark: 'reimbursementExplain',
                    remarkMessage: '请填写报账资料具体邮寄说明'
                },
                {
                    id: 6,
                    name: '邮寄资料',
                    mailProp: 'numberOfSingleMailFile',
                    mailMessage: '请选择邮寄资料份数',
                    type: 'mail',
                    min: 0,
                    max: 6,
                    scanningProp: '',
                    scanningMessage: '',
                    file: 'mailAttachment',
                    fileName: 'mailFileName',
                    fileList: 'mailFileList',
                    remark: 'singleMailFileExplain',
                    remarkMessage: '请填写先邮寄资料邮寄说明'
                }
            ],
            numberOption: [
                { label: '否', value: 0 },
                { label: '1份', value: 1 },
                { label: '2份', value: 2 },
                { label: '3份', value: 3 },
                { label: '4份', value: 4 },
                { label: '5份', value: 5 },
                { label: '6份', value: 6 },
                { label: '7份', value: 7 },
                { label: '8份', value: 8 },
                { label: '9份', value: 9 },
                { label: '10份', value: 10 }
            ],
            flagOption: [
                { label: '是', value: true },
                { label: '否', value: false },
            ],
            isHandlingSpecificProjectType: false,
            isHandlingMaterials: false,
            seniorFileName: '',
            customizedFileName: '',
            contractFileName: '',
            mailFileName: '',
            reportFileName: '',
            reimbursementFileName: '',
            AnalysisEvaluate: [],
            businessOption: [],
            companyOption: [],
            ContactOptions: [],
            LexiconOptions: [],
            ProjectOption: [],
            enforceContractLoading: false,
            TypeOption: [
                { label: 'NGS', name: '二代测序', disabled: [] },
                { label: 'AMPLICON', name: '扩增子测序', disabled: [] },
                { label: 'TGG', name: '三代测序', disabled: [] },
                { label: 'METAPRO', name: '蛋白代谢组测序', disabled: [] },
                // { label: '硬盘购买', name: '硬盘购买', disabled: [] },
                { label: 'PCR', name: '其他', disabled: ['裸测', '预付款扣款（裸测）'] },
                { label: 'IGUT', name: 'IGUT', disabled: ['测序分析', '预付款扣款（测序分析）'] },
            ],
            invoiceTypeOptions: [
                { label: '全电普票' },
                { label: '全电专票' },
            ],
            SFOptions: [
                { label: 1, name: '是' },
                { label: 0, name: '否' }
            ],
            isMail: false,
            isRecord: false,
            userData: {},
            role: '',
            templateFile: null,
            contractGenerationFlag:false,
            contractFileList: [],
            mailFileList: [],
            reportFileList: [],
            seniorFileList: [],
            reimbursementFileList: [],
            customizedFileList: [],
            DateOptions: [
                { label: '1', name: '1年' },
            ],
            title: '添加合同信息',
            UserOptions: [],
            DrafterOptions: [],
            TypeOptions: [
                { label: 'PREPAYMENTS', name: '预付款' },
                { label: 'IMPORT_PREPAYMENTS', name: '老系统预付款' },
                { label: 'FORMAL', name: '正式' },
                { label: 'CHARGEBACKS', name: '扣款' },
                { label: 'DEVELOPMENT', name: '研发' },
                { label: 'TEAM', name: '团队费用' }
            ],
            priceFileList:[],
            priceFileName:'',
            showHardDiskPurchaseInfo: false,
            formContract: {
                projectAnnexFiles:{},
                protectiveFluidInfo:{
                    protectiveFluidMethod:null,
                    doorInfo:{
                        doorFee:'',
                        phone:'',
                        address:'',
                        doorTime:''
                    },
                    materialMailInfo:{
                        recipient:'',
                        phone:'',
                        address:'',
                        mailTime:'',
                    }
                },
                sampleManagement: null,
                generateContractInfo: {
                    extractionFlag: false,
                    watermarkFlag: false,
                    returnSampleBo: {
                        reason: '',
                        returnSampleAmount: 0,
                        returnSampleFlag: false
                    },
                    extractionNumber: '',
                    paymentMethods: {}
                },
                watermarkFlag: false,
                extractionFlag: false,
                extractionNumber: '',
                returnSampleAmount: {},
                methods: 'FULL_AMOUNT',
                theFirstRatio: '',
                moreAnalysisRequest: {},
                returnFlag: false,
                sampleAmount: 0,
                reason: '',
                specificProjectType: [
                    {
                        dataAmountUnit: '',                // 数据量单位
                        experimentalProcessItems: [],      // 实验过程项
                        experimental: [],                  // 实验过程
                        sequencingPlatform: '',            // 二代检测平台
                        sequencingPlatformList: [],        // 二代平台选项
                        thirdSequencingPlatform: '',       // 三代检测平台
                        tesThirdSequencingPlatform:'',
                        thirdSequencingPlatformList: [],   // 三代平台选项
                        projectSampleDataList: [],         // 样品数据列表
                        minSampleCount: '',
                        maxSampleCount: '',
                        projectMainTypeId: '',
                        projectType: '',
                        projectClassification: '',
                        numberOfSamples: 0,
                        projectAmount: 0,
                        sizeOfSampleData: {},
                        analysisList: [],
                        analysis: '标准分析',
                        multipleChoice: false,
                        analysisChoiceList: [],
                        labList: [],
                        analyzeRequirements: ''
                    }
                ],
                moreAnalysis: [],
                analysisRequest: 'STANDARD_ANALYSIS',
                materials: [
                    {
                        materialId: '',
                        materialNumber: '',
                        remainingNumber: '',
                        specs: ''
                    }
                ],
                hardDiskPurchaseInfo: [],
                pureAnalysisInfo: {
                    pureAnalysisType: '',
                    contracts: [
                        {
                            contractId: '',
                            projectIds: [],
                            options: []
                        }
                    ]
                },
                pureAnalysisEvaluateId: '',
                contractFilePath: null,
                seniorAnalysisFile: null,
                customizedAnalysisFile: null,
                seniorAnalysisAmount: 0,
                customizedAnalysisAmount: 0,
                expirationDate: '1',
                contractType: 'FORMAL',
                contractDraftingDate: '',
                contractAmount: 0,
                salesId: '',
                customerContactsId: '',
                addedAmount: 0,
                addedType: false,
                addedProportion: '',
                signingDate: '',
                signingPlace: '上海',
                remainingAmount: 0,
                contractNumber: '',
                contractName: '',
                trusteeCompanyId: '1',
                trusteeContactsId: '',
                projectType: '测序分析',
                remark: '',
                priceFile: null
            },
            form: {
                dataSheet: 'sequencing_contract',
                draftContent: ''
            },
            rulesContract: {
                contractDraftingDate: [
                    { required: true, message: '请选择合同拟定时间', trigger: 'change' },
                    { validator: checkDate, trigger: 'change' }
                ],
                salesId: [
                    { required: true, message: '请选择销售', trigger: 'change' }
                ],
                contractType: [
                    { required: true, message: '请选择合同分类', trigger: 'change' }
                ],
                sampleManagement: [
                    { required: true, message: '请选择样品处理方式', trigger: 'change' }
                ],
                projectType: [
                    { required: true, message: '请选择合同类型', trigger: 'change' }
                ],
                contractAmount: [
                    { required: true, message: '请输入合同金额', trigger: 'change' },
                    {
                        validator: (rule, value, callback) => {
                            try {
                                if (['DEVELOPMENT'].includes(this.formContract.contractType)) {
                                    return callback();
                                }
                                if (isNaN(value)) {
                                    return callback(new Error('请输入数字值'));
                                }
                                if (['adminEdits', 'salesManagerEdits'].includes(this.operation)) {
                                    if (value < (Number(this.selectDetail.contractAmount) - Number(this.selectDetail.invoicedAmount))) {
                                        return callback(new Error('金额低于已开票金额'));
                                    }
                                }
                                if (['adminEdits', 'salesManagerEdits'].includes(this.operation) || ['预付款扣款（返样/暂存样品）', '返样/暂存样品'].includes(this.formContract.projectType)) {
                                    if (value < 0) {
                                        return callback(new Error('金额必须不小于0'));
                                    }
                                } else {
                                    if (!value && value !== 0) {
                                        return callback();
                                    }
                                    if (value <= 0) {
                                        return callback(new Error('金额必须大于0'));
                                    }
                                }
                                return callback();
                            } catch (e) {
                                return callback(new Error('合同金额校验失败'));
                            }
                        },
                        trigger: 'change'
                    }
                ],
                addedAmount: [
                    { required: true, message: '请输入增值金额', trigger: 'change' },
                    { validator: checkNum, trigger: 'change' },
                    {
                        // 增值金额必须为整数（仅当选择金额类型时生效）
                        validator: (rule, value, callback) => {
                            try {
                                // 非金额类型不校验整数要求
                                if (this.formContract.addedType !== 'number') {
                                    return callback();
                                }
                                if (this.role === 'ADMIN') {
                                    return callback();
                                }
                                const aa = new Decimal(value || 0);
                                if (!aa.isInteger()) {
                                    return callback(new Error('增值金额必须为整数'));
                                }
                                return callback();
                            } catch (e) {
                                return callback(new Error('增值金额校验失败'));
                            }
                        },
                        trigger: 'change'
                    },
                    {
                        // 增值金额不能超过合同金额的 10%
                        validator: (rule, value, callback) => {
                            try {
                                const ca = new Decimal(this.formContract.contractAmount || 0);
                                const aa = new Decimal(value || 0);
                                if (ca.lte(0)) {
                                    return callback(new Error('请先输入合同金额'));
                                }
                                const max = ca.mul(new Decimal(0.1));
                                if (aa.gt(max)) {
                                    return callback(new Error('增值金额不能超过合同金额的10%'));
                                }
                                return callback();
                            } catch (e) {
                                return callback(new Error('增值金额校验失败'));
                            }
                        },
                        trigger: 'change'
                    }
                ],
                addedType: [
                    { required: true, message: '请选择增值类型', trigger: 'change' }
                ],
                addedProportion: [
                    { required: true, message: '请选择增值比例', trigger: 'change' }
                ],
                contractNumber: [
                    { required: true, message: '请获取合同编号', trigger: 'change' }
                ],
                contractName: [
                    { required: true, message: '请输入合同名称', trigger: 'change' },
                    { validator: checkCharacter, trigger: 'change' }
                ],
                signingDate: [
                    { required: true, message: '请选择签订时间', trigger: 'change' },
                    { validator: checkDate, trigger: 'change' }
                ],
                signingPlace: [
                    { required: true, message: '请输入签订地点', trigger: 'change' }
                ],
                expirationDate: [
                    { required: true, message: '请选择有效期限', trigger: 'change' }
                ],
                customerContactsId: [
                    { required: true, message: '请选择甲方联系人', trigger: 'change' }
                ],
                trusteeCompanyId: [
                    { required: true, message: '请选择乙方(受托方)', trigger: 'change' }
                ],
                trusteeContactsId: [
                    { required: true, message: '请选择乙方联系人', trigger: 'change' }
                ],
                contractFilePath: [
                    {
                        validator: (rule, value, callback) => {
                            try {
                                if (['预付款扣款（返样/暂存样品）', '返样/暂存样品'].includes(this.formContract.projectType)) {
                                    return callback(); // 不需要校验
                                }
                                if(['change'].includes(this.operation)){
                                    return callback(); // 不需要校验
                                }
                                if (!value) {
                                    return callback(new Error('请上传附件'));
                                }
                                return callback();
                            } catch (e) {
                                return callback(new Error('合同校验失败'));
                            }
                        },
                        trigger: 'change'
                    }
                ],
                // pureAnalysisEvaluateId: [
                //     { required: true, message: '请选择纯分析评估人', trigger: 'change' }
                // ],
                analysisRequest: [
                    { required: false, message: '请选择分析要求', trigger: 'change' }
                ],
                seniorAnalysisFile: [
                    { required: true, message: '请上传高级分析附件', trigger: 'change' }
                ],
                customizedAnalysisFile: [
                    { required: true, message: '请上传个性化分析附件', trigger: 'change' }
                ],
                customizedAnalysisAmount: [
                    { required: true, message: '请输入个性化分析金额', trigger: 'change' },
                    { validator: ['adminEdits', 'salesManagerEdits'].includes(this.operation) ? checkNumber : checkNum, trigger: 'change' }
                ],
                seniorAnalysisAmount: [
                    { required: true, message: '请输入高级分析金额', trigger: 'change' },
                    { validator: ['adminEdits', 'salesManagerEdits'].includes(this.operation) ? checkNumber : checkNum , trigger: 'change' }
                ],
                returnFlag: [
                    { required: true, message: '请选择是否返样', trigger: 'change' },
                ],
                sampleAmount: [
                    { required: true, message: '请输入服务费(返样)', trigger: 'change' },
                    { validator: checkNumber, trigger: 'change' }
                ],
                extractionFlag: [
                    { required: true, message: '请选择是否进行核酸抽提', trigger: 'change' },
                ],
                extractionNumber: [
                                      {
                       // 仅当 extractionFlag 为 true 时校验为正整数
                                       validator: (rule, value, callback) => {
                                         try {
                                                 if (!this.formContract.extractionFlag) {
                                                        return callback(); // 不需要校验
                                                      }
                                                       if (value === '' || value === null || value === undefined) {
                                                             return callback(new Error('请输入抽提次数'));
                                                           }
                                                     const n = Number(value);
                                                       if (!Number.isInteger(n) || n <= 0) {
                                                            return callback(new Error('抽提次数必须为正整数'));
                                                         }
                                                      return callback();
                                               } catch (e) {
                                                         return callback(new Error('抽提次数校验失败'));
                                                    }
                                          },
                                      trigger: 'change'
                                 }
                         ],
                watermarkFlag: [
                    { required: true, message: '请选择是否添加水印', trigger: 'change' },
                ],
                reason: [
                    { required: true, message: '请填写服务费(返样)为0的原因', trigger: 'change' },
                ]
            },
            formMail: {
                reportFile: [],
                appendixExist: true,
                status: 'APPLYING',
                mailAttachment: [],
                applicantId: '',
                applicantDate: '',
                reimbursementFile: [],
                mailingContent: {
                    contractExplain: '',
                    invoiceExplain: '',
                    reportExplain: '',
                    licenseExplain: '',
                    contractScanningFlag: false,
                    reportScanningFlag: false,
                    reimbursementScanningFlag: false,
                    numberOfContract: 0,//邮寄合同数量
                    numberOfInvoice: 0,//邮寄发票数量
                    numberOfReport: 0,//邮寄报告数量
                    numberOfLicense: 0,//营业执照数量
                    numberOfReimbursementFile: 0,//报账资料份数
                    numberOfSingleMailFile: 0,
                    reimbursementExplain: '',//报账资料说明
                    singleMailFileExplain: ''//单独邮寄文件说明
                },
                recipientName: '',
                remark: '',
                recipientPhone: '',
                recipientAddress: ''
            },
            recordFileName: '',
            recordFileList: [],
            formRecord: {
                invoiceRecordFile: null,
                invoiceInfos: [{
                    billingUnitId: '1',//开票单位
                    invoiceTitleId: '',
                    invoiceAmount: 0,
                    invoiceType: '',
                    invoiceContent: '',
                    remark: ''
                }],
                invoiceIds: [],
                status: 'APPLYING',
                applicantId: '',
                contractNumbers: [],
                applicationDate: '',
                connectedFlag: '',
                sameDayFlag: '',
                remark:""
            },
            rulesRecord: {
                applicantId: [
                    { required: true, message: '请选择销售', trigger: 'change' }
                ],
                applicationDate: [
                    { required: true, message: '请选择申请日期', trigger: 'change' },
                    { validator: checkDate, trigger: 'change' }
                ],
                connectedFlag: [
                    { required: true, message: '请选择是否可连号', trigger: 'change' }
                ],
                sameDayFlag: [
                    { required: true, message: '请选择是否同一天', trigger: 'change' }
                ],
                remark: [
                    { required: true, message: '请填写开票日期备注', trigger: 'change' }
                ]
            },
            rulesMail: {
                applicantId: [
                    { required: true, message: '请选择销售', trigger: 'change' }
                ],
                applicantDate: [
                    { required: true, message: '请选择申请日期', trigger: 'change' },
                    { validator: checkDate, trigger: 'change' }
                ],
            },
        }
    },
    computed: {

        protectiveFluidMail() {
            return this.selectDetail.protectiveFluidMail || []
        },
        materialNumber() {
            return this.formContract.materials.reduce((acc, item) => {
                if (!acc[item.materialId]) {
                    acc[item.materialId] = 0; // 初始化该 id 的总和
                }
                acc[item.materialId] += Number(item.materialNumber); // 累加 number
                return acc;
            }, {});
        },
        companyIds() {
            return this.businessOption.filter(item => item.companyName.includes('凌恩')).map(item => Number(item.id))
        },
        projectTypeList() {
            return this.formContract.specificProjectType.map(item => item.projectType)
        },
        remindText() {
            if (['FORMAL', 'PREPAYMENTS'].includes(this.formContract.contractType)) {
                return '注:如需开票，请点击下方开关"添加发票信息"；如需邮寄，请点击下方开关"添加邮寄/扫描信息"。'
            } else if (['CHARGEBACKS','TEAM'].includes(this.formContract.contractType)) {
                return '注:如需邮寄，请点击下方开关"添加邮寄/扫描信息"。'
            } else {
                return ''
            }
        },
        flag() {
            const choseFlag = ['numberOfContract', 'numberOfInvoice', 'numberOfReport', 'numberOfLicense', 'numberOfReimbursementFile', 'singleMailFileExplain']
            for (const key of choseFlag) {
                if (this.formMail.mailingContent[key]) {
                    return true
                }
            }
            return !(this.formMail.mailingContent.contractScanningFlag || this.formMail.mailingContent.reportScanningFlag || this.formMail.mailingContent.reimbursementScanningFlag);
        },
        maxAmount() {
            return this.formContract.specificProjectType.map(item => {
                const amount = Number(item.projectAmount); // 将可能的字符串形式转换为数字
                return amount > 0 ? amount : 0; // 如果为大于0的数字，返回自身，否则返回0
            }).reduce((sum, amount) => sum + amount, 0)
        },
        hardDiskPurchaseAmount() {
            if (!Array.isArray(this.formContract.hardDiskPurchaseInfo)) {
                return 0;
            }
            return this.formContract.hardDiskPurchaseInfo.reduce((sum, item) => {
                const amount = Number(item.projectAmount);
                return sum + (!isNaN(amount) && amount >= 0 ? amount : 0);
            }, 0);
        },
        selectValue() {
            const countMap = new Map();
            this.formContract.materials.map(item => item.materialId).forEach(item => {
                if (countMap.has(item)) {
                    countMap.set(item, countMap.get(item) + 1);
                } else {
                    countMap.set(item, 1);
                }
            });
            const result = [];
            countMap.forEach((count, item) => {
                if (count === this.specsOption.length) {
                    result.push(item);
                }
            });
            return result;
        },
        customerContact() {
            return this.UserOptions.find(item => item.id === this.formContract.customerContactsId)
        },
        projectTypeData() {
            return ['测序分析', '裸测', '预付款扣款（测序分析）', '预付款扣款（裸测）']
        },
        hardDiskList() {
            return ['预付款扣款（测序分析）', '预付款扣款（裸测）', '测序分析', '裸测', '预付款扣款（纯分析）', '纯分析', '预付款扣款（返样/暂存样品）', '返样/暂存样品', '预付款扣款（其他）', '其他']
        },
        pureAnalysisTypeOptions() {
            // 与后端 pureAnalysisType 枚举保持一致
            return [
                { value: 'AFTER_SALES_ANALYSIS', label: '售后分析' },
                { value: 'RAW_DATA_RERELEASE', label: '原始数据重释放' },
                { value: 'PURE_ANALYSIS', label: '纯分析' }
            ]
        },
        //纯分析类型对应的合同查询类型（售后分析→已分析完成合同；原始数据重释放→已释放原始数据合同）
        pureAnalysisContractType() {
            const type = this.formContract.pureAnalysisInfo?.pureAnalysisType
            if (type === 'AFTER_SALES_ANALYSIS') return 'ANALYSIS_OVER_CONTRACT'
            if (type === 'RAW_DATA_RERELEASE') return 'RELEASED_RAW_DATA_CONTRACT'
            return ''
        },
        DirectionOptions() {
            const directions = [
                { label: '微生态保护剂', check: true },
                { label: '肠道菌群检测样本采集套装（16s全长）', check: false },
                { label: '肠道菌群检测样本采集套装（宏基因组）', check: false },
                { label: 'RNA保护剂', check: true },
            ]
            if (this.targetList.includes(this.formContract.projectType) && !directions.find(item => item.label === this.formContract.projectType)) {
                this.formContract.projectType = '' // 如果当前项目类型不在筛选后的列表中，重置项目类型
            }
            if (['PREPAYMENTS', 'IMPORT_PREPAYMENTS'].includes(this.formContract.contractType)) {
                return [
                    { label: '预付款' },
                ]
            } else if (['FORMAL'].includes(this.formContract.contractType)) {
                return [
                    { label: '测序分析' },
                    { label: '裸测' },
                    { label: '纯分析' },
                    { label: '返样/暂存样品' },
                    ...directions,
                    { label: '数据库、服务器、系统流程开发和部署' },
                    { label: '培训服务' },
                    { label: '其他' }
                ]
            } else if (this.formContract.contractType === 'CHARGEBACKS') {
                return [
                    { label: '预付款扣款（测序分析）' },
                    { label: '预付款扣款（裸测）' },
                    { label: '预付款扣款（纯分析）' },
                    { label: '预付款扣款（返样/暂存样品）' },
                    ...directions,
                    { label: '预付款扣款（数据库、服务器、系统流程开发和部署）' },
                    { label: '预付款扣款（培训服务）' },
                    { label: '预付款扣款（其他）' },
                ]
            } else if (this.formContract.contractType === 'DEVELOPMENT') {
                return [
                    { label: '测序分析' },
                    ...directions,
                    { label: '纯分析' },
                    { label: '裸测' },
                ]
            } else if (this.formContract.contractType === 'TEAM') {
                return [
                    // { label: '裸测' },
                    { label: '测序分析' },
                    { label: '纯分析' },
                ]
            } else {
                return []
            }
        },
        applyContractId() {
            return this.operation === 'submit' && this.selectDetail.status === 'APPLYING' ? this.selectDetail.id : ''
        },
        successContractId() {
            return ['change', 'adminEdits','salesManagerEdits'].includes(this.operation) ? this.selectDetail.id : ''
        }
    },
    watch: {
        // 监听解离投递方式，若为邮寄且存在解离项目则自动添加单细胞保护液物料
        'formContract.protectiveFluidInfo.protectiveFluidMethod': {
            handler(newVal) {
                const dissociationTypes = ['单细胞解离转录组-C4', '单细胞解离转录组-10X', '单细胞解离转录组'];
                const hasDissociation = this.formContract.specificProjectType.some(p => dissociationTypes.includes(p.projectType));
                if (hasDissociation && newVal === 'MAIL') {
                    // 检查物料中是否已有单细胞保护液
                    const exists = this.formContract.materials.some(m => {
                        const mat = this.LexiconOptions.find(l => l.id === m.materialId);
                        return mat && mat.materialName === '单细胞保护液';
                    });
                    if (!exists) {
                        // 查找物料字典中的单细胞保护液
                        const option = this.LexiconOptions.find(l => l.materialName === '单细胞保护液');
                        if (option) {
                            this.formContract.materials = [{
                                materialId: option.id,
                                materialNumber: '',
                                remainingNumber: option.number,
                                specs: ''
                            }]
                        }
                    }
                }
            },
            immediate: true
        },
        'formContract.projectType': {
            handler(newVal) {
                if (this.targetList.includes(newVal)) {
                    const material = this.LexiconOptions.find(item => item.materialName === newVal);
                    if (material) {
                        this.formContract.materials = [{ materialId: material.id, materialNumber: '', remainingNumber: '', specs: '' }];
                    }
                }
            },
            immediate: true,
        },

      operation: {
            handler(newVal) {
                if (newVal) {
                    if (newVal === 'change') {
                        this.title = '变更合同信息'
                    } else if (['submit', 'adminEdits', 'salesManagerEdits'].includes(newVal)) {
                        this.title = '编辑合同信息'
                    } else {
                        this.title = '添加合同信息'
                    }
                }
            },
            immediate: true
        },
        invoiceSelectDetail: {
            handler(newVal) {
                if (newVal && Object.keys(newVal).length > 0) {
                    this.detailLoading.recordLoading = true
                    this.dataLoading = true
                    this.isRecord = true
                    let record = JSON.parse(JSON.stringify(this.formRecord))
                    this.formRecord = {
                        ...record,
                        ...newVal,
                        invoiceInfos: newVal.invoiceInfoDTOS
                    }
                    if (newVal.id && newVal['annex']) {
                        this.addFileRecord(newVal.id)
                    }
                    this.detailLoading.recordLoading = false
                    if (!this.detailLoading.recordLoading && !this.detailLoading.mailLoading && !this.detailLoading.contractLoading) {
                        this.dataLoading = false
                    }
                }
            },
            immediate: true
        },
        mailSelectDetail: {
            handler(newVal) {
                if (newVal && Object.keys(newVal).length > 0) {
                    this.detailLoading.mailLoading = true
                    this.dataLoading = true
                    this.isMail = true
                    let mail = JSON.parse(JSON.stringify(this.formMail))
                    const mailingContent = {
                        ...newVal.mailingContent
                    }
                    this.formMail = {
                        ...mail,
                        ...newVal,
                        mailAttachment: [],
                        reportFile: [],
                        reimbursementFile: [],
                        mailingContent: mailingContent
                    }
                    if (newVal.id) {
                        for (const annex in newVal.mailAttachment) {
                            if (Object.keys(newVal.mailAttachment[annex]).length > 1) {
                                this.addFileMail(newVal.id, annex, 'completeAttachments')
                            } else if (Object.keys(newVal.mailAttachment[annex]).length === 1) {
                                this.addFileMail(newVal.id, annex, '')
                            }
                        }
                    }
                    this.detailLoading.mailLoading = false
                    if (!this.detailLoading.recordLoading && !this.detailLoading.mailLoading && !this.detailLoading.contractLoading) {
                        this.dataLoading = false
                    }
                }
            },
            immediate: true
        },
        selectDetail: {
            async handler(newVal) {
                if (newVal && Object.keys(newVal).length > 0) {
                    this.detailLoading.contractLoading = true
                    this.dataLoading = true
         
                    if (['change', 'submit', 'adminEdits', 'salesManagerEdits'].includes(this.operation)) {
                        let tempData = JSON.parse(JSON.stringify(newVal))
                        let contract = JSON.parse(JSON.stringify(this.formContract))
                        this.formContract = {
                            ...contract,
                            ...tempData,
                            materials:[],
                            salesId: newVal?.sales?.uuid ?? '',
                            trusteeContactsId: newVal?.trusteeContacts?.uuid ?? '',
                            analysisRequest: 'STANDARD_ANALYSIS',
                            contractFilePath: null,
                            seniorAnalysisFile: null,
                            customizedAnalysisFile: null,
                            priceFile: null,
                            hardDiskPurchaseInfo: [],
                            projectAnnexFiles:{}
                        }
                        if (!newVal.protectiveFluidMail?.length || newVal.protectiveFluidMail.some(item => item.trackingFlag === 0)) {
                            this.formContract.materials = newVal.materials || []
                        }
                        if (newVal.hardDiskPurchaseInfo && Array.isArray(newVal.hardDiskPurchaseInfo)) {
                            this.formContract.hardDiskPurchaseInfo = newVal.hardDiskPurchaseInfo.map(item => ({
                                hardDiskSize: item.hardDiskSize || '',
                                projectAmount: item.projectAmount || 0,
                                sampleCount: item.sampleCount || 0
                            }))
                        } else if (newVal.hardDiskPurchaseInfo) {
                            this.formContract.hardDiskPurchaseInfo = [{
                                hardDiskSize: newVal.hardDiskPurchaseInfo.hardDiskSize || '',
                                projectAmount: newVal.hardDiskPurchaseInfo.projectAmount || 0,
                                sampleCount: newVal.hardDiskPurchaseInfo.sampleCount || 0
                            }]
                        }
                        this.showHardDiskPurchaseInfo = this.formContract.hardDiskPurchaseInfo.length > 0
                        // 初始化纯分析项目选择（后端可能未返回该字段）
                        const rawPureInfo = this.formContract.pureAnalysisInfo
                        if (!rawPureInfo || typeof rawPureInfo !== 'object') {
                            this.formContract.pureAnalysisInfo = { pureAnalysisType: '', contracts: [{ contractId: '', projectIds: [], options: [] }] }
                        } else {
                            const rawContracts = Array.isArray(rawPureInfo.contracts) ? rawPureInfo.contracts : []
                            const contracts = rawContracts.length > 0
                                ? rawContracts.map(c => ({
                                    contractId: c.contractId || '',
                                    projectIds: Array.isArray(c.projectIds) ? c.projectIds : (c.projectIds ? [c.projectIds] : []),
                                    options: []
                                }))
                                : [{ contractId: '', projectIds: [], options: [] }]
                            this.formContract.pureAnalysisInfo = {
                                pureAnalysisType: rawPureInfo.pureAnalysisType || '',
                                contracts
                            }
                        }
                        // 编辑态下逐组按 id 定向加载已选合同（远程搜索模式下初始列表可能不包含），项目选项由所选合同联动计算
                        if (['AFTER_SALES_ANALYSIS', 'RAW_DATA_RERELEASE'].includes(this.formContract.pureAnalysisInfo.pureAnalysisType)) {
                            this.formContract.pureAnalysisInfo.contracts.forEach((group, index) => {
                                if (group.contractId) {
                                    this.loadSelectedEnforceContract(group.contractId, index)
                                }
                            })
                        }
                        if (this.formContract.generateContractInfo === null) {
                            this.formContract.generateContractInfo = {}
                        }
                        if (!this.formContract.protectiveFluidInfo) {
                            this.formContract.protectiveFluidInfo = {
                                protectiveFluidMethod:'',
                                doorInfo:null,
                                materialMailInfo:null
                            }
                        }
                        if (!this.formContract.protectiveFluidInfo.doorInfo) {
                            this.formContract.protectiveFluidInfo.doorInfo = {
                                doorFee: '',
                                phone: '',
                                address: '',
                                doorTime: ''
                            }
                        }
                        if (!this.formContract.protectiveFluidInfo.materialMailInfo) {
                            this.formContract.protectiveFluidInfo.materialMailInfo = {
                                recipient: '',
                                phone: '',
                                address: '',
                                mailTime: '',
                            }
                        }
                        const addedData = this.determineAddedType(newVal.contractAmount, newVal.addedAmount)
                        this.formContract.addedType = addedData.addedType
                        this.formContract.addedProportion = addedData.addedProportion
                        this.formContract.returnFlag = !!newVal['generateContractInfo']?.['returnSampleBo']?.['returnSampleFlag']
                        this.formContract.sampleAmount = (newVal['generateContractInfo']?.['returnSampleBo']?.['returnSampleAmount']) ?? 0
                        this.formContract.reason = (newVal['generateContractInfo']?.['returnSampleBo']?.['reason']) ?? ''

                        this.formContract.extractionFlag = !!newVal['generateContractInfo']?.['extractionFlag']
                        this.formContract.extractionNumber = newVal['generateContractInfo']?.['extractionNumber'] ?? ''
                        this.formContract.watermarkFlag = !!newVal['generateContractInfo']?.['watermarkFlag']

                        const paymentMethods = (newVal['generateContractInfo']?.paymentMethods) ?? {}
                        const methodKey = Object.keys(paymentMethods)
                        const methodValues = Object.values(paymentMethods)
                        if (methodKey.length) {
                            this.formContract.methods = methodKey[0]
                        }
                        if (methodValues.length) {
                            this.formContract.theFirstRatio = Number(methodValues[0]) * 100
                        }

                        this.getRemainingAmount(newVal.customerContactsId, this.applyContractId, this.successContractId)
                        if (!this.invoiceSelectDetail || Object.keys(this.invoiceSelectDetail).length === 0) {
                            this.formRecord.applicantId = newVal.salesId
                        }
                        if (!this.mailSelectDetail || Object.keys(this.mailSelectDetail).length === 0) {
                            this.formMail.applicantId = newVal.salesId
                        }

                        if (newVal.moreAnalysisRequest) {
                            for (let request in newVal.moreAnalysisRequest) {
                                switch (request) {
                                    case 'SENIOR_ANALYSIS':
                                        this.formContract.seniorAnalysisAmount = newVal.moreAnalysisRequest[request]
                                        break;
                                    case 'CUSTOMIZED_ANALYSIS':
                                        this.formContract.customizedAnalysisAmount = newVal.moreAnalysisRequest[request]
                                        break;
                                    default:
                                        break
                                }
                            }
                        }
                        if (!this.formContract.specificProjectType || this.formContract.specificProjectType.length <= 0) {
                            this.handleAddProject()
                        }
                        if (this.operation === 'salesManagerEdits') {
                            this.UserOptions = [{
                                id: newVal?.customerContacts?.id || '',
                                contactName: newVal?.customerContacts?.contactName || '暂无',
                                companyName: newVal?.customerContacts?.companyName || '暂无',
                                phone: newVal?.customerContacts?.phone || '',
                                email: newVal?.customerContacts?.email || '',
                                address: newVal?.customerContacts?.address || '',
                                taxRegistrationNumber: newVal?.customerContacts?.taxRegistrationNumber || '',
                            }]
                        } else {
                            this.getUserOption(this.formContract.salesId)
                        }
                        await this.getProjectOption()
                        this.formContract.specificProjectType.forEach((item, index) => {
                            if (!item.labList) {
                                this.$set(item, 'labList', []);
                            }
                            if (!item.experimentalProcessItems) {
                                this.$set(item, 'experimentalProcessItems', []);
                            }
                            item.projectSampleDataList.forEach((dataItem, dataIndex) => {
                                this.$set(dataItem, 'projectList', this.getSizeList(item.projectClassification, item.projectType, dataItem.sizeOfSampleData));
                            })
                            const project = this.ProjectOption.find(itemA => itemA.name === item.projectType);
                            const analysisChoiceList = project?.attribute?.optionalAnalysisType?.split('/')?.filter(item => item !== '') ?? []
                            if (project?.attribute) {
                                this.$set(item, 'dataAmountUnit', project.attribute.dataAmountUnit ?? '');
                                this.$set(item, 'minSampleCount', project.attribute.minSampleCount);
                                this.$set(item, 'maxSampleCount', project.attribute.maxSampleCount);
                                this.$set(item, 'multipleChoice', project.attribute.multipleChoice);
                                this.$set(item, 'analysisChoiceList', analysisChoiceList);
                                if (project.attribute.labProcess) {
                                    let list = project.attribute?.labProcess?.split('/')?.filter(item => item !== '') ?? []
                                    for (let items of ['引物合成', '荧光定量']) {
                                        const index1 = list.indexOf(items)
                                        if (index1 !== -1) {
                                            list.splice(index1, 1)
                                            list.unshift(items)
                                        }
                                    }
                                    let experimental = [...item.experimentalProcessItems]
                                    let map = experimental.map(item => item.experimentName)
                                    for (let info of list) {
                                        if (map.includes(info)) {
                                            continue
                                        }
                                        let lab = {
                                            experimentName: info,
                                            numberOfExperiment: '',
                                            experimentAmount: ''
                                        }
                                        experimental.push(lab)
                                    }
                                    this.$set(item, 'experimental', experimental);
                                } else {
                                    this.$set(item, 'experimental', []);
                                }
                            } else {
                                this.$set(item, 'dataAmountUnit', '');
                                this.$set(item, 'minSampleCount', '');
                                this.$set(item, 'maxSampleCount', '');
                                this.$set(item, 'multipleChoice', false);
                                this.$set(item, 'analysisChoiceList', []);
                                this.$set(item, 'experimental', []);
                            }
                           
                            const analyzeRequirements = item?.analyzeRequirements?.split('/')?.filter(it => it !== '') ?? []
                            
                            if (analyzeRequirements.includes('非标准分析')) {
                                this.$set(item, 'analysis', '非标准分析');
                            } else {
                                this.$set(item, 'analysis', '标准分析');
                            }
                            // 标准分析具体类型：回显值构成的数组属于该项目可选项时按其勾选，反之为空
                            if (analyzeRequirements.every(it => (item.analysisChoiceList || []).includes(it))) {
                                this.$set(item, 'analysisList', analyzeRequirements);
                            } else {
                                this.$set(item, 'analysisList', []);
                            }
                            this.$set(item, 'labList', item?.experimentalProcessItems?.map(item => item.experimentName) ?? []);
                            for (let items of ['引物合成', '荧光定量']) {
                                if (item.experimental.map(item => item.experimentName).includes(items) && !item.labList.includes(items)) {
                                    item.labList.push(items)
                                }
                            }
                            if ( !['其他', '硬盘购买'].includes(item.projectClassification)) {
                                if (item.projectClassification === 'AMPLICON') {
                                    switch (project?.modelAttr?.sonModel) {
                                        case 'SECOND':
                                            this.$set(item, 'sequencingPlatformList', project?.attribute?.sequencingPlatform?.split('/')?.filter(item => item !== '') ?? []);
                                            this.$set(item, 'thirdSequencingPlatformList', []);
                                            break
                                        case 'THIRD':
                                            this.$set(item, 'sequencingPlatformList', []);
                                            this.$set(item, 'thirdSequencingPlatformList', project?.attribute?.sequencingPlatform?.split('/')?.filter(item => item !== '') ?? []);
                                            break
                                        default:
                                            this.$set(item, 'sequencingPlatformList', []);
                                            this.$set(item, 'thirdSequencingPlatformList', []);
                                            break
                                    }
                                } else {
                                    this.$set(item, 'sequencingPlatformList', project?.attribute?.sequencingPlatform?.split('/')?.filter(item => item !== '') ?? []);
                                    this.$set(item, 'thirdSequencingPlatformList', project?.attribute?.thirdSequencingPlatform?.split('/')?.filter(item => item !== '') ?? []);
                                }
                                
                                if (!item.sequencingPlatform && item.sequencingPlatformList.length > 0) {
                                    this.$set(item, 'sequencingPlatform', item.sequencingPlatformList[0]);
                                }
                                if (item.sequencingPlatformList.length === 0) {
                                    this.$set(item, 'sequencingPlatform', '');
                                }
                                if (!item.thirdSequencingPlatform && item.thirdSequencingPlatformList.length > 0) {
                                    if (item.thirdSequencingPlatformList.includes('纳米孔')) {
                                        this.$set(item, 'thirdSequencingPlatform', '纳米孔');
                                        this.$set(item, 'tesThirdSequencingPlatform', '纳米孔');
                                    } else {
                                        this.$set(item, 'thirdSequencingPlatform', item.thirdSequencingPlatformList[0]);
                                        this.$set(item, 'tesThirdSequencingPlatform', item.thirdSequencingPlatformList[0]);
                                    }
                                }
                                if (item.thirdSequencingPlatformList.length === 0) {
                                    this.$set(item, 'thirdSequencingPlatform', '');
                                    this.$set(item, 'tesThirdSequencingPlatform', '');
                                }
                            } else {
                                this.$set(item, 'sequencingPlatformList', []);
                                this.$set(item, 'thirdSequencingPlatformList', []);
                            }
                        })
                        if (newVal.id && newVal.contractFilePath) {
                            await this.addFileContract(newVal.id, 'CONTRACT_ANNEX', ['change'].includes(this.operation))
                        }
                        if (newVal.id && newVal.seniorAnalysisAnnex) {
                            await this.addFileContract(newVal.id, 'SENIOR_ANALYSIS_ANNEX')
                        }
                        if (newVal.id && newVal.customizedAnalysisAnnex) {
                            await this.addFileContract(newVal.id, 'CUSTOMIZED_ANALYSIS_ANNEX')
                        }
                        if (newVal.id && newVal.priceFilePath && ['add','edit','submit','change'].includes(this.operation)) {
                            await this.addFileContract(newVal.id, 'PRICE_APPLE_ANNEX')
                        }
                        for (const project of newVal.specificProjectType) {
                            if (project.projectMainTypeId && project.annexFilePath && newVal.id) {
                                await this.addProjectAnnex(newVal.id, project.projectMainTypeId)
                            }
                        }
                        this.$set(this.formContract, 'moreAnalysis', Object.keys(newVal.moreAnalysisRequest));
                    } else {
                        //编辑和添加
                        try {
                            this.form.id = newVal.id
                            if (newVal.id) {
                                for (const annexType in newVal['annex']) {
                                    if (Object.keys(newVal['annex'][annexType]).length > 1) {
                                        await this.addFileManually(newVal.id, annexType, 'completeAttachments')
                                    } else if (Object.keys(newVal['annex'][annexType]).length === 1) {
                                        await this.addFileManually(newVal.id, annexType, '')
                                    }
                                }
                                for (const [key, value] of Object.entries(newVal['projectAnnex'])) {
                                    await this.addProjectAnnex(newVal.id, key, true)
                                }
                            }
                            if (newVal.draft) {
                                this.isRecord = newVal.draft.isRecord
                                this.isMail = newVal.draft.isMail
                            }
                            if (newVal.draft.contract) {
                                for (const key in newVal.draft.contract) {
                                    if (this.formContract.hasOwnProperty(key)) {
                                        this.$set(this.formContract, key, JSON.parse(JSON.stringify(newVal.draft.contract[key])));
                                    }
                                }
                                this.$set(this.formContract, 'contractNumber', newVal.draft.contract['contractNumber']);
                                this.getRemainingAmount(newVal.draft.contract.customerContactsId)
                                if (this.formContract.salesId) {
                                    this.getUserOption(this.formContract.salesId)
                                }
                                if (!this.formContract.specificProjectType || this.formContract.specificProjectType.length <= 0) {
                                    this.handleAddProject()
                                }
                                await this.getProjectOption()

                                this.formContract.specificProjectType.forEach((item, index) => {
                                    if (!item.labList) {
                                        this.$set(item, 'labList', []);
                                    }
                                    if (!item.experimentalProcessItems) {
                                        this.$set(item, 'experimentalProcessItems', []);
                                    }
                                    if (!item.experimental) {
                                        this.$set(item, 'experimental', []);
                                    }
                                    if (!Array.isArray(item.projectSampleDataList) || item.projectSampleDataList.length <= 0) {
                                        this.$set(item, 'projectSampleDataList', []);
                                        if (item.projectClassification && item.projectType) {
                                            this.handleAddData(index)
                                        }
                                    }
                                    const project = this.ProjectOption.find(itemA => itemA.name === item.projectType);
                                    if (project?.attribute) {
                                        this.$set(item, 'dataAmountUnit', project?.attribute?.dataAmountUnit ?? '');
                                        this.$set(item, 'minSampleCount', project.attribute.minSampleCount);
                                        this.$set(item, 'maxSampleCount', project.attribute.maxSampleCount);
                                        this.$set(item, 'multipleChoice', project.attribute.multipleChoice);
                                        this.$set(item, 'analysisChoiceList', project.attribute?.optionalAnalysisType?.split('/')?.filter(item => item !== '') ?? []);
                                        if (project.attribute.labProcess) {
                                            let list = project.attribute?.labProcess?.split('/')?.filter(item => item !== '') ?? []
                                            for (let items of ['引物合成', '荧光定量']) {
                                                const index1 = list.indexOf(items)
                                                if (index1 !== -1) {
                                                    list.splice(index1, 1)
                                                    list.unshift(items)
                                                }
                                            }

                                            let experimental = [...item.experimental]
                                            let map = experimental.map(item => item.experimentName)
                                            for (let info of list) {
                                                if (map.includes(info)) {
                                                    continue
                                                }
                                                let lab = {
                                                    experimentName: info,
                                                    numberOfExperiment: '',
                                                    experimentAmount: ''
                                                }
                                                experimental.push(lab)
                                            }
                                            this.$set(item, 'experimental', experimental);
                                        } else {
                                            this.$set(item, 'experimental', []);
                                        }
                                    } else {
                                        this.$set(item, 'dataAmountUnit', '');
                                        this.$set(item, 'minSampleCount', '');
                                        this.$set(item, 'maxSampleCount', '');
                                        this.$set(item, 'multipleChoice', false);
                                        this.$set(item, 'analysisChoiceList', []);
                                        this.$set(item, 'experimental', []);
                                    }
                                    if (!item.analysis) {
                                        this.$set(item, 'analysis', '标准分析');
                                    }
                                    if (!item.analysisList) {
                                        this.$set(item, 'analysisList', []);
                                    }
                                    if (!item.labList) {
                                        this.$set(item, 'labList', []);
                                    }
                                    if (!['其他', '硬盘购买'].includes(item.projectClassification)) {
                                        if (item.projectClassification === 'AMPLICON') {
                                            switch (project?.modelAttr?.sonModel) {
                                                case 'SECOND':
                                                    this.$set(item, 'sequencingPlatformList', project?.attribute?.sequencingPlatform?.split('/')?.filter(item => item !== '') ?? []);
                                                    this.$set(item, 'thirdSequencingPlatformList', []);
                                                    break
                                                case 'THIRD':
                                                    this.$set(item, 'sequencingPlatformList', []);
                                                    this.$set(item, 'thirdSequencingPlatformList', project?.attribute?.sequencingPlatform?.split('/')?.filter(item => item !== '') ?? []);
                                                    break
                                                default:
                                                    this.$set(item, 'sequencingPlatformList', []);
                                                    this.$set(item, 'thirdSequencingPlatformList', []);
                                                    break
                                            }
                                        } else {
                                            this.$set(item, 'sequencingPlatformList', project?.attribute?.sequencingPlatform?.split('/')?.filter(item => item !== '') ?? []);
                                            this.$set(item, 'thirdSequencingPlatformList', project?.attribute?.thirdSequencingPlatform?.split('/')?.filter(item => item !== '') ?? []);
                                        }
                                        if (!item.sequencingPlatform && item.sequencingPlatformList.length > 0) {
                                            this.$set(item, 'sequencingPlatform', item.sequencingPlatformList[0]);
                                        }
                                        if (item.sequencingPlatformList.length === 0) {
                                            this.$set(item, 'sequencingPlatform', '');
                                        }
                                        if (!item.thirdSequencingPlatform && item.thirdSequencingPlatformList.length > 0) {
                                            if (item.thirdSequencingPlatformList.includes('纳米孔')) {
                                                this.$set(item, 'thirdSequencingPlatform', '纳米孔');
                                                this.$set(item, 'tesThirdSequencingPlatform', '纳米孔');
                                            } else {
                                                this.$set(item, 'thirdSequencingPlatform', item.thirdSequencingPlatformList[0]);
                                                this.$set(item, 'tesThirdSequencingPlatform', item.thirdSequencingPlatformList[0]);
                                            }
                                        }
                                        if (item.thirdSequencingPlatformList.length === 0) {
                                            this.$set(item, 'thirdSequencingPlatform', '');
                                            this.$set(item, 'tesThirdSequencingPlatform', '');
                                        }
                                    } else {
                                        this.$set(item, 'thirdSequencingPlatformList', []);
                                        this.$set(item, 'sequencingPlatformList', []);
                                    }
                                })
                            }
                            if (newVal.draft.record) {
                                for (const key in newVal.draft.record) {
                                    if (this.formRecord.hasOwnProperty(key)) {
                                        this.$set(this.formRecord, key, newVal.draft.record[key]);
                                    }
                                }
                            }
                            if (newVal.draft.mail) {
                                for (const key in newVal.draft.mail) {
                                    if (this.formMail.hasOwnProperty(key)) {
                                        this.$set(this.formMail, key, newVal.draft.mail[key]);
                                    }
                                }
                            }
                        } catch (error) {
                            this.$messageUi('草稿数据导入失败', error)
                            console.log(error);
                            
                        }
                    }
                    this.detailLoading.contractLoading = false
                    if (!this.detailLoading.recordLoading && !this.detailLoading.mailLoading && !this.detailLoading.contractLoading) {
                        this.dataLoading = false
                    }
                }
            },
            immediate: true
        },
        isRecord: {
            handler(newVal) {
                if (!newVal) {
                    this.formMail.mailingContent.numberOfInvoice = 0
                }
            },
            immediate: true
        },
        'formContract.salesId': {
            handler(newVal, oldVal) {
                if (!this.dataLoading) {
                    if (newVal !== oldVal && oldVal !== '') {
                        if (!['salesManagerEdits'].includes(this.operation) && this.role !== 'ADMIN') {
                            this.formContract.customerContactsId = ''
                            this.getRemainingAmount()
                        }
                    }
                    if (newVal && newVal !== '') {
                        this.formContract.trusteeContactsId = newVal
                        this.formRecord.applicantId = newVal
                        this.getUserOption(newVal)
                    } else {
                        if (!['salesManagerEdits'].includes(this.operation)) {
                            this.formContract.customerContactsId = ''
                            this.getRemainingAmount()
                        }
                        this.UserOptions = []
                    }
                }
            },
            immediate: true
        },
        'formContract.trusteeCompanyId': {
            handler(newVal) {
                if (newVal && !this.dataLoading) {
                    this.formRecord.invoiceInfos = this.formRecord.invoiceInfos.map(item => {
                        return {
                            ...item,
                            billingUnitId: newVal
                        }
                    })
                }
            },
            immediate: true
        },
        'formContract.materials': {
            handler(newVal) {
                if (!this.dataLoading) {
                    if (this.isHandlingMaterials) return; // 如果正在处理，直接返回
                    this.isHandlingMaterials = true; // 标记正在处理
                    if (!Array.isArray(newVal)) {
                        this.$set(this.formContract, 'materials', []);
                    }
                    if (Array.isArray(newVal)) {
                        newVal.forEach((item, index) => {
                            const material = this.LexiconOptions.find(itemA => itemA.id === item.materialId);
                            if (material) {
                                this.$set(this.formContract.materials[index], 'remainingNumber', material.number);
                            }
                        });
                    }
                    this.isHandlingMaterials = false; // 处理完毕，取消标记
                }
            },
            immediate: true,
            deep: true
        },
        'formContract.trusteeContactsId': {
            handler(newVal) {
                if (!this.dataLoading) {
                    if (newVal && newVal !== '') {
                        this.formMail.applicantId = newVal
                    }
                }
            },
            immediate: true
        },
        customerContact: {
            handler(newVal) {
                if (newVal && !this.dataLoading) {
                    this.formRecord.invoiceInfos = this.formRecord.invoiceInfos.map(item => {
                        return {
                            ...item,
                            invoiceTitleId: item.invoiceTitleId || newVal.customerCompanyId,
                            taxRegistrationNumber: item.taxRegistrationNumber || newVal.taxRegistrationNumber,
                        }
                    })
                }
            },
            immediate: true
        },
        'formRecord.applicantId': {
            handler(newVal) {
                if (newVal && !this.dataLoading) {
                    this.formMail.applicantId = newVal
                }
            },
            immediate: true
        },
        'formRecord.applicationDate': {
            handler(newVal) {
                if (newVal && !this.dataLoading) {
                    this.formMail.applicantDate = newVal
                }
            },
            immediate: true
        },
        'formContract.contractNumber': {
            handler(newVal) {
                if (newVal && !this.dataLoading) {
                    this.formRecord.contractNumbers = [newVal]
                }
            },
            immediate: true
        },
        'formMail.applicantId': {
            handler(newVal) {
                if (!this.dataLoading) {
                    if (newVal !== '') {
                        this.getContactOptions(newVal)
                    } else {
                        this.ContactOptions = []
                    }
                }
            },
            immediate: true
        }
    },
    created() {
        this.userData = JSON.parse(getDataInLocalStorage('user'))
        this.role = getDataInLocalStorage('role')
    },
    mounted() {
        this.getGutSales()
        this.getBusinessOption();
        this.getCompanyOption()
        this.getDrafterOption()
        // this.getAnalysisEvaluate()
        this.getLexiconOptions()
        this.getEnforceContractOption()
        if (!(this.selectDetail && Object.keys(this.selectDetail).length > 0)) {
            this.getProjectOption()
            this.generateCode('FORMAL')
        }
        if (this.formContract.signingDate === '') {
            this.formContract.signingDate = this.getCurrentDate('sign')
        }
        if (!this.formContract.protectiveFluidInfo?.doorInfo?.doorTime) {
            this.formContract.protectiveFluidInfo.doorInfo.doorTime = this.getCurrentDate('sign')
        }
        if (!this.formContract.protectiveFluidInfo?.materialMailInfo?.mailTime) {
            this.formContract.protectiveFluidInfo.materialMailInfo.mailTime = this.getCurrentDate('sign')
        }
        if (!this.formContract.contractDraftingDate) {
            this.formContract.contractDraftingDate = this.getCurrentDate('sign')
        }
        if (!this.formRecord.applicationDate) {
            this.formRecord.applicationDate = this.getCurrentDate('sign')
        }
        if (!this.formMail.applicantDate) {
            this.formMail.applicantDate = this.getCurrentDate('sign')
        }
    },
    methods: {
        checkDate,
        checkSumAmount,
        checkSum,
        checkInclude,
        checkMinMax,
        check,
        checkSize,
        checkNumber,
        /**
         * 校验：当当前项目模块为三代（TGG）时，
         *  - 至少有一个 info.boolean 为 true
         *  - 若仅有一个为 true，则该为 true 的 info.name 必须为 '三代'
         *  - 若有多个为 true，则任意组合允许
         *
         * 被绑定到每个 dataItem.projectList 的 size 字段上，触发点包括输入和我们在 checkbox 改变时手动触发 validateField。
         */
        validateProjectAnnex(rule, value, callback, project) {
            const fileData = this.formContract.projectAnnexFiles[project.projectMainTypeId];
            if (!fileData || !fileData.file) {
                return callback(new Error('请上传理化性质项目附件'));
            }
            return callback();
        },
        validatePlatformSelection(rule, value, callback, project, projectIndex, dataIndex) {
            try {
                if (!project || project.projectClassification !== 'TGG') {
                    return callback(); // 非三代模块不校验这条规则
                }
                const list = (project.projectSampleDataList && project.projectSampleDataList[dataIndex] && project.projectSampleDataList[dataIndex].projectList) || [];
                const selected = list.filter(i => i.boolean === true);
                const count = selected.length;

                if (count === 0) {
                    return callback(new Error('多种测序类型项目至少选择一个测序类型'));
                }
                // if (count === 1) {
                //     // 只有一个被选中时，必须为三代（名称为 '三代'）
                //     if (selected[0].name !== '三代') {
                //         return callback(new Error('仅选择提供一个数据量时必须选择三代'));
                //     }
                // }
                // 多于一个，无额外约束
                return callback();
            } catch (err) {
                // 出错情况下不阻塞表单提交，输出错误以便排查
                // console.error(err);
                return callback();
            }
        },
        getGutSales() {
            getConfigPage({}, {}).then(res => {
                this.gutSalesList = []
                if (res.code === 200) {
                    const form = res.data.records.find(item => item.name === 'SYS_CONTRACT_GUT_SALES')
                    if (form) {
                        this.gutSalesList = form.confValue.split(',')
                    }
                }
            }).catch(() => {
                this.gutSalesList = []
            })
        },
        validateDoorFee(rule, value, callback) {
            if (!value && value !== 0) {
                callback(new Error('上门费用不能为空'));
            } else {
                const numValue = Number(value);
                if (isNaN(numValue)) {
                    callback(new Error('请输入有效的数字'));
                } else {
                    if (['adminEdits'].includes(this.operation)) {
                        // 管理员编辑：>=3000 或 =0
                        if (numValue !== 0 && numValue < 3000) {
                            callback(new Error('管理员编辑时上门费用必须为0或大于等于3000'));
                        } else {
                            callback();
                        }
                    } else {
                        // 非管理员编辑：>=3000
                        if (numValue < 3000) {
                            callback(new Error('上门费用必须大于等于3000'));
                        } else {
                            callback();
                        }
                    }
                }
            }
        },
        /**
         * 当某个平台的 checkbox 状态变化时，手动触发表单校验（触发我们绑定 validator）
         */
        onPlatformCheckboxChange(projectIndex, dataIndex, changedInfo) {
            this.$nextTick(() => {
                try {
                    const project = this.formContract.specificProjectType[projectIndex];
                    if (!project || !Array.isArray(project.projectSampleDataList)) return;
                    const list = project.projectSampleDataList;

                    const masterList = list[0]?.projectList || [];
                    const getSelectedKeys = (arr) => (Array.isArray(arr) ? arr.filter(i => i.boolean).map(i => i.key) : []);

                    const masterKeys = getSelectedKeys(masterList);
                  
                    // helper: compare sets (order-independent)
                    const sameSet = (a, b) => {
                        if (!Array.isArray(a)) a = [];
                        if (!Array.isArray(b)) b = [];
                        if (a.length !== b.length) return false;
                        const setB = new Set(b);
                        return a.every(item => setB.has(item));
                    };

                    if (dataIndex === 0) {
                        // 修改的是 master：严格同步到后续所有 dataItem（包括清空或全选）
                        const newMasterKeys = getSelectedKeys(masterList);
                        for (let i = 1; i < list.length; i++) {
                            const dl = list[i].projectList || [];
                            dl.forEach(it => {
                                it.boolean = newMasterKeys.includes(it.key);
                            });
                        }
                    } else {
                        // 修改的是非 master 条目
                        const currentList = list[dataIndex]?.projectList || [];
                        const selKeys = getSelectedKeys(currentList);

                        if (masterKeys.length === 0) {
                            // master 为空 -> 把当前的选择推广为 master（包括清空）
                            // 若当前也为空，则清空所有后续项与 master
                            masterList.forEach(it => {
                                it.boolean = selKeys.includes(it.key);
                            });
                            for (let i = 1; i < list.length; i++) {
                                const dl = list[i].projectList || [];
                                dl.forEach(it => {
                                    it.boolean = selKeys.includes(it.key);
                                });
                            }
                        } else {
                            // master 非空：强制后续项与 master 完全一致
                            if (!sameSet(selKeys, masterKeys)) {
                                // 恢复当前条目为 master 的选择（严格恢复）
                                currentList.forEach(it => {
                                    it.boolean = masterKeys.includes(it.key);
                                });
                                this.$messageUi && this.$messageUi.error && this.$messageUi.error('平台选择需与第一个样本严格一致');
                            }
                        }
                    }

                    // 触发表单校验（保持原 onPlatformCheckboxChange 的行为）
                    const sonIndex = (list[dataIndex] && list[dataIndex].projectList) ? list[dataIndex].projectList.findIndex(() => true) : -1;
                    if (sonIndex !== -1) {
                        const prop = `specificProjectType.${projectIndex}.projectSampleDataList.${dataIndex}.projectList.${sonIndex}.size`;
                        if (this.$refs.formContract && this.$refs.formContract.validateField) {
                            this.$refs.formContract.validateField(prop, () => { });
                        }
                    }
                } catch (e) {
                    // ignore
                }
            });
        },


        //获取所有的项目类型
        async getProjectOption() {
            try {
                const res = await getProjectList({})
                if (res.code === 200) {
                    this.ProjectOption = res.data.filter(item => !item.deprecated)
                }
            } catch (error) { console.log(error); }
        },
        //获取纯分析多组合同的「销售/客户」参考值：遍历其他组已选合同，提取 salesId 与 customerContactsId
        //excludeIndex 为需排除的组索引（通常为当前正在加载选项的组），传 -1 表示不排除任何组
        getPureAnalysisSalesCustomerReference(excludeIndex) {
            const contracts = this.formContract.pureAnalysisInfo?.contracts || []
            let salesId = ''
            let customerContactsId = ''
            for (let i = 0; i < contracts.length; i++) {
                if (i === excludeIndex) continue
                const group = contracts[i]
                if (!group || !group.contractId) continue
                const selected = (group.options || []).find(item => String(item.id) === String(group.contractId))
                if (!selected) continue
                if (!salesId && selected.salesId) salesId = String(selected.salesId)
                if (!customerContactsId && selected.customerContactsId) customerContactsId = String(selected.customerContactsId)
                if (salesId && customerContactsId) break
            }
            return { salesId, customerContactsId }
        },
        //获取已执行合同列表（供纯分析项目选择使用，支持初始加载 + 合同编号远程搜索，按组存储选项）
        async getEnforceContractOption(query, index) {
            const contractType = this.pureAnalysisContractType
            if (!contractType) return
            const group = this.formContract.pureAnalysisInfo.contracts[index]
            if (!group) return
            try {
                this.enforceContractLoading = true
                const data = {}
                if (query) {
                    // 合同编号前缀存在 BZ / BZD / BZF 等多种字母形式，搜索时统一去除字母前缀，只按数字后缀模糊匹配
                    const normalizedQuery = String(query).replace(/^[A-Za-z]+/, '').trim()
                    if (normalizedQuery) {
                        data['query#contractNumber.LIKE'] = normalizedQuery
                    }
                }
                // 多组合同必须来自同一销售、同一客户：以其他组已选合同的销售/客户作为服务端过滤条件
                const reference = this.getPureAnalysisSalesCustomerReference(index)
                if (reference.salesId) {
                    data['query#salesId.IN'] = reference.salesId
                }
                if (reference.customerContactsId) {
                    data['query#customerContactsId.IN'] = reference.customerContactsId
                }
                const res = await getAllContract(contractType, data)
                if (res.code === 200) {
                    let list = res.data || []
                    // 保留当前组已选中的合同，避免搜索后选项被覆盖导致 label / specificProjectType 丢失
                    const selectedId = group.contractId
                    if (selectedId && !list.some(item => String(item.id) === String(selectedId))) {
                        const cached = (group.options || []).find(item => String(item.id) === String(selectedId))
                        if (cached) {
                            list = [cached, ...list]
                        }
                    }
                    this.$set(group, 'options', list)
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.enforceContractLoading = false
            }
        },
        //编辑态下按 id 定向加载已选中合同到指定组，保证展示与项目联动可用
        async loadSelectedEnforceContract(contractId, index) {
            if (!contractId) return
            const contractType = this.pureAnalysisContractType
            if (!contractType) return
            const group = this.formContract.pureAnalysisInfo.contracts[index]
            if (!group) return
            if ((group.options || []).some(item => String(item.id) === String(contractId))) return
            try {
                const res = await getAllContract(contractType, { 'query#id.IN': String(contractId) })
                if (res.code === 200 && Array.isArray(res.data) && res.data.length > 0) {
                    this.$set(group, 'options', [...res.data, ...(group.options || [])])
                }
            } catch (error) {
                console.log(error);
            }
        },
        //纯分析类型变更时重置合同组并按需加载「合同」下拉初始选项
        changePureAnalysisType(type) {
            this.formContract.pureAnalysisInfo.contracts = [{ contractId: '', projectIds: [], options: [] }]
            if (['AFTER_SALES_ANALYSIS', 'RAW_DATA_RERELEASE'].includes(type)) {
                // 售后分析/原始数据重释放均需先选合同，按类型加载对应合同列表
                this.getEnforceContractOption('', 0)
            }
        },
        //纯分析项目选择 - 合同变更时重置该组项目，并联动其他组：清空销售/客户不一致的选择、刷新选项以应用最新过滤
        changePureAnalysisContract(index) {
            const contracts = this.formContract.pureAnalysisInfo.contracts || []
            const group = contracts[index]
            if (group) {
                group.projectIds = []
            }
            // 以所有组（含当前组新选择）为参考，清空其他组中销售/客户不一致的已选合同
            const reference = this.getPureAnalysisSalesCustomerReference(-1)
            contracts.forEach((c, i) => {
                if (i === index) return
                if (c.contractId && (reference.salesId || reference.customerContactsId)) {
                    const cSelected = (c.options || []).find(item => String(item.id) === String(c.contractId))
                    if (cSelected) {
                        const mismatch = (reference.salesId && String(cSelected.salesId || '') !== reference.salesId)
                            || (reference.customerContactsId && String(cSelected.customerContactsId || '') !== reference.customerContactsId)
                        if (mismatch) {
                            c.contractId = ''
                            c.projectIds = []
                        }
                    }
                }
                // 刷新其他组选项，使下拉列表应用最新的销售/客户过滤条件
                if (['AFTER_SALES_ANALYSIS', 'RAW_DATA_RERELEASE'].includes(this.formContract.pureAnalysisInfo.pureAnalysisType)) {
                    this.getEnforceContractOption('', i)
                }
            })
        },
        //纯分析项目选择 - 新增一组合同+项目
        addPureAnalysisContract() {
            this.formContract.pureAnalysisInfo.contracts.push({ contractId: '', projectIds: [], options: [] })
            const newIndex = this.formContract.pureAnalysisInfo.contracts.length - 1
            if (['AFTER_SALES_ANALYSIS', 'RAW_DATA_RERELEASE'].includes(this.formContract.pureAnalysisInfo.pureAnalysisType)) {
                this.getEnforceContractOption('', newIndex)
            }
        },
        //纯分析项目选择 - 删除指定组
        removePureAnalysisContract(index) {
            if (this.formContract.pureAnalysisInfo.contracts.length <= 1) return
            this.formContract.pureAnalysisInfo.contracts.splice(index, 1)
        },
        //合同去重 + 销售/客户一致性：已被其他组选中、或与其他组已选合同的销售/客户不一致的选项在当前组下拉中禁用
        isContractOptionDisabled(contractId, index) {
            if (!contractId) return false
            const contracts = this.formContract.pureAnalysisInfo.contracts || []
            // 已被其他组选中：禁用，保证每个合同仅能选择一次
            if (contracts.some((c, i) => i !== index && String(c.contractId) === String(contractId))) {
                return true
            }
            // 多组合同必须来自同一销售、同一客户：与其他组已选合同的销售/客户不一致时禁用
            const reference = this.getPureAnalysisSalesCustomerReference(index)
            if (!reference.salesId && !reference.customerContactsId) return false
            const currentGroup = contracts[index]
            const option = (currentGroup?.options || []).find(item => String(item.id) === String(contractId))
            if (!option) return false
            if (reference.salesId && String(option.salesId || '') !== reference.salesId) return true
            if (reference.customerContactsId && String(option.customerContactsId || '') !== reference.customerContactsId) return true
            return false
        },
        //提交兜底校验：纯分析多组合同不允许重复选择同一合同，且必须来自同一销售、同一客户（防止回显数据或异常操作绕过 UI 禁用）
        validatePureAnalysisContracts() {
            if (this.formContract.contractType !== 'TEAM' || this.formContract.projectType !== '纯分析') {
                return { valid: true }
            }
            const info = this.formContract.pureAnalysisInfo
            if (!info || !['AFTER_SALES_ANALYSIS', 'RAW_DATA_RERELEASE'].includes(info.pureAnalysisType)) {
                return { valid: true }
            }
            const contracts = Array.isArray(info.contracts) ? info.contracts : []
            const ids = contracts.map(c => c.contractId).filter(Boolean).map(id => String(id))
            const duplicated = ids.some((id, i) => ids.indexOf(id) !== i)
            if (duplicated) {
                return { valid: false, message: '纯分析项目选择中存在重复的合同，请确保每个合同仅选择一次' }
            }
            // 多组合同必须来自同一销售、同一客户
            const selectedList = contracts
                .map(c => (c.options || []).find(item => String(item.id) === String(c.contractId)))
                .filter(Boolean)
            if (selectedList.length > 1) {
                const firstSalesId = String(selectedList[0].salesId || '')
                const firstCustomerId = String(selectedList[0].customerContactsId || '')
                const inconsistent = selectedList.some(item =>
                    String(item.salesId || '') !== firstSalesId ||
                    String(item.customerContactsId || '') !== firstCustomerId
                )
                if (inconsistent) {
                    return { valid: false, message: '纯分析项目选择中的多个合同必须属于同一销售、同一客户' }
                }
            }
            return { valid: true }
        },
        //根据指定组已选合同解析项目下拉选项
        getProjectOptions(group) {
            if (!group || !group.contractId) return []
            const contract = (group.options || []).find(item => String(item.id) === String(group.contractId))
            const merged = [...new Set([...(contract?.specificProjectType || []).map(item => item.projectMainTypeId), ...(contract?.projectMainTypeIds || [])])]
            return this.ProjectOption.filter(item => merged.includes(item.id)).map(item => ({
                id: item.id,
                label: item.model + '-' + item.name
            }))
        },
        getRemainingAmount(contactId, applyContractId, successContractId) {
            if (contactId) {
                let params = {
                    contactId: contactId,
                    applyContractId: applyContractId ? applyContractId : '',
                    successContractId: successContractId ? successContractId : ''
                }
                getUserAmountById(params).then(res => {
                    if (res.code === 200) {
                        this.formContract.remainingAmount = res.data
                    } else {
                        this.formContract.remainingAmount = 0
                    }
                }).catch(err => { })
            } else {
                this.formContract.remainingAmount = 0
            }
        },
        changeMailNumber(value, type) {
            switch (type) {
                case 'invoice':
                    if (!this.isRecord && value) {
                        this.$messageUi.error('未选择添加发票，不能选择邮寄')
                        this.formMail.mailingContent.numberOfInvoice = 0
                    }
                    break;
                case 'report':
                    if (this.formMail.reportFile.length <= 0 && value) {
                        if (value === true) {
                            this.$messageUi.error('未上传结题报告，不能选择扫描结题报告')
                            this.formMail.mailingContent.reportScanningFlag = false
                        } else {
                            this.$messageUi.error('未上传结题报告，不能选择邮寄')
                            this.formMail.mailingContent.numberOfReport = 0
                        }
                    }
                    break;
                case 'reimbursement':
                    if (this.formMail.reimbursementFile.length <= 0 && value) {
                        if (value === true) {
                            this.$messageUi.error('未上传报账资料，不能选择扫描报账资料')
                            this.formMail.mailingContent.reimbursementScanningFlag = false
                        } else {
                            this.$messageUi.error('未上传报账资料，不能选择邮寄')
                            this.formMail.mailingContent.numberOfReimbursementFile = 0
                        }
                    }
                    break;
                case 'mail':
                    if (this.formMail.mailAttachment.length <= 0 && value) {
                        this.$messageUi.error('未上传单独邮寄附件，不能选择邮寄')
                        this.formMail.mailingContent.numberOfSingleMailFile = 0
                    }
                    break;
                default:
                    break;
            }
        },
        async addFileMail(id, annexType, name) {
            try {
                // 获取压缩包二进制
                const response = await attachmentMail(id, annexType, name);
                let fileList = []
                if ('application/x-zip-compressed' === response.file.type) {
                    const zipBlob = new Blob([response.file], { type: response.file.type });
                    // 解压缩为文件列表
                    fileList = await this.unzipToFileList(zipBlob);
                } else {
                    const file = new File([response.file], decodeURI(response.fileName), { type: response.file.type });
                    // 创建一个文件对象的包装对象
                    const fileWrapper = {
                        name: file.name,
                        status: 'ready',
                        url: '',
                        raw: file,
                    };
                    fileList = [fileWrapper]
                }
                switch (annexType) {
                    case 'MAIL_ANNEX':
                        this.formMail.mailAttachment = fileList.map(item => item);
                        this.mailFileList = fileList.map(item => item);
                        break;
                    case 'REPORT_ANNEX':
                        this.formMail.reportFile = fileList.map(item => item);
                        this.reportFileList = fileList.map(item => item);
                        break;
                    case 'REIMBURSEMENT_ANNEX':
                        this.formMail.reimbursementFile = fileList.map(item => item);
                        this.reimbursementFileList = fileList.map(item => item);
                        break;
                    default:
                        break;
                }
            } catch (error) {
                console.error('解压缩文件失败:', error);
            }
        },
        /**
        * 解压缩 ZIP 文件并返回文件列表
        * @param {Blob} zipBlob - ZIP 文件的 Blob 流
        * @returns {Promise<Array<File>>} - 解压后的文件列表
          */
        async unzipToFileList(zipBlob) {
            const zip = new JSZip();
            const fileList = [];

            // 加载 ZIP 文件
            const zipData = await zip.loadAsync(zipBlob);

            // 遍历 ZIP 文件中的每个文件
            for (const [relativePath, file] of Object.entries(zipData.files)) {
                if (!file.dir) { // 忽略目录
                    // 获取文件的 Blob 流
                    const fileBlob = await file.async('blob');

                    // 将 Blob 转换为 File 对象
                    const fileName = relativePath.split('/').pop(); // 获取文件名
                    const fileObject = new File([fileBlob], fileName, {
                        type: fileBlob.type || 'application/octet-stream',
                        lastModified: new Date().getTime(),
                    });
                    const fileWrapper = {
                        name: fileName,
                        status: 'ready',
                        url: '',
                        raw: fileObject,
                    };
                    fileList.push(fileWrapper);
                }
            }

            return fileList;
        },
        async addFileRecord(id) {
            try {
                const response = await downloadRecord(id);
                if (!response.file) {
                    return
                }
                const file = new File([response.file], decodeURI(response.fileName), { type: response.file.type });
                // 创建一个文件对象的包装对象
                const fileWrapper = {
                    name: file.name,
                    status: 'ready',
                    url: '',  // 如果需要，可以设置文件的URL
                    raw: file,  // 实际的文件对象
                };
                this.formRecord.invoiceRecordFile = fileWrapper
                this.recordFileList.push(fileWrapper)
                this.recordFileName = file.name
            } catch (error) {
                console.log(error);
            }
        },
        async addProjectAnnex(id, projectMainTypeId, draft = false) {
            try {
                const apiFunction = draft ? downloadProjectDraft : downloadProjectAnnex;
                const response = await apiFunction(id, projectMainTypeId);
                if (!response) {
                    return
                }
                const file = new File([response.file], decodeURI(response.fileName), { type: response.file.type });
                this.$set(this.formContract.projectAnnexFiles, projectMainTypeId, {
                    name: file.name,
                    file
                })
            } catch (error) {
                console.log(error);
            }
        },
        async addFileContract(id, annexType,isChange = false) {
            try {
                const response = await attachmentContract(id, annexType);
                if (!response.file) {
                    return
                }
                const file = new File([response.file], decodeURI(response.fileName), { type: response.file.type });
                // 创建一个文件对象的包装对象
                const fileWrapper = {
                    name: file.name,
                    status: 'ready',
                    url: '',  // 如果需要，可以设置文件的URL
                    raw: file,  // 实际的文件对象
                };
                switch (annexType) {
                    case 'CONTRACT_ANNEX':
                        if (isChange) {
                            this.oldContractFile.file = fileWrapper;
                            this.oldContractFile.name = file.name;
                        } else {
                            this.formContract.contractFilePath = fileWrapper;
                            this.contractFileList.push(fileWrapper);
                            this.contractFileName = file.name
                        }
                        break;
                    case 'SENIOR_ANALYSIS_ANNEX':
                        this.formContract.seniorAnalysisFile = fileWrapper
                        this.seniorFileList.push(fileWrapper)
                        this.seniorFileName = file.name
                        break;
                    case 'CUSTOMIZED_ANALYSIS_ANNEX':
                        this.formContract.customizedAnalysisFile = fileWrapper
                        this.customizedFileList.push(fileWrapper)
                        this.customizedFileName = file.name
                        break;
                    case 'PRICE_APPLE_ANNEX':
                        this.formContract.priceFile = fileWrapper
                        this.priceFileList.push(fileWrapper)
                        this.priceFileName = file.name
                        break;
                    default:
                        break;
                }
            } catch (error) {
                console.log(error);
            }
        },
        returnList(keys, data) {
            const order = ['NGS', 'PACBIO', 'HIC', 'ONT'];
            return Object.entries(keys).map(([key, value]) => {
                let name;
                switch (key) {
                    case "NGS":
                        name = "二代";
                        break;
                    case "PACBIO":
                        name = "三代";
                        break;
                    case "HIC":
                        name = "HIC";
                        break;
                    case "ONT":
                        name = "ONT";
                        break;
                    default:
                        name = ""; // 如果 key 不在预定义的列表中，name 为空字符串
                }
                let boolean = false;
                if (data && Object.values(data).length > 0) {
                    boolean = !!data[key];
                } else {
                    boolean = value !== "NOT";
                }
                return {
                    key: key,
                    value: value,
                    size: (data && data[key]) ? formatNumberWithUnit(Number(data[key])) : "",
                    boolean: boolean,
                    name: name // 添加 name 属性
                };
            }).sort((a, b) => order.indexOf(a.key) - order.indexOf(b.key));
        },
        getSizeList(type, name, sizeOfSampleData) {
            if (type === '' || name === '') {
                return []
            }
            const project = this.ProjectOption.find(item => item.model === type && item.name === name)
            if (project && project['geneSequencingSetting']) {
                return this.returnList(project['geneSequencingSetting'], sizeOfSampleData)
            } else {
                return []
            }
        },
        filterOption(value) {
            let name = '单细胞保护液'
            if (this.targetList.includes(this.formContract.projectType)) {
                name = this.formContract.projectType
            }
            let options = this.LexiconOptions.filter(item => item.materialName === name)
            if (value && value !== '') {
                return options.filter(item => !this.selectValue.includes(item.id) || item.id === value)
            }
            return options.filter(item => !this.selectValue.includes(item.id))
        },
        filterSpecsOption(value, specs) {
            if (value && value !== '') {
                return this.specsOption.filter(item => !this.formContract.materials.filter(item => item.materialId === value).map(item => item.specs).includes(item) || item === specs)
            }
            return JSON.parse(JSON.stringify(this.specsOption))
        },
        filterOptions(type, project) {
            const HARD_DISK_OPTIONS = [
                { model: '硬盘购买', name: '1T', deprecated: false },
                { model: '硬盘购买', name: '2T', deprecated: false },
                { model: '硬盘购买', name: '4T', deprecated: false },
                { model: '硬盘购买', name: '5T', deprecated: false },
                { model: '硬盘购买', name: '6T', deprecated: false },
                { model: '硬盘购买', name: '8T', deprecated: false },
                { model: '硬盘购买', name: '10T', deprecated: false },
                { model: '硬盘购买', name: '12T', deprecated: false },
                { model: '硬盘购买', name: '16T', deprecated: false },
                { model: '硬盘购买', name: '20T', deprecated: false }
            ];
            if (!type) {
                return [];
            }
            const options = type === '硬盘购买' ? HARD_DISK_OPTIONS : this.ProjectOption;
            const filterCondition = (item) => {
                if (item.model !== type) {
                    return false;
                }
                if (this.formContract.contractType === 'TEAM' && type === 'PCR' && item.name === '理化性质') {
                    return false;
                }
                if (type === '硬盘购买') {
                    const selectedSizes = (this.formContract.hardDiskPurchaseInfo || []).map(entry => entry.hardDiskSize).filter(size => size);
                    return !selectedSizes.includes(item.name) || (project && item.name === project);
                }
                return !this.projectTypeList.includes(item.name) || (project && item.name === project);
            };
            return options.filter(filterCondition);
        },
        async changeNumber(id, index) {
            if (this.LexiconOptions.length === 0) {
                await this.getLexiconOptions()
            }

            this.formContract.materials[index].remainingNumber = this.LexiconOptions.find(item => item.id === id).number
            this.formContract.materials[index].specs = ''
        },
        selectTitle(invoiceInfo, value) {
            const index = this.formRecord.invoiceInfos.indexOf(invoiceInfo)
            this.formRecord.invoiceInfos[index].taxRegistrationNumber = this.companyOption.find(item => item.id === value)?.taxRegistrationNumber
        },
        async getLexiconOptions() {
            try {
                let param = {
                    'type': 'PROTECT_REAGENT'
                }
                const res = await getMaterialType(param)
                if (res.code === 200) {
                    this.LexiconOptions = res.data.filter(item => item.number !== 0 && item['materialStatus'])
                }
            } catch (error) {
                console.log(error);
            }
        },
        changeContractNumber(contractNumber, type) {
            try { 
                const match = contractNumber.match(/^([A-Z]{3})(\d+)$/);
                if (!match) {
                    throw new Error('Invalid contract number format');
                }
                const [_, letters, numbers] = match;
                let newLetters;
                switch (type) {
                    case 'PREPAYMENTS':
                        newLetters = 'BZP';
                        break;
                    case 'CHARGEBACKS':
                        newLetters = 'BZD';
                        break;
                    case 'FORMAL':
                        newLetters = 'BZF';
                        break;
                    case 'DEVELOPMENT':
                        newLetters = 'BZR';
                        break;
                    case 'IMPORT_PREPAYMENTS':
                        newLetters = 'BZP';
                        break;
                    case 'TEAM':
                        newLetters = 'BZS';
                        break;
                    default:
                        throw new Error('Invalid type');
                }
                // 重新组合 contractNumber
                return `${newLetters}${numbers}`;
            }catch (error) {
                console.log(error);
            }
        },
        changeContractType(type) {
            if (!['submit', 'change', 'edit', 'adminEdits', 'salesManagerEdits'].includes(this.operation)) {
                    this.generateCode(type)
                } else {
                    if (!this.formContract.contractNumber) {
                        this.generateCode(type)
                    } else {
                        this.$set(this.formContract, 'contractNumber', this.changeContractNumber(this.formContract.contractNumber, type))
                    }
                }
                if (type) {
                    if (type === 'PREPAYMENTS') {
                        this.formContract.projectType = '预付款'
                        if (['adminEdits', 'salesManagerEdits'].includes(this.operation)) {
                            if (Number(this.selectDetail.addedAmount) === 0) {
                                this.formContract.addedType = false
                                this.formContract.addedAmount = 0
                                this.formContract.addedProportion = ''
                            } else {
                                const data = this.determineAddedType(this.selectDetail.contractAmount, this.selectDetail.addedAmount)
                                this.formContract.addedType = data.addedType
                                this.formContract.addedProportion = data.addedProportion
                                this.formContract.addedAmount = Number(this.selectDetail.addedAmount)
                            }
                            this.formContract.contractAmount = Number(this.selectDetail.contractAmount)
                        }
                    } else if (type === 'CHARGEBACKS') {
                        this.formContract.projectType = '预付款扣款（测序分析）'
                        if (['adminEdits', 'salesManagerEdits'].includes(this.operation)) {
                            this.formContract.contractAmount = Number(this.selectDetail.contractAmount)
                        }
                        this.isRecord = false
                        this.isMail = false
                    } else if (type === 'FORMAL') {
                        this.formContract.projectType = '测序分析'
                        if (['adminEdits', 'salesManagerEdits'].includes(this.operation)) {
                            this.formContract.contractAmount = Number(this.selectDetail.contractAmount)
                        }
                    } else if (type === 'DEVELOPMENT') {
                        this.formContract.contractAmount = 0
                        this.formContract.projectType = '测序分析'
                        this.formContract.specificProjectType.forEach((item, index) => {
                            item.projectAmount = 0
                        })
                        this.formContract.hardDiskPurchaseInfo.forEach((item, index) => {
                            item.projectAmount = 0
                        })
                    } else if (type === 'TEAM') {
                        this.formContract.projectType = '测序分析'
                    }
                }

        },
        async addFileManually(id, annexType, name) {
            try {
                const response = await downloadAttachment(id, annexType, name);
                if (!response.file) {
                    return
                }
                let fileList = []
                if ('application/x-zip-compressed' === response.file.type) {
                    const zipBlob = new Blob([response.file], { type: response.file.type });
                    // 解压缩为文件列表
                    fileList = await this.unzipToFileList(zipBlob);
                } else {
                    const file = new File([response.file], decodeURI(response.fileName), { type: response.file.type });
                    // 创建一个文件对象的包装对象
                    const fileWrapper = {
                        name: file.name,
                        status: 'ready',
                        url: '',
                        raw: file,
                    };
                    fileList = [fileWrapper]
                }
                switch (annexType) {
                    case 'CONTRACT_ANNEX':
                        this.formContract.contractFilePath = fileList[0];
                        this.contractFileList = fileList.map(item => item);
                        this.contractFileName = fileList[0].name
                        break;
                    case 'SENIOR_ANALYSIS_ANNEX':
                        this.formContract.seniorAnalysisFile = fileList[0];
                        this.seniorFileList = fileList.map(item => item);
                        this.seniorFileName = fileList[0].name
                        break;
                    case 'CUSTOMIZED_ANALYSIS_ANNEX':
                        this.formContract.customizedAnalysisFile = fileList[0];
                        this.customizedFileList = fileList.map(item => item);
                        this.customizedFileName = fileList[0].name
                        break;
                    case 'MAIL_ANNEX':
                        this.formMail.mailAttachment = fileList.map(item => item);
                        this.mailFileList = fileList.map(item => item);
                        break;
                    case 'LIST_OF_REAGENTS_ANNEX':
                        this.formRecord.invoiceRecordFile = fileList[0];
                        this.recordFileList = fileList.map(item => item);
                        this.recordFileName = fileList[0].name
                        break;
                    case 'REPORT_ANNEX':
                        this.formMail.reportFile = fileList.map(item => item);
                        this.reportFileList = fileList.map(item => item);
                        break;
                    case 'REIMBURSEMENT_ANNEX':
                        this.formMail.reimbursementFile = fileList.map(item => item);
                        this.reimbursementFileList = fileList.map(item => item);
                        break;
                    case 'PRICE_APPLE_ANNEX':
                        this.formContract.priceFile = fileList[0];
                        this.priceFileList = fileList.map(item => item);
                        this.priceFileName = fileList[0].name
                        break;    
                    default:
                        break;
                }
            } catch (error) {
                console.log(error);
            }
        },
        getCompanyOption() {
            getAllCompanyName().then(res => {
                if (res.code === 200) {
                    this.companyOption = res.data
                }
            }).catch(err => {
            })
        },
        changeProjectType() {
            const list = this.TypeOption.filter(item => item.disabled.includes(this.formContract.projectType)).map(item => item.label)
            this.formContract.specificProjectType = this.formContract.specificProjectType.filter(item => !list.includes(item.projectClassification))
            if (this.formContract.specificProjectType.length === 0) {
                this.handleAddProject()
            }
        },
        addProjectAmount(value, index) {
            let num = 0
            let list = this.formContract.specificProjectType[index].experimental.filter(item => this.formContract.specificProjectType[index].labList.includes(item.experimentName))
            for (let data of list) {
                const number = data.experimentAmount
                num = num + Number(number ? number : 0)
            }
            this.formContract.specificProjectType[index].projectAmount = num
        },
        //更改三代检测平台
        changeThirdSequencingPlatform(value,project) {
            project.thirdSequencingPlatform = project.tesThirdSequencingPlatform 
            this.$confirmUi('如果无法确认平台,请保持默认;是否更换平台?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                project.tesThirdSequencingPlatform = value
                project.thirdSequencingPlatform = value
            }).catch(() => {
                project.thirdSequencingPlatform = project.tesThirdSequencingPlatform
            });
        },
        handleAddProject() {
            if (!Array.isArray(this.formContract.specificProjectType)) {
                this.$set(this.formContract, 'specificProjectType', [])
            }
            let project = {
                experimental: [],
                experimentalProcessItems: [],
                sequencingPlatform: '',
                sequencingPlatformList: [],
                thirdSequencingPlatform: '',
                tesThirdSequencingPlatform:'',
                thirdSequencingPlatformList: [],
                projectSampleDataList: [],
                minSampleCount: '',
                maxSampleCount: '',
                projectMainTypeId: '',
                projectType: '',
                projectClassification: '',
                numberOfSamples: 0,
                projectAmount: 0,
                sizeOfSampleData: {},
                analysisList: [],
                analysis: '标准分析',
                multipleChoice: false,
                analysisChoiceList: [],
                labList: [],
                analyzeRequirements: ''
            }
            this.formContract.specificProjectType.push(project)
        },
        handleAddData(index) {
            let project = this.formContract?.specificProjectType[index]
            let projectList = JSON.parse(JSON.stringify(project?.projectSampleDataList?.[0]?.projectList ?? this.getSizeList(project.projectClassification, project.projectType)))
            for (let i = 0; i < projectList.length; i++) {
                projectList[i].size = ''
            }
            
            let data = {
                numberOfSamples: 0,
                sizeOfSampleData: {},
                projectList: projectList
            }
            this.formContract.specificProjectType[index].projectSampleDataList.push(data)
        },
        handleDeleteData(index, sonIndex) {
            this.formContract.specificProjectType[index].projectSampleDataList.splice(sonIndex, 1)
            if (this.formContract.specificProjectType[index].projectSampleDataList.length === 0) {
                this.handleAddData(index)
            }
        },
        handleAddMaterial() {
            let material = {
                materialId: '',
                materialNumber: '',
                remainingNumber: '',
                specs: ''
            }
            this.formContract.materials.push(material)
        },
        handleDeleteProject(item) {
            const index = this.formContract.specificProjectType.indexOf(item)
            if (index !== -1) {
                this.formContract.specificProjectType.splice(index, 1)
            }
            if (this.formContract.specificProjectType.length === 0) {
                this.handleAddProject()
            }
        },
        handleDeleteMaterial(item) {
            const index = this.formContract.materials.indexOf(item)
            if (index !== -1) {
                this.formContract.materials.splice(index, 1)
            }
        },
        changeProject(item) {
            const index = this.formContract.specificProjectType.indexOf(item)
            if (index !== -1) {
                this.$set(item, 'dataAmountUnit', '');
                this.$set(item, 'projectMainTypeId', '');
                this.$set(item, 'projectType', '');
                this.$set(item, 'projectSampleDataList', []);
                this.$set(item, 'minSampleCount', '');
                this.$set(item, 'maxSampleCount', '');
                this.$set(item, 'multipleChoice', false);
                this.$set(item, 'analysisList', []);
                this.$set(item, 'analysisChoiceList', []);
                this.$set(item, 'experimental', []);
                this.$set(item, 'experimentalProcessItems', []);
                this.$set(item, 'labList', []);
                this.$set(item, 'sequencingPlatform', '');
                this.$set(item, 'sequencingPlatformList', []);
                this.$set(item, 'thirdSequencingPlatform', '');
                this.$set(item, 'tesThirdSequencingPlatform', '');
                this.$set(item, 'thirdSequencingPlatformList', []);
            }
        },
        changeType(item) {
            const index = this.formContract.specificProjectType.indexOf(item)
            if (index !== -1) {
                this.$set(item, 'projectSampleDataList', [])
                this.$set(item, 'experimentalProcessItems', []);
                this.$set(item, 'dataAmountUnit', '');
                this.$set(item, 'projectMainTypeId', '');
                this.$set(item, 'minSampleCount', '');
                this.$set(item, 'maxSampleCount', '');
                this.$set(item, 'multipleChoice', false);
                this.$set(item, 'analysisList', []);
                this.$set(item, 'analysisChoiceList', []);
                this.$set(item, 'experimental', []);
                this.$set(item, 'labList', []);
                this.$set(item, 'sequencingPlatform', '');
                this.$set(item, 'sequencingPlatformList', []);
                this.$set(item, 'thirdSequencingPlatform', '');
                this.$set(item, 'tesThirdSequencingPlatform', '');
                this.$set(item, 'thirdSequencingPlatformList', []);


                this.handleAddData(index)
                const project = this.ProjectOption.find(itemA => itemA.name === item.projectType);
                if (project) {
                    this.$set(item, 'projectMainTypeId', project.id);
                    this.$set(item, 'dataAmountUnit', project.attribute.dataAmountUnit ? project.attribute.dataAmountUnit : '');
                    this.$set(item, 'minSampleCount', project.attribute.minSampleCount);
                    this.$set(item, 'maxSampleCount', project.attribute.maxSampleCount);
                    this.$set(item, 'multipleChoice', project.attribute.multipleChoice);
                    this.$set(item, 'analysisList', []);
                    this.$set(item, 'analysisChoiceList', project.attribute?.optionalAnalysisType?.split('/')?.filter(item => item !== '') ?? []);
                    if (project.attribute.labProcess) {
                        let list = project.attribute?.labProcess?.split('/')?.filter(item => item !== '') ?? []
                        for (let items of ['引物合成', '荧光定量']) {
                            const index1 = list.indexOf(items)
                            if (index1 !== -1) {
                                list.splice(index1, 1)
                                list.unshift(items)
                            }
                        }

                        let experimental = []
                        for (let info of list) {
                            let lab = {
                                experimentName: info,
                                numberOfExperiment: '',
                                experimentAmount: ''
                            }
                            experimental.push(lab)
                        }
                        this.$set(item, 'experimental', experimental);
                    } else {
                        this.$set(item, 'experimental', []);
                    }
                    this.$set(item, 'labList', []);
                    for (let items of ['引物合成', '荧光定量']) {
                        if (item.experimental.map(item => item.experimentName).includes(items)) {
                            item.labList.push(items)
                        }
                    }
                    if (!['其他', '硬盘购买'].includes(item.projectClassification)) {
                        if (item.projectClassification === 'AMPLICON') {
                            switch (project?.modelAttr?.sonModel) {
                                case 'SECOND':
                                    this.$set(item, 'sequencingPlatformList', project.attribute?.sequencingPlatform?.split('/')?.filter(item => item !== '') ?? []);
                                    this.$set(item, 'thirdSequencingPlatformList', []);
                                    break
                                case 'THIRD':
                                    this.$set(item, 'sequencingPlatformList', []);
                                    this.$set(item, 'thirdSequencingPlatformList', project.attribute?.sequencingPlatform?.split('/')?.filter(item => item !== '') ?? []);
                                    break
                                default:
                                    this.$set(item, 'sequencingPlatformList', []);
                                    this.$set(item, 'thirdSequencingPlatformList', []);
                                    break
                            }
                        } else {
                            this.$set(item, 'sequencingPlatformList', project.attribute?.sequencingPlatform?.split('/')?.filter(item => item !== '') ?? []);
                            this.$set(item, 'thirdSequencingPlatformList', project.attribute?.thirdSequencingPlatform?.split('/')?.filter(item => item !== '') ?? []);
                        }
                        if (!item.sequencingPlatform && item.sequencingPlatformList.length > 0) {
                            this.$set(item, 'sequencingPlatform', item.sequencingPlatformList[0]);
                        }
                        if (item.sequencingPlatformList.length === 0) {
                            this.$set(item, 'sequencingPlatform', '');
                        }
                        if (!item.thirdSequencingPlatform && item.thirdSequencingPlatformList.length > 0) {
                            console.log(1);
                            
                            if (item.thirdSequencingPlatformList.includes('纳米孔')) {
                                this.$set(item, 'thirdSequencingPlatform', '纳米孔');
                                this.$set(item, 'tesThirdSequencingPlatform', '纳米孔');
                            }else{
                                this.$set(item, 'thirdSequencingPlatform', item.thirdSequencingPlatformList[0]);
                                this.$set(item, 'tesThirdSequencingPlatform', item.thirdSequencingPlatformList[0]);
                            }
                        }
                        if (item.thirdSequencingPlatformList.length === 0) {
                            this.$set(item, 'thirdSequencingPlatform', '');
                            this.$set(item, 'tesThirdSequencingPlatform', '');
                        }
                    } else {
                        this.$set(item, 'sequencingPlatformList', []);
                        this.$set(item, 'thirdSequencingPlatformList', []);
                    }
                }
            }
        },
        //更改乙方公司
        changeTrusteeCompany(value) {
            if (Number(value) !== 1) {
                this.formContract.watermarkFlag = false
            }
        },
        getBusinessOption() {
            try {
                let params = {
                    'page.current': 1,
                    'page.size': 500,
                    'order': 'id.asc'
                }
                getCompanyPage(params, {}).then(res => {
                    if (res.code === 200) {
                        this.businessOption = res.data.records.filter(item => item['companyInvoiceStatus'])
                        if (!this.businessOption.find(item => item.id === this.formContract.trusteeCompanyId)) {
                            this.formContract.trusteeCompanyId = this.businessOption[0].id
                        }
                        this.formRecord.invoiceInfos.forEach(item => {
                            if (!this.businessOption.find(item => item.id === item.billingUnitId)) {
                                item.billingUnitId = this.businessOption[0].id
                            }
                        })
                    }
                }).catch(err => { })
            } catch (error) {
                console.log(error);
                this.$messageUi.error('获取开票单位信息失败');
            }
        },
        validateForm(ref) {
            return new Promise((resolve) => {
                this.$refs[ref]['validate']((valid) => {
                    resolve(valid);
                });
            });
        },
        addAllAmount() {
            if (this.formContract.contractType === 'DEVELOPMENT') {
                this.formContract.contractAmount = 0
                return
            }
            const maxAmount = (this.projectTypeData.includes(this.formContract.projectType)) ? Number(this.maxAmount) : 0
            const hardDiskPurchaseAmount = (this.hardDiskList.includes(this.formContract.projectType)) ? Number(this.hardDiskPurchaseAmount || 0) : 0
            const sampleAmount = (this.projectTypeData.includes(this.formContract.projectType) && this.formContract.returnFlag) ? Number(this.formContract.sampleAmount) : 0
            const hasAnalysis = () => ['预付款扣款（测序分析）', '测序分析'].includes(this.formContract.projectType)
            const seniorAnalysisAmount = (hasAnalysis() && this.formContract.moreAnalysis.includes('SENIOR_ANALYSIS')) ? Number(this.formContract.seniorAnalysisAmount) : 0
            const customizedAnalysisAmount = (hasAnalysis() && this.formContract.moreAnalysis.includes('CUSTOMIZED_ANALYSIS')) ? Number(this.formContract.customizedAnalysisAmount) : 0
            const hasDoorFee = () => ['单细胞解离转录组-C4', '单细胞解离转录组-10X', '单细胞解离转录组'].some(item => this.formContract.specificProjectType.map(project => project.projectType).includes(item)) && this.formContract.protectiveFluidInfo.protectiveFluidMethod === 'DOOR' && this.projectTypeData.includes(this.formContract.projectType)

            const doorFee = hasDoorFee() ? Number(this.formContract.protectiveFluidInfo.doorInfo.doorFee) : 0

            this.formContract.contractAmount = seniorAnalysisAmount + customizedAnalysisAmount + maxAmount + hardDiskPurchaseAmount + sampleAmount + doorFee
        },
        addHardDiskPurchaseItem() {
            if (!Array.isArray(this.formContract.hardDiskPurchaseInfo)) {
                this.formContract.hardDiskPurchaseInfo = []
            }
            const options = this.filterOptions('硬盘购买')
            const selectedSizes = this.formContract.hardDiskPurchaseInfo.map(entry => entry.hardDiskSize).filter(size => size)
            const nextOption = options.find(opt => !selectedSizes.includes(opt.name))
            this.formContract.hardDiskPurchaseInfo.push({
                hardDiskSize: nextOption ? nextOption.name : '',
                projectAmount: 0,
                sampleCount: 0
            })
            this.showHardDiskPurchaseInfo = true
        },
        removeHardDiskPurchaseItem(index) {
            if (!Array.isArray(this.formContract.hardDiskPurchaseInfo)) {
                return
            }
            this.formContract.hardDiskPurchaseInfo.splice(index, 1)
        },
        validateHardDiskProjectAmount(rule, value, callback) {
            if (this.formContract.contractType === 'DEVELOPMENT') {
                return callback()
            }
            if (value === '' || value === null || value === undefined) {
                return callback()
            }
            const number = Number(value)
            if (!isNaN(number) && number > 0) {
                return callback()
            }
            callback(new Error('请输入大于等于0的数字'))
        },
        validateHardDiskSampleCount(rule, value, callback) {
            if (value === '' || value === null || value === undefined) {
                return callback()
            }
            const str = String(value).trim()
            const number = Number(value)
            if (/^\d+$/.test(str) && !isNaN(number) && number > 0) {
                return callback()
            }
            callback(new Error('请输入大于等于0的整数'))
        },

        /**
   * 使用 decimal.js 精确计算按比例金额并四舍五入取整数（用于比例选择时的赋值/展示）
   */
        calculateAmountInteger(contractAmount, proportion) {
            try {
                const ca = new Decimal(contractAmount || 0);
                const p = new Decimal(proportion || 0);
                // 四舍五入取整数
                const rounded = ca.mul(p).toDecimalPlaces(0, Decimal.ROUND_HALF_UP);
                return Number(rounded.toString());
            } catch (e) {
                return 0;
            }
        },
        /**
           * 当选择比例时的处理（使用精确计算并四舍五入为整数）
           */
        onProportionChange(value) {
            const amount = this.calculateAmountInteger(this.formContract.contractAmount, value);
            this.formContract.addedAmount = amount;
        },
        /**
             * 获取下拉每项的显示文本，使用精确计算并显示四舍五入整数
             */
        getProportionLabel(item) {
            const amount = this.calculateAmountInteger(this.formContract.contractAmount, item.value);
            return `${amount} (${item.label})`;
        },
        /**
     * 使用 decimal.js 判断增值类型（比例或金额）
     * 规则：
     *  - 若合同金额为 0 或 非法，视为未增值（false）
     *  - 若新增金额为 0，视为未增值（false）
     *  - 若新增金额为整数，则允许与合同金额*比例四舍五入后相等时判定为比例类型
     *  - 否则按精确比例比较
     */
        determineAddedType(contractAmount, addedAmount) {
            try {
                const ca = new Decimal(contractAmount || 0);
                const aa = new Decimal(addedAmount || 0);
                if (ca.eq(0)) {
                    return { addedType: false, addedProportion: '' };
                }
                if (aa.eq(0)) {
                    return { addedType: false, addedProportion: '' };
                }

                // 若增值金额为整数 -> 允许用四舍五入后的合同金额*比例比较
                if (aa.isInteger()) {
                    const matched = this.proportionOptions.find(opt => {
                        try {
                            const expectedRounded = ca.mul(new Decimal(opt.value)).toDecimalPlaces(0, Decimal.ROUND_HALF_UP);
                            return aa.equals(expectedRounded);
                        } catch (e) {
                            return false;
                        }
                    });
                    if (matched) {
                        return { addedType: 'proportion', addedProportion: Number(matched.value) };
                    } else {
                        return { addedType: 'number', addedProportion: '' };
                    }
                } else {
                    // 非整数，按精确比例判断
                    const ratio = aa.div(ca);
                    const matched = this.proportionOptions.find(opt => {
                        try {
                            return new Decimal(opt.value).equals(ratio);
                        } catch (e) {
                            return false;
                        }
                    });
                    if (matched) {
                        return { addedType: 'proportion', addedProportion: Number(matched.value) };
                    } else {
                        return { addedType: 'number', addedProportion: '' };
                    }
                }
            } catch (e) {
                return { addedType: 'number', addedProportion: '' };
            }
        },
        createName() {
            let nameLast = ''
            if (this.projectTypeData.includes(this.formContract.projectType)) {
                for (let project of this.formContract.specificProjectType) {
                    if (['硬盘购买', 'PCR'].includes(project.projectClassification)) {
                        continue
                    }
                    if (project.projectStatus === 'TERMINATION') {
                        continue
                    }
                    let sum = 0
                    for (let data of project.projectSampleDataList) {
                        sum = sum + Number(data.numberOfSamples)
                    }
                    nameLast = nameLast + sum + '个' + '-' + project.projectType + '-'
                }
            }
            const name = ['测序分析', '裸测', '纯分析'].find(item => this.formContract.projectType.includes(item))
            this.formContract.contractName = nameLast + (name ? name : '')
        },

        validateContractAmount() {
            if (this.formContract.contractType === 'DEVELOPMENT') {
                return { valid: true, message: '' }
            }

            // 团队费用合同：测序分析金额不超过800，纯分析金额不超过1500
            const teamAmountError = checkTeamContractAmount(this.formContract, this.formContract.contractAmount)
            if (teamAmountError) {
                return { valid: false, message: teamAmountError }
            }

            const contractAmount = Number(this.formContract.contractAmount || 0)
            const hardDiskPurchaseAmount = Number(this.hardDiskPurchaseAmount || 0)
            const sampleAmount = (this.projectTypeData.includes(this.formContract.projectType) && this.formContract.returnFlag && this.formContract.contractType !== 'DEVELOPMENT') ? Number(this.formContract.sampleAmount || 0) : 0
            const doorFee = ['单细胞解离转录组-C4', '单细胞解离转录组-10X', '单细胞解离转录组'].some(item => this.formContract.specificProjectType.map(project => project.projectType).includes(item)) && this.formContract.protectiveFluidInfo.protectiveFluidMethod === 'DOOR' ? Number(this.formContract.protectiveFluidInfo.doorInfo.doorFee || 0) : 0

            if (this.projectTypeData.includes(this.formContract.projectType)) {
                if (['预付款扣款（测序分析）', '测序分析'].includes(this.formContract.projectType)) {
                    const seniorAnalysisAmount = this.formContract.moreAnalysis.includes('SENIOR_ANALYSIS') ? Number(this.formContract.seniorAnalysisAmount || 0) : 0
                    const customizedAnalysisAmount = this.formContract.moreAnalysis.includes('CUSTOMIZED_ANALYSIS') ? Number(this.formContract.customizedAnalysisAmount || 0) : 0
                    const expectedAmount = seniorAnalysisAmount + customizedAnalysisAmount + Number(this.maxAmount || 0) + hardDiskPurchaseAmount + sampleAmount + doorFee
                    if (expectedAmount !== contractAmount) {
                        return { valid: false, message: '项目与分析总金额不等于合同金额，请检查' }
                    }
                } else {
                    const expectedAmount = Number(this.maxAmount || 0) + hardDiskPurchaseAmount + sampleAmount + doorFee
                    if (expectedAmount !== contractAmount) {
                        return { valid: false, message: '项目总金额不等于合同金额，请检查' }
                    }
                }
            } else if (this.hardDiskList.includes(this.formContract.projectType)) {
                if (!(contractAmount >= hardDiskPurchaseAmount)) {
                    return { valid: false, message: '合同金额必须大于等于硬盘总金额，请检查' }
                }
            }

            return { valid: true, message: '' }
        },

        // 构建合同提交数据（公共逻辑）
        buildContractPayload(formContract) {
            const result = JSON.parse(JSON.stringify(formContract))

            // 水印
            if (!this.companyIds.includes(Number(result.trusteeCompanyId))) {
                result.watermarkFlag = false
            }

            // 日期格式化
            result.signingDate = padDate(result.signingDate)
            result.contractDraftingDate = padDate(result.contractDraftingDate)

            // 增值金额
            if (result.contractType === 'PREPAYMENTS') {
                if (!result.addedType) {
                    result.addedAmount = 0
                }
                if (result.addedType === 'proportion' && result.addedProportion) {
                    result.addedAmount = this.calculateAmountInteger(result.contractAmount, result.addedProportion)
                }
            } else {
                result.addedAmount = 0
            }

            // 补充分析要求
            if (['预付款扣款（测序分析）', '测序分析'].includes(result.projectType) && result.contractType !== 'DEVELOPMENT') {
                result.moreAnalysisRequest = result.moreAnalysis.reduce((acc, item) => {
                    if (item === 'SENIOR_ANALYSIS') {
                        acc[item] = result.seniorAnalysisAmount
                    } else if (item === 'CUSTOMIZED_ANALYSIS') {
                        acc[item] = result.customizedAnalysisAmount
                    }
                    return acc
                }, {})
            } else {
                result.moreAnalysisRequest = {}
                result.analysisRequest = null
            }

            // 生成合同信息
            if (['预付款扣款（测序分析）', '预付款扣款（裸测）', '测序分析', '裸测', '预付款'].includes(result.projectType)) {
                if (result.methods === 'FULL_AMOUNT') {
                    result.generateContractInfo.paymentMethods = { [result.methods]: 1 }
                } else {
                    result.generateContractInfo.paymentMethods = { [result.methods]: Number(result.theFirstRatio) / 100 }
                }
                let returnSample = {}
                if (['预付款扣款（测序分析）', '预付款扣款（裸测）', '测序分析', '裸测'].includes(result.projectType) && result.contractType !== 'DEVELOPMENT') {
                    returnSample.returnSampleFlag = result.returnFlag
                    returnSample.returnSampleAmount = result.returnFlag ? result.sampleAmount : 0
                    returnSample.reason = result.returnFlag && Number(result.sampleAmount) === 0 ? result.reason : ''
                }
                result.generateContractInfo.returnSampleBo = returnSample
                result.generateContractInfo.extractionFlag = result.extractionFlag
                result.generateContractInfo.extractionNumber = result.extractionNumber
                result.generateContractInfo.watermarkFlag = result.watermarkFlag
            } else {
                result.generateContractInfo.paymentMethods = {}
                result.generateContractInfo.returnSampleBo = {}
                result.generateContractInfo.extractionFlag = false
                result.generateContractInfo.extractionNumber = ''
                result.generateContractInfo.watermarkFlag = false
            }

            // 项目类型数据处理
            if (!this.projectTypeData.includes(result.projectType)) {
                result.specificProjectType = []
            }

            // 团队合同：清空硬盘选购信息（页面 v-if 包含 contractType !== 'TEAM'）
            if (result.contractType === 'TEAM') {
                result.hardDiskPurchaseInfo = []
            }

            // 处理项目数据
            result.specificProjectType.forEach(item => {
                item.projectSampleDataList.forEach(dataItem => {
                    if (dataItem.projectList.length > 0 && !['METAPRO', '硬盘购买', 'PCR'].includes(item.projectClassification)) {
                        const newSizeOfSampleData = dataItem.projectList.reduce((acc, projectItem) => {
                            if (projectItem.boolean) {
                                let size = projectItem.size
                                const unit = size.replace(/[0-9.]/g, '').toLowerCase()
                                const numericValue = parseFloat(size.replace(/[^\d.]/g, ''))
                                switch (unit) {
                                    case 'w': size = numericValue * 10000; break
                                    case 'm': size = numericValue * 1000000; break
                                    default: size = numericValue; break
                                }
                                acc[projectItem.key] = size
                            }
                            return acc
                        }, {})
                        this.$set(dataItem, 'sizeOfSampleData', newSizeOfSampleData)
                    }
                    if (item.experimental.length > 0) {
                        let num = 0
                        const list = item.experimental.filter(itemA => item.labList.includes(itemA.experimentName))
                        for (const data of list) {
                            const number = data.numberOfExperiment
                            num = num + Number(number ? number : 0)
                        }
                        this.$set(dataItem, 'numberOfSamples', num)
                        this.$set(item, 'experimentalProcessItems', item.experimental.filter(it => item.labList.includes(it.experimentName)))
                    }
                })

                // 二代/三代平台清空
                const hasSecondGen = item.projectSampleDataList.some(di =>
                    Array.isArray(di.projectList) && di.projectList.some(p => p.name === '二代' && p.boolean)
                )
                if (!hasSecondGen) {
                    this.$set(item, 'sequencingPlatform', '')
                }
                const hasThirdGen = item.projectSampleDataList.some(di =>
                    Array.isArray(di.projectList) && di.projectList.some(p => p.name === '三代' && p.boolean)
                )
                if (!hasThirdGen) {
                    this.$set(item, 'thirdSequencingPlatform', '')
                    this.$set(item, 'tesThirdSequencingPlatform', '')
                }

                // 分析要求
                if (item.projectClassification !== '硬盘购买' && !['预付款扣款（裸测）', '裸测'].includes(result.projectType)) {
                    if (item.analysis === '标准分析') {
                        item.analyzeRequirements = '标准分析'
                        if (item.analysisChoiceList.length > 0 && !(item.analysisChoiceList.includes('标准分析') && item.analysisChoiceList.length === 1)) {
                            item.analyzeRequirements = item.analysisList.join('/')
                        }
                    } else {
                        item.analyzeRequirements = '非标准分析'
                    }
                } else {
                    item.analyzeRequirements = ''
                }
            })

            // 物料清空
            if (!(this.targetList.includes(result.projectType) || (['单细胞解离转录组-C4', '单细胞解离转录组-10X', '单细胞解离转录组'].some(item => result.specificProjectType.map(project => project.projectType).includes(item)) && result.protectiveFluidInfo.protectiveFluidMethod === 'MAIL'))) {
                result.materials = []
            }

            // 保护液信息
            if (!['单细胞解离转录组-C4', '单细胞解离转录组-10X', '单细胞解离转录组'].some(item => result.specificProjectType.map(project => project.projectType).includes(item))) {
                result.protectiveFluidInfo = {}
            } else {
                if (result.protectiveFluidInfo.protectiveFluidMethod === 'MAIL') {
                    result.protectiveFluidInfo.doorInfo = {}
                } else {
                    result.protectiveFluidInfo.materialMailInfo = {}
                }
            }

            // 非团队合同+纯分析时清空纯分析项目选择
            if (!(result.contractType === 'TEAM' && result.projectType === '纯分析')) {
                result.pureAnalysisInfo = null
            } else if (result.pureAnalysisInfo) {
                // 提交前剥离仅供 UI 使用的合同下拉选项；仅售后分析/原始数据重释放需要提交合同组
                const info = result.pureAnalysisInfo
                if (['AFTER_SALES_ANALYSIS', 'RAW_DATA_RERELEASE'].includes(info.pureAnalysisType)) {
                    info.contracts = (Array.isArray(info.contracts) ? info.contracts : []).map(c => ({
                        contractId: c.contractId,
                        projectIds: Array.isArray(c.projectIds) ? c.projectIds : []
                    }))
                } else {
                    info.contracts = []
                }
            }

            return result
        },

        async openTemplate() {
            let remainingAmount = Number(this.formContract.remainingAmount)
            if (Number(this.formContract.contractAmount) > Number(remainingAmount) && this.formContract.contractType === 'CHARGEBACKS') {
                this.$messageUi.error('扣款金额大于甲方剩余金额，请检查')
                return
            }
            const validation = this.validateContractAmount()
            if (!validation.valid) {
                this.$messageUi.error(validation.message)
                return
            }
            const rules = this.$refs.formContract.rules;
            const tempRule = rules['contractFilePath'];
            delete rules['contractFilePath'];
            const [contractFormValid] = await Promise.all([
                this.validateForm('formContract')
            ]);
            rules['contractFilePath'] = tempRule;
            if (contractFormValid) {
                const pureValidation = this.validatePureAnalysisContracts()
                if (!pureValidation.valid) {
                    this.$messageUi.error(pureValidation.message)
                    return
                }
                const formContract = this.buildContractPayload(this.formContract)

                const data = {
                    customizeFlag: false,
                    sequencingContractInputBo: Object.keys(formContract).reduce((acc, key) => {
                        if (!['contractFilePath', 'customizedAnalysisFile', 'seniorAnalysisFile', 'priceFile', 'projectAnnexFiles'].includes(key)) {
                            acc[key] = formContract[key]
                        }
                        return acc
                    }, {})
                }

                const response = await templateGeneration(data)
                if (!response || !response.file) {
                    return
                }
                const file = new File([response.file], decodeURI(response.fileName), { type: response.file.type })
                this.templateFile = {
                    name: file.name,
                    status: 'ready',
                    url: '',
                    raw: file,
                }
                this.templateFileName = file.name
                this.$messageUi.success('已生成合同')
            } else {
                this.$nextTick(() => {
                    const err = document.getElementsByClassName('is-error')
                    if (err.length) {
                        err[0].scrollIntoView({
                            block: 'center',
                            behavior: 'smooth',
                        })
                    }
                })
                this.$messageUi.error('填写参数不规范，请检查')
            }
        },
        changeAnalysisChoice(value, project) {
            if (value.includes('normal') && value.includes('binning')) {
                const last = value.slice(-1)[0];
                const index = this.formContract.specificProjectType.indexOf(project)
                let val = value.filter(item => !['normal', 'binning'].includes(item))
                val.push(last)
                this.$set(this.formContract.specificProjectType[index], 'analysisList', val)
            }
        },
        usedTemplate() {
            if (!this.templateFile) {
                this.$messageUi.error('未生成合同文件，请检查')
            } else {
                this.formContract.contractFilePath = this.templateFile
                this.contractGenerationFlag = true
                this.contractFileList.push(this.templateFile)
                this.contractFileName = this.templateFileName
            }
        },
        downloadFile(rawFile) {
            try {
                if (!rawFile) {
                    this.$messageUi.error('文件不存在，请检查')
                    return
                }
                fileDownload(rawFile, rawFile.name)
            } catch (error) {
                console.log(error);
            }
        },
        async handle() {
            try {
                this.loading = true
                let remainingAmount = Number(this.formContract.remainingAmount)
                if (Number(this.formContract.contractAmount) > Number(remainingAmount) && this.formContract.contractType === 'CHARGEBACKS') {
                    this.$messageUi.error('扣款金额大于甲方剩余金额，请检查')
                    this.loading = false
                    return
                }
                const validation = this.validateContractAmount()
                if (!validation.valid) {
                    this.$messageUi.error(validation.message)
                    this.loading = false
                    return
                }
                if (this.isRecord && this.formContract.contractType !== 'DEVELOPMENT') {
                    const invoiceAmounts = this.formRecord.invoiceInfos.map(item => {
                        const amount = Number(item.invoiceAmount); // 将可能的字符串形式转换为数字
                        return amount > 0 ? amount : 0; // 如果为大于0的数字，返回自身，否则返回0
                    }).reduce((sum, amount) => sum + amount, 0);
                    if (invoiceAmounts > this.formContract.contractAmount) {
                        this.$messageUi.error('开票金额超出可开票金额' + Math.abs(invoiceAmounts - this.formContract.contractAmount) + ',请检查')
                        this.loading = false
                        return
                    }
                    if (this.formRecord.invoiceInfos.length <= 0) {
                        this.$messageUi.error('请申请至少一张发票')
                        this.loading = false
                        return
                    }
                }
                // 表单验证
                const [contractFormValid, recordFormValid, mailFormValid] = await Promise.all([
                    this.validateForm('formContract'),
                    this.isRecord ? this.validateForm('formRecord') : true,
                    this.isMail ? this.validateForm('formMail') : true
                ]);
                if (contractFormValid && recordFormValid && mailFormValid) {
                    const pureValidation = this.validatePureAnalysisContracts()
                    if (!pureValidation.valid) {
                        this.$messageUi.error(pureValidation.message)
                        this.loading = false
                        return
                    }
                    const formContract = this.buildContractPayload(this.formContract)
                    const formRecord = { ...this.formRecord, status: 'APPLYING' }
                    const formMail = { ...this.formMail }
                    formRecord.applicationDate = padDate(formRecord.applicationDate)
                    formMail.applicantDate = padDate(formMail.applicantDate)

                    const formData = new FormData();
                    // 补充分析文件

                    if (['预付款扣款（测序分析）', '测序分析'].includes(formContract.projectType) && formContract.contractType !== 'DEVELOPMENT') {
                        if (formContract.customizedAnalysisFile && this.formContract.moreAnalysis.includes('CUSTOMIZED_ANALYSIS')) {
                            formData.append('customizedAnalysisFile', this.formContract.customizedAnalysisFile.raw);
                        }
                        if (formContract.seniorAnalysisFile && this.formContract.moreAnalysis.includes('SENIOR_ANALYSIS')) {
                            formData.append('seniorAnalysisFile', this.formContract.seniorAnalysisFile.raw);
                        }
                    }
                    // 项目附件
                    if (Object.keys(this.formContract.projectAnnexFiles || {}).length > 0) {
                        for (const [key, value] of Object.entries(this.formContract.projectAnnexFiles)) {
                            if (this.formContract.specificProjectType.some(item => item.projectMainTypeId === key) && value.file) {
                                formData.append(`projectAnnexFiles[${key}]`, value.file);
                            }
                        }
                    }
                    // 合同附件
                    if (formContract.contractType !== 'DEVELOPMENT' && !['salesManagerEdits'].includes(this.operation)) {
                        if (this.formContract.contractFilePath) {
                            formData.append('contractFile', this.formContract.contractFilePath.raw);
                        } else if (!['预付款扣款（返样/暂存样品）', '返样/暂存样品'].includes(formContract.projectType) && !['change'].includes(this.operation)) {
                            this.$messageUi.error('请上传合同附件')
                            this.loading = false
                            return
                        }
                    }
                    // 价格申请截图
                    if (this.formContract.priceFile && ['add', 'edit', 'submit','change'].includes(this.operation)) {
                        formData.append('priceFile', this.formContract.priceFile.raw);
                    }
                    if (this.operation === 'edit') {
                        formContract.draftId = this.form.id
                    }
                    const jsonStrContract = JSON.stringify(
                        Object.keys(formContract).reduce((acc, key) => {
                            if (!['contractFilePath', 'customizedAnalysisFile', 'seniorAnalysisFile', 'priceFile','projectAnnexFiles'].includes(key)) {
                                acc[key] = formContract[key];
                            }
                            return acc;
                        }, {})
                    );
                    const blobContract = new Blob([jsonStrContract], {
                        type: 'application/json'
                    });
                    if (['adminEdits', 'salesManagerEdits'].includes(this.operation)) {
                        formData.append("info", blobContract);
                    } else if (this.operation === 'change') {
                        let data = {
                            changeInfo: jsonStrContract,
                            contractGenerationFlag: this.formContract.contractFilePath === this.templateFile || this.contractGenerationFlag
                        }
                        const blob = new Blob([JSON.stringify(data)], {
                            type: 'application/json'
                        });
                        formData.append("contractInfo", blob);
                    } else {
                        formData.append("contractInfo", blobContract);
                    }

                    if (this.isMail && ['add', 'edit', 'submit'].includes(this.operation) && (formContract.contractType !== 'DEVELOPMENT' || this.targetList.includes(formContract.projectType))) {
                        if (!this.isRecord) {
                            if (formMail.mailAttachment.length > 0) {
                                for (let file of formMail.mailAttachment) {
                                    formData.append('mailFile', file.raw);
                                }
                            }
                        } else {
                            formMail.mailingContent.singleMailFileExplain = ''
                        }
                        if (formMail.reportFile.length > 0) {
                            for (let file of formMail.reportFile) {
                                formData.append('reportFile', file.raw);
                            }
                        }
                        if (formMail.reimbursementFile.length > 0) {
                            for (let file of formMail.reimbursementFile) {
                                formData.append('reimbursementFile', file.raw);
                            }
                        }

                        const jsonStrMail = JSON.stringify(
                            Object.keys(formMail).reduce((acc, key) => {
                                if (!['mailAttachment', 'reportFile', 'reimbursementFile'].includes(key)) {
                                    acc[key] = formMail[key];
                                }
                                return acc;
                            }, {})
                        );
                        const blobMail = new Blob([jsonStrMail], {
                            type: 'application/json'
                        });
                        if (this.operation === 'submit') {
                            if (this.mailSelectDetail && Object.keys(this.mailSelectDetail).length > 0) {
                                formData.append("mailInfoEdit", blobMail);
                            } else {
                                formData.append("mailInfoInput", blobMail);
                            }
                        } else {
                            formData.append("mailInfo", blobMail);
                        }
                    }
                    if (this.isRecord && ['add', 'edit', 'submit'].includes(this.operation) && formContract.contractType !== 'DEVELOPMENT') {
                        if (formRecord.invoiceRecordFile) {
                            formData.append('invoiceRecordFile', formRecord.invoiceRecordFile.raw); // 文件
                        }
                        const jsonStrRecord = JSON.stringify(Object.keys(formRecord).reduce((acc, key) => {
                            if (!['invoiceRecordFile'].includes(key)) {
                                acc[key] = formRecord[key];
                            }
                            return acc;
                        }, {}));
                        const blobRecord = new Blob([jsonStrRecord], {
                            type: 'application/json'
                        });
                        if (this.operation === 'submit') {
                            if (this.invoiceSelectDetail && Object.keys(this.invoiceSelectDetail).length > 0) {
                                formData.append("invoiceInfoEdit", blobRecord);
                            } else {
                                formData.append("invoiceInfoInput", blobRecord);
                            }
                        } else {
                            formData.append("invoiceInfo", blobRecord);
                        }
                    }
                    if (this.operation === 'change') {
                        // 合同变更
                        changeContract(formData).then(res => {
                            this.loading = false
                            if (res.code === 200) {
                                this.$messageUi.success('提交成功')
                                this.$emit('submit', 'confirm')
                                this.$store.commit('right/setChangeRed', true)
                            }
                        }).catch(err => {
                            this.loading = false
                        })
                    } else if (this.operation === 'submit') {
                        editContractRecordMail(formData).then(res => {
                            this.loading = false
                            if (res.code === 200) {
                                this.$emit('submit', 'confirm')
                                this.$messageUi.success('修改成功')
                                this.$store.commit('right/setChangeRed', true)
                            }
                        }).catch(err => {
                            this.loading = false
                        })
                    } else if (['adminEdits','salesManagerEdits'].includes(this.operation)) {
                        adminEdit(formData).then(res => {
                            this.loading = false
                            if (res.code === 200) {
                                this.$emit('submit', 'confirm')
                                this.$messageUi.success('修改成功')
                                this.$store.commit('right/setChangeRed', true)
                            }
                        }).catch(err => {
                            this.loading = false
                        })
                    } else {
                        // 添加以及草稿的编辑
                        addContractRecordMail(formData).then(res => {
                            this.loading = false
                            if (res.code === 200) {
                                this.$emit('submit', 'confirm')
                                this.$messageUi.success('提交成功')
                                this.$store.commit('right/setChangeRed', true)
                            }
                        }).catch(err => {
                            this.loading = false
                        })
                    }
                } else {
                    this.loading = false
                    this.$nextTick(() => {
                        let err = document.getElementsByClassName('is-error')
                        if (err.length) {
                            err[0].scrollIntoView({
                                block: 'center',
                                behavior: 'smooth',
                            })
                        }
                    })
                    this.$messageUi.error('填写参数不规范，请检查')
                }
            } catch (error) {
                console.log(error);
                this.loading = false
                this.$messageUi.error('提交失败，请稍后再试！')
            }
        },
        handleDelete(item) {
            const index = this.formRecord.invoiceInfos.indexOf(item)
            if (index !== -1) {
                if (this.formRecord.invoiceInfos[index].id) {
                    this.formRecord.invoiceIds.push(this.formRecord.invoiceInfos[index].id)
                }
                this.formRecord.invoiceInfos.splice(index, 1)
            }
            if (this.formRecord.invoiceInfos.length <= 0 || !Array.isArray(this.formRecord.invoiceInfos)) {
                const company = this.businessOption[0]
                this.formRecord.invoiceInfos = [{
                    billingUnitId: company.id,//开票单位
                    invoiceTitleId: '',
                    invoiceAmount: 0,
                    invoiceType: '',
                    invoiceContent: '',
                    remark: '',
                }]
            }
        },
        handleAdd() {
            const companyId = this.formContract.trusteeCompanyId
            const companyTitleId = this.customerContact?.customerCompanyId
            const taxRegistrationNumber = this.customerContact?.taxRegistrationNumber
            let invoice = {
                billingUnitId: '1',//开票单位
                invoiceTitleId: '',
                invoiceAmount: 0,
                invoiceType: '',
                invoiceContent: '',
                remark: '',
            }
            if (companyId) {
                invoice.billingUnitId = companyId
            }
            if (companyTitleId) {
                invoice.invoiceTitleId = companyTitleId
            }
            if (taxRegistrationNumber) {
                invoice.taxRegistrationNumber = taxRegistrationNumber
            }
            this.formRecord.invoiceInfos.push(invoice)
        },
        querySearch(queryString, cb) {
            const results = queryString ? this.ContactOptions.filter(item => item.contactName.toLowerCase().includes(queryString.toLowerCase())) : this.ContactOptions;
            const modifiedItems = results.map(item => {
                if (item.contactName) {
                    return {
                        ...item,
                        value: item.contactName,
                        contactName: undefined
                    };
                }
                return item;
            });
            cb(modifiedItems);
        },
        handleSelect(item) {
            this.formMail.recipientPhone = item.phone
            this.formMail.recipientAddress = item.address
        },
        checkNum,
        checkUser() {
            if (this.DrafterOptions.some(item => item.uuid === this.userData['personUuids'][0])) {
                this.formContract.salesId = this.userData['personUuids'][0];
                this.formRecord.applicantId = this.userData['personUuids'][0]
            }
        },
        getContactOptions(uuid) {
            try {
                getUserById(uuid).then(res => {
                    if (res.code === 200) {
                        this.ContactOptions = res.data
                    }
                }).catch(err => { })
            } catch (error) {
                console.log(error);
                this.$messageUi.error('获取收件人信息失败');
            }
        },
        handleExceed(files) {
            this.$messageUi.error('上传文件数量超过5个，请检查');
        },
        handleRemove(files, type) {
            switch (type) {
                case 'record':
                    this.formRecord.invoiceRecordFile = null;
                    this.recordFileList = []
                    this.recordFileName = ''
                    break
                case 'senior':
                    this.formContract.seniorAnalysisFile = null; // 更新已选择的文件
                    this.seniorFileList = []
                    this.seniorFileName = ''
                    break
                case 'customized':
                    this.formContract.customizedAnalysisFile = null; // 更新已选择的文件
                    this.customizedFileList = []
                    this.customizedFileName = ''
                    break
                case 'contract':
                    this.formContract.contractFilePath = null;
                    this.contractFileList = []
                    this.contractFileName = ''
                    break
                case 'report':
                    this.formMail.reportFile.splice(files, 1)
                    this.reportFileList.splice(files, 1)
                    this.reportFileName = ''
                    if (this.reportFileList.length <= 0) {
                        this.formMail.mailingContent.numberOfReport = 0
                        this.formMail.mailingContent.reportScanningFlag = false
                    }
                    break
                case 'mail':
                    this.formMail.mailAttachment.splice(files, 1)
                    this.mailFileList.splice(files, 1)
                    this.mailFileName = ''
                    if (this.mailFileList.length <= 0) {
                        this.formMail.mailingContent.numberOfSingleMailFile = 0
                    }
                    break
                case 'reimbursement':
                    this.formMail.reimbursementFile.splice(files, 1)
                    this.reimbursementFileList.splice(files, 1)
                    this.reimbursementFileName = ''
                    if (this.reimbursementFileList.length <= 0) {
                        this.formMail.mailingContent.numberOfReimbursementFile = 0
                        this.formMail.mailingContent.reimbursementScanningFlag = false
                    }
                    break
                default:
                    break
            }
        },
        handleFileSelect(event, type, isMultiple = false) {
            const files = Array.from(event.target.files);
            if (!files.length) return;
            const fileObj = (f) => ({ name: f.name, raw: f });
            switch (type) {
                case 'record':
                    this.formRecord.invoiceRecordFile = fileObj(files[0]);
                    this.recordFileList = [fileObj(files[0])];
                    this.recordFileName = files[0].name;
                    break;
                case 'senior':
                    this.formContract.seniorAnalysisFile = fileObj(files[0]);
                    this.seniorFileList = [fileObj(files[0])];
                    this.seniorFileName = files[0].name;
                    break;
                case 'customized':
                    this.formContract.customizedAnalysisFile = fileObj(files[0]);
                    this.customizedFileList = [fileObj(files[0])];
                    this.customizedFileName = files[0].name;
                    break;
                case 'contract':
                    this.formContract.contractFilePath = fileObj(files[0]);
                    this.contractFileList = [fileObj(files[0])];
                    this.contractFileName = files[0].name;
                    this.contractGenerationFlag = false;
                    break;
                case 'price':
                    this.formContract.priceFile = fileObj(files[0]);
                    this.priceFileList = [fileObj(files[0])];
                    this.priceFileName = files[0].name;
                    break;
                case 'report': {
                    const newFiles = files.map(f => fileObj(f));
                    this.formMail.reportFile = [...this.formMail.reportFile, ...newFiles];
                    this.reportFileList = [...this.reportFileList, ...newFiles];
                    if (this.formMail.mailingContent.numberOfReport === 0) {
                        this.formMail.mailingContent.numberOfReport = 1;
                    }
                    break;
                }
                case 'mail': {
                    const newFiles = files.map(f => fileObj(f));
                    this.formMail.mailAttachment = [...this.formMail.mailAttachment, ...newFiles];
                    this.mailFileList = [...this.mailFileList, ...newFiles];
                    if (this.formMail.mailingContent.numberOfSingleMailFile === 0) {
                        this.formMail.mailingContent.numberOfSingleMailFile = 1;
                    }
                    break;
                }
                case 'reimbursement': {
                    const newFiles = files.map(f => fileObj(f));
                    this.formMail.reimbursementFile = [...this.formMail.reimbursementFile, ...newFiles];
                    this.reimbursementFileList = [...this.reimbursementFileList, ...newFiles];
                    if (this.formMail.mailingContent.numberOfReimbursementFile === 0) {
                        this.formMail.mailingContent.numberOfReimbursementFile = 1;
                    }
                    break;
                }
                default:
                    break;
            }
            // 重置 input value，允许再次选择同名文件
            event.target.value = '';
        },
        handleProjectAnnexFileSelect(event, project) {
            const files = Array.from(event.target.files);
            if (!files.length || !project.projectMainTypeId) return;
            this.$set(
                this.formContract.projectAnnexFiles,
                project.projectMainTypeId,
                { name: files[0].name, file: files[0] }
            );

            // 触发项目附件表单验证
            this.$nextTick(() => {
                if (this.$refs.formContract && this.$refs.formContract.validateField) {
                    this.$refs.formContract.validateField('projectAnnexFiles', () => { });
                }
            });

            console.log(this.formContract.projectAnnexFiles);
            event.target.value = '';
        },

        generateCode(type) {
            if (type) {
                getContractNumber(type).then(res => {
                    if (res.code === 200) {
                        this.formContract.contractNumber = res.data
                    }
                }).catch(err => {
                })
            } else {
                this.$messageUi.error('未选择合同分类');
            }
        },
        getCurrentDate(data) {
            const date = new Date();
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从 0 开始, September == 8
            const day = date.getDate().toString().padStart(2, '0'); // 日期
            if (data === 'sign') {
                return `${year}-${month}-${day}`
            } else {
                return `${year}${month}${day}`
            }
        },

        getUserOption(salesId) {
            try {
                getUserById(salesId).then(res => {
                    if (res.code === 200) {
                        this.UserOptions = res.data;
                    }
                }).catch(err => { })
            } catch (error) {
                console.log(error);
                this.$messageUi.error('获取客户信息失败');
            }
        },
        getDrafterOption() {
            try {
                if (['ADMIN', 'MANAGER', 'SALES_ASSI_MANAGER', 'SALES_ASSI'].includes(this.role)) {
                    getPersonByType('SALES', {}).then(res => {
                        if (res.code === 200) {
                            this.DrafterOptions = res.data;
                        }
                    }).catch(err => { })
                } else {
                    getPersonById(this.userData['personUuids'][0], {}).then(res => {
                        if (res.code === 200) {
                            this.DrafterOptions = res.data;
                            this.checkUser();
                        }
                    }).catch(err => { })
                }
            } catch (error) {
                console.log(error);
                this.$messageUi.error('获取人员信息失败');
            }
        },
        cancel() {
            this.$emit('submit', 'cancel')
        },
        handleDraft() {
            this.loading = true
            const formData = new FormData();
            if (this.formContract.contractFilePath) {
                formData.append('contractFile', this.contractFileList[0].raw); // 文件
            }
            if (this.formContract.priceFile) {
                formData.append('priceFile', this.priceFileList[0].raw); // 文件
            }
            if (this.formMail.mailAttachment.length > 0) {
                for (let file of this.formMail.mailAttachment) {
                    formData.append('mailFile', file.raw);
                }
            }

            if (this.formContract.customizedAnalysisFile) {
                formData.append('customizedAnalysisFile', this.formContract.customizedAnalysisFile.raw); // 文件
            }
            if (this.formContract.seniorAnalysisFile) {
                formData.append('seniorAnalysisFile', this.formContract.seniorAnalysisFile.raw); // 文件
            }
            if (this.formRecord.invoiceRecordFile) {
                formData.append('invoiceFile', this.formRecord.invoiceRecordFile.raw); // 文件
            }
            if (this.formMail.reportFile.length > 0) {
                for (let file of this.formMail.reportFile) {
                    formData.append('reportFile', file.raw);
                }
            }
            if (this.formMail.reimbursementFile.length > 0) {
                for (let file of this.formMail.reimbursementFile) {
                    formData.append('reimbursementFile', file.raw);
                }
            }
            if (Object.keys(this.formContract.projectAnnexFiles || {}).length > 0) {
                for (const [key, value] of Object.entries(this.formContract.projectAnnexFiles)) {
                    if (this.formContract.specificProjectType.some(item => item.projectMainTypeId === key) && value.file) {
                        formData.append(`projectAnnexFiles[${key}]`, value.file);
                    }
                }
            }
            const form = {
                isRecord: this.isRecord,
                isMail: this.isMail,
                contract: Object.keys(this.formContract).reduce((acc, key) => {
                    if (!['contractFilePath', 'customizedAnalysisFile', 'seniorAnalysisFile','priceFile','projectAnnexFiles'].includes(key)) {
                        acc[key] = this.formContract[key];
                    }
                    return acc;
                }, {}),
                record: Object.keys(this.formRecord).reduce((acc, key) => {
                    if (!['invoiceRecordFile'].includes(key)) {
                        acc[key] = this.formRecord[key];
                    }
                    return acc;
                }, {}),
                mail: Object.keys(this.formMail).reduce((acc, key) => {
                    if (!['mailAttachment', 'reportFile', 'reimbursementFile'].includes(key)) {
                        acc[key] = this.formMail[key];
                    }
                    return acc;
                }, {})
            }
            this.form.draftContent = JSON.stringify(form)

            // for (const key in this.form) {
            //   if (this.form.hasOwnProperty(key)) {
            //     formData.append(key, this.form[key]);
            //   }
            // }
            const jsonStr = JSON.stringify(this.form);
            const blob = new Blob([jsonStr], {
                type: 'application/json'
            });
            formData.append("info", blob);
            // 请求方法
            const ApiMethod = this.operation === 'edit' ? editDraft : addDraft
            const successMessage = this.operation === 'edit' ? '修改草稿成功' : '添加草稿成功'
            ApiMethod(formData).then(res => {
                this.loading = false
                if (res.code === 200) {
                    this.$emit('submit', 'con')
                    this.$messageUi.success(successMessage)
                }
            }).catch(err => {
                this.loading = false
            })
        },
        // 复制
        copyData(text) {
            copyText(text)
            this.$messageUi.success('复制成功')
        }
    },
}
</script>

<style lang="scss" scoped>
.global-block-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 10050;
    /* 确保覆盖在所有内容之上 */
    background: rgba(0, 0, 0, 0.35);
    /* 半透明遮罩 */
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: all;
    /* 拦截所有指针事件，阻止下层交互 */
}

/* 中心盒子样式（可按需调整） */
.global-block-overlay .overlay-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 18px 24px;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0);
    /* 使用透明背景，文字/图标为白色 */
    color: #fff;
}

/* 使用 Element 的 loading 图标（el-icon-loading）并放大 */
.overlay-spinner {
    font-size: 40px;
    color: #fff;
}

/* 文字说明 */
.overlay-text {
    margin-top: 10px;
    font-size: 16px;
    color: #fff;
}


.upload-demo {

    /*margin-top: 20px;*/
    width: 100% !important;
}


@import "@/assets/css/mixins.scss";

.el-dialog-div {
    @include thin-scrollbar(8px, #888);
    max-height: 60vh;
    /* 你还可以在这个类里写其他样式 */
    background: #fff;
}


.invoice-box {
    border: 1px dashed #ccc;
    /* 虚线框 */
    padding: 20px 20px 0 0;
    margin-bottom: 10px;
}

.bold-text {
    font-weight: bold;
    color: red;
    background-color: yellow;
    font-size: 16px;
}

.checkbox-group {
    display: flex;
    flex-wrap: nowrap;
    /* 禁止换行 */
}

/* 使 <el-row> 的高度贴合内部组件 */
.fit-height-row {
    margin: 0 0 0 0;
    display: flex;
    /* 使用 flex 布局 */
    align-items: stretch;
    /* 使子元素的高度自动拉伸 */
    flex-wrap: nowrap;
    /* 防止换行 */
}

.formDiv {
    display: flex;
    flex-wrap: wrap;
}

.el-form-item {
    width: 48% !important;
}

:deep(.el-select) {
    width: 100%;
}

.el-form-item__label {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex: 1;
}

.no-border-select :deep(.el-input__inner) {
    border: none;
    box-shadow: none;
    background: transparent;
    /* 背景透明，与表格融合 */
}

.no-border-select :deep(.el-textarea__inner) {
    border: none;
    box-shadow: none;
    background: transparent;
    /* 背景透明，与表格融合 */
}

 :deep(.el-input.is-disabled .el-input__icon) {
    display: none;
    background-color: #ffffff!important;
}


.custom-style {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 0 0 0;
    /* 默认不显示上边框 */

}

.disabled-state {
    cursor: not-allowed !important;
    /* 鼠标显示为不可交互状态 */
    filter: grayscale(100%) !important;
    /* 设置为灰色 */
}

.disabled-state :deep(*) {
    pointer-events: none !important;
    cursor: not-allowed !important;
    /* 禁用元素及其子元素的交互 */
}

.first-item {
    border-top: 1px dashed #d9d9d9;
    /* 第一个元素显示上边框 */
}
.mask-layer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;

    cursor: not-allowed;
    /* 禁用光标 */
    display: flex;
    align-items: center;
    justify-content: center;
    /*
       防御性编程：
       确保鼠标事件只在这个遮罩层触发，防止子元素干扰
    */
    pointer-events: auto;
}
.mask-layer-text {
    color: #F56C6C;
    font-size: 14px;
    font-weight: bold;
    user-select: none;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.2s ease;
}
.mask-layer:hover .mask-layer-text {
    opacity: 1;
}

/* 理化性质列表 - 使验证错误信息参与文档流，自动将下方下载链接推开 */
.project-annex-wrapper :deep(.el-form-item__error) {
    position: relative;
    top: 0;
    padding-top: 6px;
}
</style>